import gql from 'graphql-tag'

export const SIGNUP_MUTATION = gql`
mutation SignupMutation($fname: String!, $middle_name: String $lname: String!,$username: String!,$phone: String, $email: String!, $password: String!, $param:String,
$details:String,$validity:String!
# ,$code:String,$location:String!,$isLocationCode:Boolean
) {

  register(input: {
    fname:$fname,
    lname:$lname,
    middle_name:$middle_name,
    username:$username,
    phone:$phone,
    email: $email,
    password: $password,
    param:$param
    details:$details
    validity:$validity
    # code:$code
    # location:$location
    # isLocationCode:$isLocationCode

  }) {
    status
    pin_time
      user{
        email
        fname
        lname

      }
  }
}`
export const ME_DATA = gql` query CurrentUsersQuery {
  me {
    id
      fname
      lname
      avatar
   roles{
       id
       name
     permissions{
       id
       name
     }
   }
  }
}
`
export const ME_USER_DATA = gql` query CurrentUsersQuery {
  me {
    id
  }
}
`

export const LOGIN_MUTATION = gql`
mutation LoginMutation($email: String!, $password: String! ,$device:String) {
  login(input: {
    username:$email,
    password: $password,
    device:$device
  }) {
    status
    access_token
    refresh_token
    expires_in
    token_type
    session_id
    firebase_token
  
    user {
      id
      fname
      lname
      email_confirmed
      email
      phone
      phone_verified
      status
      pending
      avatar
      locations{
        id
      }
      roles {
        id
        name
        permissions{
        id
        name
         }
        }

    }
  }
}`
export const ALL_ROLES_QUERY = gql`query AllUsersQuery {
  roles {
    id
    name
  }
}
`
export const LOGOUT = gql`
mutation logout($session_id: String) {
  logout(
    session_id:$session_id,
   ) {
    status
  }
}`

export const VERIFY_EMAIL = gql`
mutation verifyEmailQuery($token: Int!,$pin_created_at: String) {
  verifyEmail(input: {
    token:$token,
    pin_created_at:$pin_created_at,
  }) {
    user{
      fname
      email_confirmed
      status
    }
    error
    status
    message
  }
}`
export const VERIFY_INVITED_USER_EMAIL = gql`mutation verifyInvitedUserEmail($token: Int!,$pin_created_at: String) {
  verifyInvitedUserEmail(input: {
    token:$token,
    pin_created_at:$pin_created_at,
  }) {
    user{
      id
      email_confirmed
      username
    }
    error
    status
    access_token
  }
}`
export const RESEND_TOKEN_EMAIL = gql` 
mutation resendEmailQuery($email: String!) {
  resendTokenEmail(input: {
    email:$email,
  }) {
    user{

      fname
      email_confirmed

    }
    pin_time
    error
    status
  }
}`
export const RESEND_INVITED_USER_EMAIL = gql` 
mutation resendEmailQuery($email: String!) {
  resendInvitedUserEmail( 
    email:$email,
   ) {
    user{

      fname
      email_confirmed

    }
    pin_time
    error
    status
  }
}`
export const PASSWORD_RESET_EMAIL = gql`
mutation forgotPassword($email: String!) {
  forgotPassword(input: {
    email:$email,
  }) {
    status
    message
  }
}`
export const PASSWORD_UPDATE_BY_EMAIL = gql`mutation
updateForgottenPassword(
  $token: String!,
  $password: String!,
  $password_confirmation: String!
 ){
  updateForgottenPassword(
    input:
    {
      token:$token,
      password:$password,
      password_confirmation:$password_confirmation,
    })
  {
    status
    message
  }
}`


export const REMOVE_PROGRAM = gql`
mutation($id:ID!) {
  deleteProgram(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const CREATE_PROGRAM = gql`
mutation
  createProgram($name: String!, $location_id:String! , $color_code:String , $group:ID){
    createProgram (input: {
    name: $name,
    color_code:$color_code
    location_id: $location_id
    group: $group
  }) {
    status
    message
    color
  }
}
`
export const UPDATE_PROGRAM = gql`
mutation
  updateProgram($id: ID!,$name: String!, $location_id:String! , $color_code:String , $group:ID){
    updateProgram (id:$id , input: {
    name: $name,
    color_code:$color_code
    location_id: $location_id
    group: $group
  }) {
    status
    message
    color
  }
}
`
export const CAMERA_REPORT_MUTATION = gql`
mutation createCameraWatchTimeReport($camera_id: Int!,$location_id:ID!,$code:String) {
  createCameraWatchTimeReport(input: {
    camera_id:$camera_id,
    location_id:$location_id,
    code:$code,
  }) {
    status
    is_counter
    limit_over
  }
}`

export const GET_CAMERA_DETAILS = gql`
  query ($id:ID!){
    getCameraDetail(id:$id) {
       id
       name
       code
    }
  }
`

export const GET_REPORT_CAMERAS_LIST = gql`query AllCamerasQuery {
  cameras {
    id
    name
  }
}
`
 
export const CREATE_CAMERA = gql`
  mutation
  createCamera($name: String!,$code: String! ,$color_code: String!,$camera_id:String,$status:Boolean, $location_id:String!){
    createCamera (input: {
      name: $name,
      code:$code,
      color_code:$color_code,
      camera_id:$camera_id,
      location_id: $location_id,
      status:$status
    }) {
      id
      name
      location_id
      location{
        id
        name
      }
    }
  }
`
export const SAVE_APP_SETTING = gql`
  mutation
  saveAppSettings($key: String!,$value: String){
    saveAppSettings (input: {
      key: $key,
      value: $value,

    }) {
      status
    }
  }
`
export const CREATE_LOCATION_CAMERA = gql`
mutation
  createLocationCamera($location_id:String! , $camera_id: String!){
    createLocationCamera (input: {
    location_id: $location_id,
    camera_id: $camera_id,
  }) {
    id
    }
    }
`
export const ALL_MANAGERS_QUERY = gql`query AllManagersQuery {
  getManagersList(
    name:"manager"
  ) {
    name
    users{
      id
      fname
      lname
      nick_name
      middle_name
      username
      avatar
      job_title
      email
      phone
      email_confirmed
      status
      managerlocations{
        id
        name
      }
    }
  }
#  users {
#    id
#    fname
#    lname
#    nick_name
#    username
#    phone
#    email
#    email_confirmed
#    status
#    avatar
#    locations
#    {
#      id
#      name
#    }
#  }
}
`
export const REMOVE_CAMERA = gql`
  mutation($id:ID!,$schedule_id:ID) {
    deleteCamera(
      id: $id
      schedule_id:$schedule_id
    )
    {
      message
      status
      color
    }
  }
`
export const UPDATE_CAMERA = gql`
  mutation
  updateCamera($id: ID!,$name: String!,$code: String ,$color_code: String,$camera_id:String, $location_id:String!, $status: Boolean, $schedule_id: String){
    updateCamera (id:$id , input: {
      name: $name,
      code:$code,
      color_code:$color_code,
      camera_id:$camera_id,
      location_id: $location_id,
      schedule_id:$schedule_id,
      status:$status
    }) {
      id
      name
      location_id
      location{
        id
        name
      }
    }
  }
`
export const ALL_LOCATIONS = gql`
query AllLocationsQuery {
  locations {
    id
    name
    timezone{
      id
      name
      value
    }
    email
    phone
    longitude
    latitude
    address
    pin_url
    map_url
    is_signup
    color_code
    signup_code
    billing
    active
    managers{
      id
      fname
      lname
      username
      email
      avatar
    }
    cameras{
      id
      name
      code
      color_code
      camera_id
    }
    camera_setting{
        id
        key
        value
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
  }
}
`
export const ALL_MANGER_LOCATIONS = gql`query AllLocationQuery {
  allManagerLocations {
    id
    name
    timezone{
      id
      name
      value
    }
    email
    phone
    longitude
    latitude
    address
    pin_url
    managers{
      id
      fname
      lname
      username
      email
    }
    cameras{
      id
      name
      code
      color_code
      camera_id
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
  }
}
`
export const ALL_INCIDENTS = gql` 
query AllIncidentssQuery {
  Incidents {
    id
    name
    details
    status
    created_at
    center{
      id
      name
      url
      }
    incident_videos{
      id
      video
      date
      start_time
      end_time
      camera{
        id
        name
      }
    }
    location{
      id
      name
    }
    embed_code
  }
}
`

// export const CREATE_LOCATION = gql`
//   mutation
//   createLocation($name: String!,$schedule_id: String!){
//     createLocation (input: {
//       name: $name,
//       schedule_id:$schedule_id,
//     }) {
//       id
//       name
//       schedule_id
//     }
//   }
// `

export const CREATE_LOCATION = gql`
mutation
  createLocation(
  $name: String!,
  $timezone:String,
  $email:String
  $phone:String
  $longitude:String
  $latitude:String
  $address:String
  $pin_url:String
  $is_signup:Boolean
  $signup_code:String
  $cameras: CreateLocationCamerasRelation
  $managers: [ID!]!
  )
  {
    createLocation (input: {
    name:$name,
    timezone:$timezone,
    email:$email,
    phone:$phone,
    longitude:$longitude,
    latitude:$latitude,
    address:$address,
    pin_url:$pin_url,
    is_signup:$is_signup
    signup_code:$signup_code
    managers:{
        connect: $managers
      }
    cameras:$cameras
    }) {
      id
      name
      cameras{
        id
      }
    }
  }
`
export const UPDATE_LOCATION = gql`
  mutation
  updateLocation(
    $id: ID!,
    $schedule_changed:Boolean
    $name:String!,
    $email:String
    $phone:String
    $longitude:String
    $latitude:String
    $address:String
    $pin_url:String
    $map_url:String
    $color:String
    $timezone:String
    $schedule_id: ID
    $managers: [ID!]
  ){
    updateLocation (
      id:$id ,
      schedule_changed:$schedule_changed
      input: {
      name: $name,
      email:$email,
      phone:$phone,
      longitude:$longitude,
      latitude:$latitude,
      address:$address,
      pin_url:$pin_url,
      map_url:$map_url
      color:$color
      timezone:$timezone,
      schedule_id: $schedule_id,
      managers:$managers
     # managers:{
     #   sync: $managers
     # }
    }) {
      id
      name
    }
  }
`
export const REMOVE_LOCATION = gql`
  mutation($id:ID!,$schedule_id:ID!) {
    deleteLocation(
      id: $id
      schedule_id:$schedule_id
    )
    {
      message
      status
      color
    }
  }
`
export const CREATE_MANAGER = gql`
  mutation
  createManager(
    $fname: String,
    $lname: String,
    $middle_name: String,
    $nick_name: String,
    $username: String,
    $job: String,
    $phone: String,
    $avatar: String,
    $email: String,
    $email_confirmed: Boolean,
    $status: Boolean!,
    $locations:[Int!]!,
    $invite_email :Boolean,
    $password: String,
    $roles:[Int]

  ){
    createManager (input: {
      fname:$fname,
      lname:$lname,
      middle_name: $middle_name,
      nick_name:$nick_name,
      username:$username,
      job:$job,
      phone:$phone,
      avatar:$avatar,
      email:$email,
      email_confirmed:$email_confirmed,
      status:$status,
      locations:$locations
      invite_email:$invite_email
      password:$password
      roles:$roles

    }) {
      status
      user{
        id
      }
    }
  }
`
export const UPDATE_MANAGER = gql`
  mutation
  updateManager(
    $id:ID!,
    $fname: String,
    $lname: String,
    $nick_name: String,
    $middle_name: String,
    $username: String,
    $job: String,
    $phone: String,
    $email: String,
    $avatar: String,
    $status: Boolean!,
    $locations:[String!]!
    $roles:[Int]

  ){
    updateManager (
      id:$id,
      input: {
        fname:$fname,
        lname:$lname,
        nick_name:$nick_name,
        middle_name:$middle_name,
        username:$username,
        job:$job,
        phone:$phone,
        email:$email,
        avatar:$avatar
        status:$status,
        locations:$locations
        roles:$roles

      }) {
      status

    }
  }
`
export const UPDATE_MANAGER_EMAIL_STATUS = gql`
  mutation
  updateUser(
    $id:ID!,
    $email_confirmed: Boolean,

  ){
    updateUser (
      id:$id,
      input: {
        email_confirmed:$email_confirmed,

      }) {
      id
      email_confirmed
    }
  }
`
export const UPDATE_MANAGER_STATUS = gql`
  mutation
  updateUser(
    $id:ID!,
    $status: Boolean,

  ){
    updateUser (
      id:$id,
      input: {
        status:$status,

      }) {
      id
      status
    }
  }
`
export const UPDATE_MANAGER_PASSWORD = gql`
  mutation
  updateManagerUserPassword(
    $id:ID!,
    $password: String,

  ){
    updateManagerUserPassword (
      id:$id,
      input: {
        password:$password,

      }) {
     status

    }
  }`
export const UPDATE_INVITED_USER_PASSWORD = gql`
  mutation
  updateInvitedUserPassword(
    $token:Int,
    $pin_created_at:String,
    $password: String,
    $username: String

  ){
    updateInvitedUserPassword (
      input: {
        token:$token,
        pin_created_at:$pin_created_at,
        password:$password,
        username:$username

      }) {
      status
      message

    }
  }`
export const UPDATE_USER_PASSWORD = gql`
  mutation
  updateUserPassword(
    $id:ID!,
    $old_password: String,
    $password: String,

  ){
    updateUserPassword (
      id:$id,
      input: {
        old_password:$old_password,
        password:$password,
      }) {
      status
    }
  }
`
export const UPDATE_ROLE_USER_PASSWORD = gql`
  mutation
  updateRoleUserPassword(
    $id:ID!,
    $password: String,

  ){
    updateRoleUserPassword (
      id:$id,
      input: {
        password:$password,
      }) {
      status
    }
  }
`
export const UPDATE_ADMIN_USER_PASSWORD = gql`
  mutation
  updateAdminUserPassword(
    $id:ID!,
    $password: String,

  ){
    updateAdminUserPassword (
      id:$id,
      input: {
        password:$password,
      }) {
      status
    }
  }
`
 

export const ALL_USERS = gql`query AllUsersQuery {
  role(
    name:"user"
  ) {
  name
  users{
    id
    fname
    lname
    middle_name
    username
    email
    phone
    email_confirmed
    status
    pending
    invited
    emergency_contact
    avatar
    last_login_time
    locations{
        id
        name
        billing
      }
    students{
    id
    fname
    middle_name
    nick_name
    image
    dob
    lname
    cameras{
        id
        name
        code
        color_code
        camera_id
    }
    }
    schedule{
      id
      name
      scheduledates{
        id
        day
        start_time
        end_time
      }
    }

  }
  }
}
`

// export const GET_LOG_REPORT = gql`query AllUsersQuery {
//   getLogReport{
//     id
//     object_type
//     object_id
//     activity
//     created_at
//     updated_at
//     user{
//       id
//       fname
//       lname
//     }

//   }
// }
// `
export const GET_LOG_REPORT = gql`
  mutation($id:ID,$page:Int,$first:Int!) {
    getLogReport(
      id: $id,
      page:$page
      first:$first
    )
    { 
    data {
        id
        object_type
        object_id
        activity
        created_at
        updated_at
            user{
            id
            fname
            lname
            }
        }
      paginatorInfo {
        currentPage
        lastPage
        perPage
        total
      }
    }
  }
`

export const GET_LOG_REPORT_ALL_USER = gql`query AllUsersQuery {
  getLogReportAllUser
}
`
// export const GET_INVITED_LOG_REPORT = gql`query AllUsersQuery {
//   getInvitedLogReport{
//     id
//     type
//     status
//     message
//     receiver
//     created_at
//     invited_by{
//       fname
//       lname
//     }
//   }
// }
// `

export const GET_INVITED_LOG_REPORT = gql`
  mutation($search:String,$page:Int,$first:Int!) {
    getInvitedLogReport(
      search:$search
      page:$page
      first:$first
    )
    { 
    data {
      id
     type
     status
     message
     receiver
     created_at
     sender_name
     receiver_name
     invited_by {
        fname
        lname
     }
     sender {
        fname
        lname
     }

     receivedTo {
        fname
        lname
     }
        }
      paginatorInfo {
        currentPage
        lastPage
        perPage
        total
      }
    }
  }
`

export const GET_THEME_SETTING = gql`query getThemeSettingQuery {
  getThemeSetting{
    max_daily_login_feature
    theme_color
    set_title
    change_layout
    theme_mode
    collapse_sidebar
    app_logo
    login_page_image
    top_bar_title
    show_login_img
    show_room_ration_widget
    bucket_name
    bucket_url
  }
}
`
export const GET_IMAGE_SETTING = gql`query getImageSettingQuery {
  getImagesSetting{
    max_daily_login_feature
    theme_color
    set_title
    change_layout
    theme_mode
    collapse_sidebar
    app_logo
    login_page_image
    register_page_image
    verify_email_page_image
    forgot_password_page_image
    reset_password_page_image
    resend_token_page_image
    show_login_img
    theme_key_settings
    show_room_ration_widget

  }
}
`
 
export const ADMIN_ROLES_LIST = gql`query AllUsersQuery {
  getAdminRolesList{
    id
    name

  }
}
`
// export const CENTER_ROLES_LIST = gql`query AllUsersQuery {
//   getCenterRolesList{
//     id
//     name

//   }
// }
// `
// export const MANAGER_ROLES_LIST = gql`query AllUsersQuery {
//   getManagerRolesList{
//     id
//     name

//   }
// }
// `
export const CREATE_INVITE_USER = gql`
  mutation
  createInviteUser($fname: String! ,$middle_name: String,$lname:String!, $username: String! ,$email: String!,$phone: String,$phone2: String, $locations:[Int!]!,$pending: Boolean,$status: Boolean,$emergency_contact:Boolean,$email_confirmed: Boolean!,$avatar:String,  $invite_email:Boolean,
    $password:String,$phone_type:String,$phone_type2:String
    $roles: [ID!]! , $invite_type:String,){
    createInviteUser (input: {
      fname:$fname
      middle_name:$middle_name
      lname:$lname
      username:$username
      email:$email
      phone:$phone
      phone_type:$phone_type
      phone2:$phone2
      phone_type2:$phone_type2
      locations:$locations
      pending:$pending
      email_confirmed:$email_confirmed
      status:$status
      emergency_contact:$emergency_contact
      invite_email:$invite_email
      avatar:$avatar
      password:$password
      invite_type:$invite_type
      roles:{
      connect: $roles
      }
    }) {
      status
       user{
        id
        fname
        lname
        avatar
        locations{
          id
          name
          billing
        }

      }
    }
  }
`
export const CREATE_USER_ACTIVITY = gql`
  mutation
  createUserActivity($object_id: ID!,$object_type: String!,$activity: String!){
    createUserActivity (input: {
      object_id:$object_id
      object_type:$object_type
      activity:$activity

    }) {
      status

    }
  }
`
export const CREATE_USER = gql`
  mutation
  createUser($fname: String! ,$middle_name: String,$lname:String!, $username: String!,$email: String!,$phone: String,$pending: Boolean,$status: Boolean,$emergency_contact:Boolean,$email_confirmed: Boolean!,$avatar:String,
    $roles: [ID!]!){
    createUser (input: {
    fname:$fname
    middle_name:$middle_name
    lname:$lname
    username:$username
    email:$email
    phone:$phone
    pending:$pending
    email_confirmed:$email_confirmed
    status:$status
    emergency_contact:$emergency_contact
    avatar:$avatar
    roles:{
        connect: $roles
      }
  }) {
    id

    }
    }
`
export const CREATE_ADMIN = gql`
mutation
createAdmin(
  $fname: String! ,
  $middle_name: String,
  $lname:String!,
  $nick_name: String,
  $username: String!,
  $email: String!,
  $password: String,
  $phone: String,
  $status: Boolean!,
  $roles:[Int]
  $email_confirmed: Boolean!,
  $avatar:String,
  $job:String,
  $invite_email:Boolean
){
  createAdmin (input: {
    fname:$fname
    middle_name:$middle_name
    lname:$lname
    username:$username
    nick_name:$nick_name
    email:$email
    password:$password
    phone:$phone
    roles:$roles
    email_confirmed:$email_confirmed
    status:$status
    avatar:$avatar
    job:$job
    invite_email:$invite_email

  }) {
    status
    user{
      id
      fname
    }

    }
    }
`
export const UPDATE_ADMIN = gql`
  mutation
  updateAdmin(
    $id: ID!,
    $fname: String ,
    $middle_name: String,
    $lname:String,
    $username: String,
    $nick_name: String,
    $email: String,
    $phone: String,
    $status: Boolean,
    $roles:[Int]
    $avatar:String,
    $job:String,
    $schedule_id:String
  ){
    updateAdmin (id:$id ,
      input: {
        fname:$fname
        middle_name:$middle_name
        lname:$lname
        username:$username
        nick_name:$nick_name
        email:$email
        phone:$phone
        roles:$roles
        status:$status
        schedule_id:$schedule_id
        avatar:$avatar
        job:$job
      }) {
      status
      user{
        fname
      }

    }
  }
`
export const REMOVE_USER = gql`
mutation($id:ID!) {
  deleteUser(
    id: $id
  )
  {
  message
  status
  color
  }
}
`
export const UPDATE_USER = gql`
mutation
  updateUser($id: ID!,$fname: String ,$middle_name: String,$lname:String, $username: String,$email: String,$phone: String,$locations:[String!]!,$pending: Boolean,$status: Boolean,$emergency_contact: Boolean,$email_confirmed: Boolean,$avatar:String,$schedule_id:String){
    updateUser (id:$id ,
      input: {
    fname:$fname
    middle_name:$middle_name
    lname:$lname
    username:$username
    email:$email
    phone:$phone
    pending:$pending
    locations:$locations
    email_confirmed:$email_confirmed
    status:$status
    emergency_contact:$emergency_contact
    schedule_id:$schedule_id
    avatar:$avatar

  }) {
    status
    user{
      id
    }
  }
}
`
export const UPDATE_NEW_USER = gql`
mutation
  updateNewUser($id: ID!,$fname: String ,$middle_name: String,$lname:String, $username: String,$email: String,$phone: String,$phone2: String,$locations:[String!]!,$pending: Boolean,$status: Boolean,$avatar:String,$schedule_id:String,$phone_type:String,$phone_type2:String){
    updateNewUser (id:$id ,
      input: {
    fname:$fname
    middle_name:$middle_name
    lname:$lname
    username:$username
    email:$email
    phone:$phone
    phone2:$phone2
    phone_type:$phone_type
    phone_type2:$phone_type2
    pending:$pending
    locations:$locations
     status:$status
     schedule_id:$schedule_id
    avatar:$avatar

  }) {
    status
    user{
      id
    }
  }
}
`
export const UPDATE_USER_STATUS = gql`
mutation
updateUserStatus($id: ID!,$status: Boolean){
  updateUserStatus (id:$id ,
      input: {
    status:$status

  }) {
    status
  }
}
`
export const UPDATE_USER_ACTIVITY = gql`
mutation
updateUserActivity($object_id: ID!,$object_type: String!,$activity: String!){
  updateUserActivity (id:$object_id ,
      input: {
        object_id:$object_id
        object_type:$object_type
        activity:$activity
  }) {
      status
  }
}
`
export const RESET_USER_LOGINS = gql`
  mutation
  resetUserLogins($id: ID!){
    resetUserLogins (id:$id,)
    {
      status

    }
  }
`
export const UPDATE_USER_LOGINS = gql`
  mutation
  updateUserLogins($id: ID!,$max_logins:String){
    updateUserLogins (id:$id,
      input: {
        max_logins:$max_logins

      }) {

      status

    }
  }
`
export const UPDATE_CAMERA_SETTING = gql`
  mutation
  updateCameraSetting($id: ID!,$max_logins:String){
    updateCameraSetting (id:$id,
      input: {
        max_logins:$max_logins

      }) {

      status

    }
  }
`
export const UPDATE_STUDENT_SETTING = gql`
  mutation
  updateStudentSetting($id: ID!,$max_logins:String){
    updateStudentSetting (id:$id,
      input: {
        max_logins:$max_logins

      }) {

      status

    }
  }
`
export const UPDATE_LOCATION_SETTINGS = gql`
  mutation
  updateLocationSettings(
  $id: ID!,
  $max_no_of_students:String,
  $max_no_of_users:String,
  $max_logins:String,
  $time_out:String,
  $max_login_feature:Boolean,
  # $is_token_mismatch:Boolean,
  # $toke_email:String,
  $token_succes_msg:String,
  $token_fail_msg:String,
  # $is_signup_notification:Boolean,
 #  $signup_notification_email:String,
 #  $signup_notification_phone:String,
  $signup_status:Boolean,
  # $appNotification:Boolean,
 #  $emailNotification:Boolean,
 #  $smsNotification:Boolean,
  $defaultCameras:[ID],
  # $isSignupCode:Boolean
  $signup_pin_code_expiry:String
  $can_edit_student:Boolean
  $can_edit_fields:[String]
  $default_city:String
  $default_state:String
  $default_zip:String 
  #$check_in_qr_expire:String
  ){
    updateLocationSettings (id:$id,
      input: {
        max_no_of_students:$max_no_of_students
        max_no_of_users:$max_no_of_users
        max_logins:$max_logins
        time_out:$time_out
        max_login_feature:$max_login_feature
        # is_token_mismatch:$is_token_mismatch,
        # toke_email:$toke_email,
        token_succes_msg:$token_succes_msg,
        token_fail_msg:$token_fail_msg,
      #   is_signup_notification:$is_signup_notification,
      #   signup_notification_email:$signup_notification_email,
      #   signup_notification_phone:$signup_notification_phone,
        signup_status:$signup_status,
        signup_pin_code_expiry:$signup_pin_code_expiry,
      #   appNotification:$appNotification,
      #   emailNotification:$emailNotification,
       #  smsNotification:$smsNotification
        defaultCameras:$defaultCameras
        # isSignupCode:$isSignupCode
        can_edit_student:$can_edit_student
        can_edit_fields:$can_edit_fields
       # check_in_qr_expire:$check_in_qr_expire
        default_city:$default_city
        default_state:$default_state
        default_zip:$default_zip 

      }) {

      status

    }
  }
`
export const UPDATE_USER_PROFILE = gql`
  mutation
  updateUserProfile($id: ID!,$username: String,$fname: String, $lname:String,$middle_name: String, $nick_name: String,$phone: String,$avatar:String){
    updateUserProfile (id:$id , input: {
      username:$username
      fname:$fname
      lname:$lname
      middle_name:$middle_name
      nick_name:$nick_name
      phone:$phone
      avatar:$avatar
    }) {
     status
      user{
        fname
        lname
        avatar
      }

    }
  }
`
export const GET_USER_BY_ID = gql`
  query ($id:ID!){
    user(id:$id) {
      avatar
      fname
      lname
    }
  }
`
export const GET_USER_LOGIN_DETAILS = gql`
  query ($id:ID!){
    getUserSettingData(id:$id) {
      status
      daily_logins
      msg
    }
  }
`
export const GET_LOCATION_SETTING_DETAILS = gql`
  query ($id:ID!){
    getLocationSettingData(id:$id) {
      max_no_of_students
      max_no_of_users
      max_daily_logins
      user_time_out
      enable_max_login_feature
      # is_token_mismatch
      # toke_email
      token_succes_msg
      token_fail_msg
      is_signup_notification
      signup_notification_email
      signup_notification_phone
      signup_status
      appNotification
      emailNotification
      smsNotification
      status
      defaultCameras
      signup_pin_code_expiry
      can_edit_student
      can_edit_fields
      check_in_qr
      check_in_qr_expire
      default_city
      default_state
      default_zip


    }
  }
`
export const GET_INCIDENT_VIDEOS_DETAILS = gql`
  query ($id:ID!){
    getIncidentDetails(id:$id) {
      videos
      status

    }
  }
`
export const USER_LOG_DATA = gql`
  query ($id:ID!,$object_type:String){
    getUserLogData(id:$id,object_type:$object_type) {
      data{
        id
        object_type
        object_id
        user_id
        activity
        user{
          fname
          lname
        }
      }


    }
  }
`
export const GET_CAMERA_SETTING_DETAILS = gql`
  query ($id:ID!){
    getCameraSettingData(id:$id) {
      status
      daily_logins

    }
  }
`
export const GET_STUDENT_SETTING_DETAILS = gql`
  query ($id:ID!){
    getStudentSettingData(id:$id) {
      status
      daily_logins
      setting_id
      msg

    }
  }
`
export const GET_USER_PROFILE_DATA = gql`
  query ($id:ID!){
    user(id:$id) {
      id
      avatar
      fname
      lname
      middle_name
      nick_name
      username
      email
      phone
      email_confirmed
      pending
      status
      invited
      check_in_pin
    }
  }
`

export const SINGLE_USER = gql`
query ($id:ID!){
  user(id:$id) {
    id
    avatar
    fname
    lname
    middle_name
    username
    email
    phone
    email_confirmed
    status
    locations{
      id
      name
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
    students{
    id
    fname
    middle_name
    nick_name
    image
    dob
    lname
    status
    updated_at
    program{
        id
        name
    }
    location{
        id
        name
        billing
    }
    users{
        id
        fname
        lname
        middle_name
        email
    }
    cameras{
        id
        name
        color_code
        code
        camera_id
        location_setting{
        id
        name
        location_camera_setting{
          id
          key
          value
        }
       }
        schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
    location{
        id
        name
        schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
    }
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
    }
    }
  }
`
export const USER_PROFILE_DATA = gql`
query ($id:ID!){
  user(id:$id) {
    id
    avatar
    fname
    lname
    middle_name
    full_name
    username
    email
    phone
    phone2
    phone_type
    phone2_type
    email_confirmed
    status
    pending
    invited
    details
    last_login_time
    has_password
    logincounter{
      login_counter
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
    created_at
    updated_at

    locations{
      id
      name
      billing
      color_code
      timezone{
        id
        value
      }
    }
    active_students{
    id
    fname
    middle_name
    nick_name
    image
    dob
    lname
    status
    type
    updated_at
    location{
      id
      name
    }
    program{
      id
      name
    }
    sibling_group{
      id
      sibling_group_id
    }
    }
    }
  }
`
export const CHECK_REMAINING_LOGINS_SETTING = gql`
  mutation ($id:ID!){
  checkRemainingLogins(id:$id) {
    consumed_daily_logins
    total_max_allowed
    }
  }
`
export const SINGLE_USER_BY_EMAIL = gql`
query ($email:String){
  userByEmail(email:$email)
  }
`
export const CHECK_USER_EMAIL = gql`
  mutation (
  $id:ID!,
  $email:String
){
  checkUserEmail( input: {
  id:$id
  email:$email
  }) 
  }
`
export const CHECK_USER_NAME_EXCEPT_ID = gql`
  query (
  $id:ID!,
  $username:String
){
    checkUserNameExceptId( input: {
  id:$id
  username:$username

  }) 
  }
`
export const SINGLE_USER_BY_USERNAME = gql`
query ($username:String!){
  userByUserName(
    username:$username
  )
  }
`
 
export const CAMERAS_BY_MANAGER_LOCATION = gql`
query ($id:ID!){
  user(id:$id) {
    id
    fname
  managerlocations{
      id
      name
      cameras{
        id
        name
        code
        color_code
        camera_id
      }
      users{
        id
      }
      }
    }
}
`
export const STUDENTS_BY_MANAGER_LOCATION = gql`
query ($id:ID!){
  user(id:$id) {
    id
    fname
  managerlocations{
      id
      name
      students{
        id
    fname
    middle_name
    nick_name
    image
    dob
    lname
    status
    updated_at
    program{
        id
        name
    }
    location{
        id
        name
    }
    users{
        id
        fname
        lname
        middle_name
        email
    }
    cameras{
        id
        name
        code
        color_code
        camera_id
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }

      }
    }
  }
  }
`
export const ALL_STUDENTS = gql`query AllProgramsQuery {
  students{
    id
    fname
    middle_name
    nick_name
    image
    dob
    lname
    status
    updated_at
    program{
        id
        name
        color_code
    }
    location{
        id
        name
        billing
    }
    users{
        id
        fname
        lname
        middle_name
        email
    }
    cameras{
        id
        name
        code
        color_code
        camera_id
        location_setting{
        id
        name
        location_camera_setting{
          id
          key
          value
        }
        }
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
    }
}
`
export const CREATE_STUDENT = gql`
  mutation
  createStudent(
    $fname: String!
    $lname: String!
    $middle_name: String
    $nick_name: String
    $dob:String
    $image:String
    $status: Boolean
    $location_id:String!
    $program_id: String!
    $billing_program_id:ID
    $cameras: [ID!]!
    $users: [ID!]!
    $relation:String
    $other_rooms:[ID]
    $check_duplicate:Boolean
  ){
    createStudent (input: {
      fname:$fname,
      lname:$lname,
      middle_name:$middle_name,
      nick_name:$nick_name,
      dob:$dob,
      image:$image,
      status:$status,
      program_id:$program_id,
      billing_program_id:$billing_program_id
      location_id:$location_id
      cameras:$cameras
      users:$users
      relation:$relation
      other_rooms:$other_rooms
      check_duplicate:$check_duplicate
    }) {
      status
      message
      id
    }
  }
`
export const UPDATE_STUDENT = gql`
  mutation
  updateStudent(
    $id:ID!
    $fname: String
    $lname: String
    $middle_name: String
    $nick_name: String
    $dob:String
    $image:String
    $status: Boolean
    $location_id:String!
    $program_id: String
    $schedule_id: String
    $cameras: [ID!]
    $users: [ID!]
    $siblings: [ID!]
  ){
    updateStudent (
      id:$id,
      input: {
      fname:$fname,
      lname:$lname,
      middle_name:$middle_name,
      nick_name:$nick_name,
      dob:$dob,
      image:$image,
      status:$status,
      schedule_id:$schedule_id
      program_id:$program_id,
      location_id:$location_id
      cameras:$cameras
      users:$users
      siblings:$siblings

      # cameras:{
      #   sync: $cameras
      # }
      # users:{
      #   sync: $users
      # }
      # siblings:{
      #   sync: $siblings
      # }
    }) {
      status
      message
      id
    }
  }
`
export const REMOVE_STUDENT = gql`
mutation($id:ID!) {
  deleteStudent(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const UPDATE_STUDENT_STATUS = gql`
  mutation
  updateStudentStatus(
    $id:ID!
    $status: Boolean
  ){
    updateStudentStatus (
      id:$id,
      input: {
      status:$status,
    }) {
        id
        status      
    }
  }
`
export const SINGLE_STUDENT = gql`
query ($id:ID!){
  student(id:$id) {
    id
    fname
    middle_name
    lname
    full_name
    nick_name
    image
    dob
    status
    type
    gender 
    race 
    allergies {
      id 
      name
    }
    medications {
      id 
      name
    }
    doctor_name 
    doctor_phone 
    note
    ethnicity 
    street_1 
    street_2 
    city 
    state 
    country 
    zip
    enrollment_date
    graduation_date
    external_id
    week_schedule
    updated_at
    created_at
    tags{
     id
     name
    }
    billing_program{
        id
        name
        color_code
    }
    program{
        id
        name
        color_code
    }
    other_rooms{
      id
      name
      color_code
    }
    location{
        id
        name
        billing
        color_code
    }
    users{
        id
        fname
        lname
        middle_name
        email
        avatar
        phone
        phone_type
        phone2
        phone2_type
        username
        status
        email_confirmed
        pending
        invited
        check_in_pin
        pivot {
        emergency_contact
        alert
        black_list
        watch_camera
        relation
        legal_guardian
        pickup
        is_payer
      }
    }
    cameras{
        id
        name
        code
        color_code
        camera_id
        location{
        id
        name
        schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
    }
        schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
  }

}
`
export const CREATE_STUDENT_USER = gql`
  mutation
  createStudentUser(
    $fname: String ,
    $middle_name: String,
    $lname:String,
    $username: String,
    $email: String,
    $invite_email: String,
    $phone: String,
    $phone2: String,
    $phone_type:String,
    $phone_type2:String
    $status: Boolean,
    $pending: Boolean,
    $emergency_contact: Boolean,
    $email_confirmed: Boolean,
    $avatar:String,
    $student_id: ID,
    $location:ID!,
    $password:String,
    $relation:String,
    $invite_type:String,
    
  ){
    createStudentUser(input: {
      fname:$fname,
      middle_name:$middle_name,
      lname:$lname,
      username:$username,
      phone:$phone,
      phone_type:$phone_type
      phone2:$phone2
      phone_type2:$phone_type2
      email: $email,
      invite_email: $invite_email,
      status: $status,
      pending:$pending,
      email_confirmed: $email_confirmed,
      emergency_contact:$emergency_contact,
      avatar: $avatar,
      student_id: $student_id,
      location:$location,
      password:$password,
      relation:$relation,
      invite_type:$invite_type,
    }) {
      status
      user{
        id
        email
        fname
        lname
      }
    }
  }
`
export const UPDATE_STUDENT_USER = gql`
  mutation
  updateStudentUser(
    $id: ID,
    $fname: String ,
    $middle_name: String,
    $lname:String,
    $username: String,
    $email: String,
    $invite_email: String,
    $phone: String,
    $status: Boolean,
    $pending: Boolean,
    $emergency_contact: Boolean,
    $email_confirmed: Boolean,
    $avatar:String,
    $student_id: ID,
    $phone2: String,
    $phone_type:String,
    $phone_type2:String,
    $location:ID!

  ){
    updateStudentUser(input: {
      id:$id,
      fname:$fname,
      middle_name:$middle_name,
      lname:$lname,
      username:$username,
      phone:$phone
      phone_type:$phone_type
      phone2:$phone2
      phone_type2:$phone_type2
      email: $email,
      invite_email: $invite_email,
      status: $status,
      pending:$pending,
      email_confirmed: $email_confirmed,
      emergency_contact:$emergency_contact,
      avatar: $avatar,
      student_id: $student_id,
      location:$location
    }) {
      status
      user{
        fname
        lname
      }
    }
  }
`
export const ALL_SCHEDULE = gql`
query($status:Int!){
schedules(status:$status)
    {
    id
    name
    scheduledates{
        id
        day
        start_time
        end_time
    }
    }
}
`
export const REMOVE_SCHEDULE = gql`
mutation($id:ID!) {
  deleteSchedule(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const CREATE_SCHEDULE = gql`
mutation
  createSchedule($name: String! $status:Boolean, $scheduledates: CreateScheduleDatesRelation)
  {
    createSchedule (input: {
    name:$name,
    status:$status,
    scheduledates:$scheduledates
    }) {
      id
      scheduledates{
        id
      }
    }
  }
`
export const UPDATE_SCHEDULE = gql`
mutation
  updateSchedule($id: ID!,$name: String!, $status:Boolean, $scheduledates: UpdateScheduleDatesRelation)
  {
    updateSchedule(input: {
    id:$id,
    name:$name,
    status:$status,
    scheduledates:$scheduledates
    }) {
      id
      scheduledates{
        id
      }
    }
  }
`
export const UPLOAD_IMAGE = gql`
  mutation
  uploadImage(
    $image:String!
    $oldimage:String
  ){
    uploadImage (input: {
      image:$image,
      oldimage:$oldimage
    }) {

      status
      image_name
      error

    }
  }
`
export const UPLOAD_VIDEO = gql`
  mutation
  uploadVideo(
    $video:String
    $oldvideo:String
  ){
    uploadVideo (input: {
    video:$video,
      oldvideo:$oldvideo
    }) {

      status
      video_name
      error

    }
  }
`
export const DELETE_IMAGE = gql`
  mutation
  deleteImage(
    $image:String!
  ){
    deleteImage (input: {
      image:$image,
    })
  }
`
export const CREATE_LOGIN_COUNTER = gql`
mutation
  createLoginCounter($user_id: ID!){
  createLoginCounter (input: {
      user_id:$user_id
  }) {
    id

    }
    }
`
export const GET_LOGIN_REPORT = gql`
mutation
getLoginReport($date: String!,$location:ID!){
  getLoginReport (input: {
      date:$date
      location:$location
  }) {
    status
    user{
      user_id
      date
      login_counter
      users{
      id
      fname
      lname
    }
    }
  }
    }
`
export const GET_LOGIN_DATE_REPORT = gql`
mutation
getLoginDateReport($fromDate: String!,$toDate: String!,$location:ID!){
  getLoginDateReport (input: {
    fromDate:$fromDate
    toDate:$toDate
    location:$location
  }) {
    status
    user{
      user_id
      date
      login_counter
      users{
      id
      fname
      lname
    }
    }
  }
    }
`
export const GET_LOGIN_WEEK_REPORT = gql`
mutation
getLoginWeekReport($date: String!,$location:ID!){
  getLoginWeekReport (input: {
      date:$date
      location:$location
  }) {
    status
    data{
      lables
      values
    }

  }
    }
`
export const WATCH_TIME_REPORT = gql`
mutation
watchTimeWeeklyReport($date: String!,$location:ID!){
  watchTimeWeeklyReport (input: {
      date:$date
      location:$location
  }) {
    status
    data{
      lables
      values
    }

  }
    }
`
export const WATCH_TIME_REPORT_BY_DATE = gql`
  query ($fromDate:String,$toDate:String,$location:ID!){
    watchTimeReportByDate(
    fromDate:$fromDate
    toDate:$toDate
    location:$location
    ) {
      status
      data{
        user_id
        minutes
        user{
          fname
          lname
        }
      }
    }
  }
`
export const WATCH_TIME_REPORT_BY_CAMERA = gql`
  query ($fromDate:String,$toDate:String,$camera_id:Int){
    watchTimeReportByCamera(
    fromDate:$fromDate
    toDate:$toDate
    camera_id:$camera_id
    ) {
      status
      data{
        user_id
        minutes
        user{
          fname
          lname
        }
      }
    }
  }
`
export const WATCH_TIME_MONTHLY_REPORT = gql` 
query watchTimeMonthlyReport($location:ID!) {
  watchTimeMonthlyReport(
    location:$location
   ){
    status
      data{
        user_id
        minutes
        user{
          fname
          lname
        }
      }

  }
}
`
export const USER_WATCH_TIME_WEEKLY = gql`
  mutation
  userWatchTimeWeekly(
    $id: ID
  ){
    userWatchTimeWeekly (
      id:$id
    ) {
      minutes
      camera_name
      camera_color
      date
    }
  }
`
export const GET_USER_LOGINS_REPORT = gql`
  mutation
  getUserLoginsReport(
    $id: ID
  ){
    getUserLoginsReport (
      id:$id
    ) {
      date
      login_counter
    }
  }
`

export const USER_DATE_LOGIN = gql`query AllFilterLoginsByDate {
  users{
    id
    fname
    lname
    todaylogin(date:"2020-11-19"){
      # todaylogin(date:String){
      user_id
    login_counter
    }
  }
}
`
export const ADD_SIBLING = gql`
  mutation
  addSibling(
    $student_id: ID!
    $sibling_id: ID!
  ){
    addSibling (input: {
      student_id:$student_id,
      sibling_id:$sibling_id,
    }) {
      student_id
      sibling_id
    }
  }
`

export const GET_SIBLING = gql`
mutation
getSiblings($id: ID!){
  getSiblings (input: {
      id:$id
  }) 
  {
      id
      fname
      lname
      image
      program{
        id
        name
      }
      }
  }
`
export const REMOVE_SIBLING = gql`
mutation
removeSiblings($student_id: ID!,$sibling_id: ID!){
  removeSiblings (input: {
    student_id:$student_id,
    sibling_id:$sibling_id,
  })
  {
      status
      message
      color
    }
  }
`
export const ADD_USER_TO_SIBLING = gql`
  mutation
  addUserToSibling(
    $student_id: ID!
    # $user_id: [ID]
  ){
    addUserToSibling (input: {
      student_id:$student_id,
      # user_id:$user_id,
    }) {
      status
      # user_id
    }
  }
`
export const UPDATE_USER_TO_SIBLING = gql`
  mutation
  updateUserToSibling(
    $student_id: ID!
    $users: [ID!]!
  ){
    updateUserToSibling (input: {
      student_id:$student_id,
      users:$users,
    }) {
      student_id
      users
    }
  }
`
export const ADD_LOGIN_TIME = gql`
mutation
addLoginTime($id: ID!){
  addLoginTime (input: {
      id:$id
  }) {
    status
    expire
    id
    roles{
       id
       name
     permissions{
       id
       name
     }
  }
  }
  }
`
export const ADD_RELOGIN_TIME = gql`
mutation
addReloginTime($id: ID!){
  addReloginTime (input: {
      id:$id
  }) {
     status
  }
  }
`
export const UPDATE_LOGIN_TIME = gql`
mutation
updateLoginTime($id: ID!){
  addLoginTime (input: {
      id:$id
  }) {
    id
  }
  }
`
export const PENDING_USER = gql`
query PendingUser {
  PendingUser{
    id
    name
    color_code
    location_user_count
  }
  }
`
 
export const GET_CAMERA_BY_LOCATION = gql`
  query ($location_id:ID!){
    location_cameras(location_id:$location_id) {
      id
      name
      code
      color_code
      camera_id
      location_id
    }
  }
`
export const GET_PROGRAM_BY_LOCATION = gql`
  query ($location_id:ID!){
    location_programs(location_id:$location_id) {
      id
      name
      location_id
      color_code
    }
  }
`
export const FILTER_ROOM_PLANS = gql`
  mutation ($location:ID!,$rooms:[ID],$from:String,$to:String){
    filterRoomPlans(location:$location,rooms:$rooms,from:$from,to:$to)
  }
`

export const GET_PROGRAM_BY_LOCATION_WITH_GROUP = gql`
  query ($location_id:ID!){
    location_programs(location_id:$location_id) {
      id
      name
      location_id
      camera_group{
       id
       name
       cameras{
         id
         name
         color_code
       }
      }
    }
  }
`
export const GET_GROUPS_BY_LOCATION = gql`
  query ($location_id:ID!){
    location_groups(location_id:$location_id) {
      id
      name
    }
  }
`
export const GET_SIBLING_BY_LOCATION = gql`
  query ($id:ID!){
    getSiblingByLocation(id:$id) {
     students{
      id
      fname
      lname
     }
    }
  }
`
export const MANAGER_PENDING_USER = gql`
  query ($id:ID!){
    getManagerPendingUser(
      id:$id
      )
    {
     # counter
     id
     name
     color_code
     location_user_count
    }
  }
`
export const USER_EMAIL_CONFIRMED = gql`
  mutation
  confirmUserEmail(
    $name: String,
    $user_ids:[Int]

  ){
    confirmUserEmail (input: {
      name:$name,
      user_ids:$user_ids
    }) {
      status
    }
  }
`
export const STUDENT_MULTI_ACTION = gql`
  mutation
  studentMultiAction(
    $name: String,
    $student_id:[ID]
  ){
    studentMultiAction (  
      name:$name,
      student_id:$student_id
      ) {
      status
    }
  }
`
export const CAMERA_COLOR = gql`
  mutation (
  $id:ID,
  $color:String
){
  checkCameraColor( input: {
  id:$id
  color:$color
  }){
    counter
  }
  }
`
export const PLAY_CAMERA = gql`
  mutation (
  $id:ID,
  $code:ID
  $location:ID!
){
  playCamera( input: {
  id:$id
  code:$code
  location:$location
  }){
    embed_code
    status
    message
  }
  }
`
export const REQUEST_INCIDENT = gql`
  mutation
  requestIncident(
    $name: String
    $details:String
    $status:String
    $location:String!
    $requested_by: String
    $times:[RequestIncidentTime]
  ){
    requestIncident (input: {
      name:$name,
      details:$details,
      status:$status,
      location:$location,
      requested_by:$requested_by,
      times:$times
    }) {
     status
      }
  }
`
export const UPDATE_INCIDENT = gql`
  mutation
  updateIncident(
    $id:ID
    $name: String
    $details:String
    $status:String
    $location:String!
    $times: [UpdateIncidentTime]
  ){
    updateIncident (
    id:$id,
    input: {
      name:$name,
      details:$details,
      status:$status
      location:$location,
      times:$times
    }) {
       status
       message
       color
      }
  }
`
export const UPDATE_INCIDENT_VIDEOS = gql`
  mutation
  updateIncidentVideos(
      $videos: [UpdateincidentvideosInput]
  ){
    updateIncidentVideos (input: {
    videos:$videos
    }) {
      status
      }
  }
`
export const MANAGER_INCIDENTS = gql`query ManagerIncidentssQuery {
  ManagerIncidents {
    incidents{
    id
    name
    details
    status
    created_at
    incident_videos{
      id
      video
      date
      start_time
      end_time
      camera{
        id
        name
      }
    }
    location{
      id
      name
    }
    embed_code
    }
    status

  }
}
`
export const REMOVE_INCIDENT = gql`
mutation($id:ID!) {
  deleteIncident(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const GET_SINGLE_INCIDENT = gql`
  mutation (
  $id:ID,
){
  getSingleIncident(id:$id){
      incidents
      status
    }
  }
`
export const DELETE_INCIDENT_VIDEOS = gql`
  mutation (
  $id:ID,
){
  deleteIncidentVideo( input: {
  id:$id
  }){
    status
  }
  }
`
export const SINGLE_LOCATION = gql`
query ($id:ID!){
  location(id:$id) {
    id
    name
    email
    phone
    longitude
    latitude
    pin_url
    map_url
    address
    is_signup
    signup_code
    color_code
    billing
    active
    location_billing_request{
      value
    }
    timezone{
      id
      name
      value
    }
    rooms{
      id
      name
    }
    groups{
    id
    name
    cameras{
        id
        name
        code
        color_code
    }
    }
    camera_setting{
        id
        key
        value
    }
    managers{
      id
      fname
      lname
      email
      username
    }
    cameras{
      id
    name
    code
    color_code
    camera_id
    room{
      id
      name
    }
    groups{
      id
      name
    }
    location_setting{
      id
      name
      location_camera_setting{
        id
        key
        value
      }
    }
    location_id
    status
    order
    location{
      name
      id
      schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }

    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }
  }
}
`
export const SINGLE_LOCATION_FOR_TABS = gql`
query ($id:ID!){
  location(id:$id) {
    id
    name
    email
    phone
    longitude
    latitude
    pin_url
    map_url
    address
    is_signup
    signup_code
    color_code
    billing
    active
    location_billing_request{
      value
    }
    timezone{
      id
      name
      value
    }
    groups{
    id
    name
    cameras{
        id
        name
        code
        color_code
    }
    }
     
    managers{
      id
      fname
      lname
      email
      avatar
    }
    cameras{
      id
      name
      schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }

    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }
  }
}
`
// export const SUGGEST_COLOR = gql`
// query SuggestColorQuery {
//   suggestcolors($id:ID!)
// }
// `
export const SUGGEST_COLOR = gql`
  query ($id:ID,$location:ID!){
    suggestcolors(
      id:$id
      location:$location
      )
    {
      colors
    }
  }
`
export const SUGGEST_PROGRAM_COLOR = gql`
  query ($id:ID){
    suggestProgramColors(
      id:$id
      )
    {
      colors
    }
  }
`
export const APPLLY_SCHEDULE_TO_CAMERAS = gql`
  mutation ($id:ID,$schedule_id:ID){
    applyScheduleToCameras(
      id:$id
      schedule_id:$schedule_id
    )
    {
      status
      message
      color
    }
  }
`
export const CREATE_CAMERA_With_SCHEDULE_IN_LOCATION = gql`
  mutation
  createCameraWithScheduleInLocation(
    $name: String!,
    $code: String!,
    $color_code: String!,
    $camera_id:String,
    $room_id:String,
    $status:Boolean,
    $groups:[ID]
    $location_id:String!,
    $schedule_name:String,
    $scheduledates: [CreateDatesInput]
  ){
    createCameraWithScheduleInLocation (input: {
      name: $name,
      code:$code,
      color_code:$color_code,
      camera_id:$camera_id,
      room_id:$room_id,
      location_id: $location_id,
      status:$status,
      groups:$groups
      schedule_name:$schedule_name,
      scheduledates:$scheduledates
    }) {
      status
      message
      color
    }
  }
`
export const UPDATE_CAMERA_With_SCHEDULE_IN_LOCATION = gql`
  mutation
  updateCameraWithScheduleInLocation(
    $id:ID!
    $name: String!,
    $code: String!,
    $color_code: String!,
    $camera_id:String,
    $room_id:String
    $groups:[ID]
    $status:Boolean,
    $location_id:String!,
    $schedule_name:String!,
    $scheduledates: [CreateDatesInput]
  ){
    updateCameraWithScheduleInLocation (input: {
      id:$id
      name: $name,
      code:$code,
      color_code:$color_code,
      camera_id:$camera_id,
      room_id:$room_id,
      groups:$groups,
      location_id: $location_id,
      status:$status,
      schedule_name:$schedule_name,
      scheduledates:$scheduledates
    }) {
      status
      message
      color
    }
  }
`
export const CREATE_STUDENT_SCHEDULE = gql`
  mutation
  createStudentSchedule(
    $id: ID!,
    $schedule_name:String!,
    $scheduledates: [CreateDatesInput]
  ){
    createStudentSchedule (input: {
      id: $id,
      schedule_name:$schedule_name,
      scheduledates:$scheduledates
    }) {
      status
      message
      color
    }
  }
`
export const CREATE_USER_SCHEDULE = gql`
  mutation
  createUserSchedule(
    $id: ID!,
    $schedule_name:String!,
    $scheduledates: [CreateDatesInput]
  ){
    createUserSchedule (input: {
      id: $id,
      schedule_name:$schedule_name,
      scheduledates:$scheduledates
    }) {
       status
       message
       color
    }
  }
`

export const UPDATE_SINGLE_INCIDENT_VIDEO = gql`
  mutation
  updateSingleIncidentVideo(
    $id:ID,
    $video: String,
    $original_name: String,
    $file_name: String,
    $date: String,
    $start_time: String,
    $end_time:String,
    $camera: String,
  ){
    updateSingleIncidentVideo (input: {
      id:$id,
      video: $video,
      original_name: $original_name,
      file_name: $file_name,
      date:$date,
      start_time:$start_time,
      end_time:$end_time,
      camera: $camera,
    }) {
      status
      message
      color
    }
  }

`
export const DELETE_INCIDENT_SINGLE_VIDEOS = gql`
  mutation (
  $id:ID,
  $file_name:String,
){
  deleteIncidentSingleVideo( input: {
  id:$id
  file_name:$file_name
  }){
    status
  }
  }
`
export const REMOVE_STUDENT_SCHEDULE = gql`
mutation($id:ID!,$schedule_id:ID!) {
  deleteStudentSchedule(
    id: $id
    schedule_id: $schedule_id
  )
  {
    message
    status
    color
  }
}
`
export const REMOVE_USER_SCHEDULE = gql`
mutation($id:ID!,$schedule_id:ID!) {
  deleteUserSchedule(
    id: $id
    schedule_id: $schedule_id
  )
  {
    message
    status
    color
  }
}
`
export const USER_BY_STUDENT_LOCATION = gql`
mutation($location_id:ID!,$filter:Boolean) {
  userByStudentLocation(
    location_id: $location_id
    filter: $filter
  )
  {
    status
    user{
      id
      fname
      lname
      email
    }
  }
}
`
export const MANAGER_LOCATION = gql`
query ($id:ID!){
  user(id:$id) {
    id
    fname
    managerlocations{
      id
      name
      billing
      color_code
    }
  }
}
`

export const REMOVE_STUDENT_SETTING = gql`
  mutation($id:ID!) {
    deleteStudentLoginLimitSetting(
      id: $id
    )
    {
      id
    }
  }
`
export const REMOVE_USER_SETTING = gql`
  mutation($id:ID!) {
    deleteUserLoginLimitSetting(
      id: $id
    )
    {
      status
    }
  }
`
export const ALL_TICKETS = gql`
mutation AllTiclets {
  tickets {
    id
    ticket_number
    name
    description
    created_at
    status
    {
      id
      name
      color
    }
    category
    {
      id
      name
      description
    }
    locations{
      location_id
      center_location_id
    }
    users{
      user_id
       setting{
        center_object_id
      }
    }
    students{
      student_id
       setting{
        center_object_id
      }
    }
    action_by
  }

}
`
export const ALL_TICKET_CATEGORIES = gql`
query AllTicketCategories {
  ticketCategories {
      id
      name
      description
    }
}
`
export const ALL_TICKET_STATUSES = gql`
query AllTicketStatuses {
  ticketStatuses {
      id
      name
      color
    }
}
`
export const CREATE_TICKET = gql`
mutation
  createTicket($name: String!, $description: String!,$status:String!,$category:String!,$created_by:String!,$files: [fileNameInput],$locations:[Ticket_Location],$students:[Ticket_Student],$users:[Ticket_User]){
    createTicket (input: {
    name: $name,
    description: $description
    status:$status
    category:$category
    created_by:$created_by
    files:$files
    locations:$locations
    students:$students
    users:$users
  }) {
    status
  }
}
`
export const UPDATE_TICKET = gql`
  mutation
  updateTicket($id:ID!,$name: String!, $description: String!,$status:String!,$category:String!,$updated_by:String!,$locations:[Ticket_Location],$students:[Ticket_Student],$users:[Ticket_User]){
    updateTicket (input: {
      id:$id
      name: $name,
      description: $description
      status:$status
      category:$category
      updated_by:$updated_by
      locations:$locations
      students:$students
      users:$users
    }) {
      status
    }
  }
`
export const REMOVE_TICKET = gql`
mutation($id:ID!) {
  deleteTicket(
    id: $id
  )
  {
    status
  }
}
`
export const GET_SINGLE_TICKET = gql`
mutation ($id:ID!){
ticket(id:$id) {
        id
        name
        ticket_number
        description
        created_at
        updated_at
        action_by
        created_by{
        id
        fname
        lname
        }
        attachment{
            id
            file_name
            orignal_name
            storage_link
          }
          status{
            id
            name
            color
          }
        locations{
         location_id
         center_location_id
         location{
         id
         name
         }
        }  
        users{
          user{
            id
            fname
            lname
          }
          user_id
          name
        }
        students{
          student_id
          name
          student{
            id
            fname
            lname
          }
        }
        category{
          id
          name
        }
        history{
          id
          summary
          description
          created_at
          action_by
          {
          id
          fname
          lname
          avatar
          }
          created_by{
          id
          fname
          lname
          avatar
          }
          attachment{
            id
            file_name
            orignal_name
            storage_link
            deleted_at
          }
        }
}
}
`
export const ADD_TICKET_COMMENT = gql`
  mutation
  addTicketComment($id:ID!,$comment: String!,$comment_by: String!,$files: [fileNameInput]){
    addTicketComment (input: {
      id:$id
      comment: $comment,
      comment_by: $comment_by
      files:$files
    }) {
      status
    }
  }
`
export const UPLOAD_FILE = gql`
  mutation
  uploadFile(
    $file:[Upload]
  ){
    uploadFile (file:$file) {
      status
      files{
        orignal
        new
        link
      }
    }
  }
`
export const UPLOAD_CSV = gql`
  mutation
  uploadCsv(
    $file:[Upload]
  ){
    uploadCsv (file:$file) {
      errors
      data{
        fname
        lname
        program
        Users
        {
          fname
          lname
          email
          phone
          check
          sms_notif
          email_notif
        }

      }

    }
  }
`
export const REMOVE_TICKET_ATTACHMENT = gql`
  mutation($id:ID!) {
    deleteTicketAttachment(
      id:$id
    )
    {
    status
  }
}
`
export const DOWNLOAD_TICKET_ATTACHMENT = gql`
mutation($file:String!) {
  downloadTicketAttachment(
    file: $file
  )
}
`
export const FILTER_TICKET_STATUSES = gql`
query FilterTicketStatuses {
  filterTicketStatuses {
    id
    name
    color
    }
}
`
export const ALL_MANAGERS = gql`query AllUsersQuery {
  role(
    name:"manager"
  ) {
  name
  users{
    id
    fname
    lname
    middle_name
    username
    email
    status
  }
}
}
`
export const ALL_TIMEZONES = gql`
query AllTimezone {
  allTimezone {
      id
      name
      value
    }
}
`
export const GENERATE_QR = gql`
  mutation
  generateQr(
    $link: String,
    $student_id:[ID]
    $location_id:ID!

  ){
    generateQr (
      link:$link,
      student_id:$student_id
      location_id:$location_id
    ) {
      status
      color
    }
  }
`
export const GENERATE_LOCATION_QR = gql`
  mutation
  generateLocationQr(
    $link: String,
    $location_id:ID!,
    $code: String,
    $reset:Boolean

  ){
    generateLocationQr (
      link:$link,
      location_id:$location_id
      code:$code
      reset:$reset
    ) {
      status
      color
    }
  }
`
export const CHECK_LOCATION = gql`
  mutation (
  $id:ID,
  $name:String!
){
  checkLocationName(
  id:$id
  name:$name
){
    counter
  }
  }
`
export const GET_UPCOMING_BIRTHDAY = gql` 
mutation(
$date:String!
) {
studentsBirthday (
 date:$date
)
{
    id
    fname
    lname
    image
    dob
    age
    day
 }
 }
`
export const ALL_ARCHIVE_STUDENT = gql`query AllProgramsQuery {
  ArchiveStudents{
    id
    fname
    middle_name
    nick_name
    image
    dob
    lname
    status
    updated_at
    program{
        id
        name
        color_code
    }
    location{
        id
        name
    }
    archiveUser{
        id
        fname
        lname
        middle_name
    }
    cameras{
        id
        name
        code
        color_code
    }

    }
}
`
export const RESTORE_STUDENT = gql`
mutation($id:ID!,$type:String!) {
  restoreStudent(
    id: $id
    type:$type
  )
  {
    message
    status
    color
  }
}
`
export const FORCE_DELETE_STUDENT = gql`
mutation($id:ID!) {
  forceDeleteStudent(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const FORCE_DELETE_ALL_STUDENT = gql`
mutation($id:[ID!]) {
  forceDeleteAllStudent(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const RESTORE_ALL_STUDENT = gql`
mutation($id:[ID!]) {
  restoreAllStudent(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const ALL_TICKET_CHART = gql`query AllTicketChart {
  TicketChart{
    total
    percent
    new
    opened
    waiting
    }
}
`
export const WEEK_TICKET_CHART = gql`query WeekTicketChart {
  WeekTicketChart{
    total
    percent
    new
    opened
    waiting
    }
}
`
export const FILTER_TICKET_CHART = gql`
mutation($filter:String) {
  FilterTicketChart(
    filter: $filter
  )
  {
    total
    percent
    new
    opened
    waiting
  }
}
`
export const TOTAL_COUNTER = gql`query AllTotalCounter {
  TotalCounter{
    invited
    pending
    students
    users
    locations
    managers
    }
}
`
export const CAMERA_CHART = gql`query GetCameraChart {
  CameraChart{
    name
    color
    count
    }
}
`
 
 
export const CREATE_LOCATION_ROOM = gql`
  mutation
  createlocationRoom(
    $name: String!,
    $location:ID!
  ){
     createlocationRoom (
      name:$name,
      location:$location,
    ) {
      status
      color
      message
    }
  }
`
export const UPDATE_LOCATION_ROOMS = gql`
  mutation
  updateLocationRoom(
    $id: ID!,
    $rooms: [ID!]
  ){
    updateLocationRoom (
      id:$id ,
      input: {
      rooms:{
        sync: $rooms
      }
    }) {
      id
    }
  }
`
export const GENERATE_SMS_STUDENT = gql`
  mutation
  generateSmsStudent(
    $student_id:[ID]
  ){
    generateSmsStudent (
      student_id:$student_id
    ) {
      students{
        id
        fname
        middle_name
        full_name
        lname
        image
        program{
          id
          name
        }
        location_id
      }
    }
  }
`
export const SEND_SMS_TO_USER = gql`
  mutation
  sendSmsToUser(
    $students: [SmsStudentUser],
  ){
    sendSmsToUser (
      students:$students
      ) {
      status
      message
      color
      }
  }
`
export const SAVE_BOARDING_DATA = gql`
  mutation
  saveBoardingData(
    $students: [BoardingStudentUserInput],
    $location:ID!
  ){
    saveBoardingData (
      students:$students,
      location:$location
      ) {
      status
      message
      color
      }
  }
`
export const UPDATE_SMS_INVITED_USER_PASSWORD = gql`
  mutation
  updateSmsInvitedUserPassword(
    $token:Int,
    $pin_url:String,
    $password: String,
    $username: String
    $email:String

  ){
    updateSmsInvitedUserPassword (
      input: {
        token:$token,
        pin_url:$pin_url,
        password:$password,
        username:$username,
        email:$email

      }) {
      status
      message

    }
  }
  `
 
export const ADD_ONBOARDING_STUDENTS = gql`
  mutation
  addOnboardingStudents(
    $studentsData: [OnBoardingStudentsInputs],
  ){
    addOnboardingStudents (
      studentsData:$studentsData
      ) {
      status

      }
  }
`

export const VERIFY_INVITED_USER_PHONE = gql`mutation verifyInvitedUserPhone($token: Int!,$pin_url: String) {
  verifyInvitedUserPhone(input: {
    token:$token,
    pin_url:$pin_url,
  }) {
    user{
      email_confirmed
      email
    }
    error
    status
    access_token
  }
}`

export const ROOM_BY_LOCATION = gql`
  mutation
  roomsByLocation(
    $location:ID!
  ){
    roomsByLocation (
      location:$location
    ) {

        id
        name
      }
    }
`
export const ADD_SCHOOL = gql`
  mutation
  addSchool(
    $school:SchoolInput,
    $location:ID!,
  ){
    addSchool (
      school:$school
      location:$location
      ) {
      status
      message
      color
      }
  }
`
export const REMOVE_LOCATION_ROOM = gql`
  mutation($room_id:ID!) {
    deleteLocationRoom(
      room_id: $room_id
    )
    {
      message
      status
      color
    }
  }
`
export const REMOVE_LOCATION_GROUP = gql`
  mutation($group_id:ID!) {
    deleteLocationGroup(
      group_id: $group_id
    )
    {
      message
      status
      color
    }
  }
`
export const UPDATE_LOCATION_GROUP_NAME = gql`
  mutation($id:ID!,$name:String) {
    updateLocationGroupName(
      id: $id
      name: $name
    )
    {
      message
      status
      color
    }
  }
`
export const GET_SCHOOL_PROFILE = gql`
query getSchoolProfile($location:ID!){
  getSchoolProfile(location:$location){
    school_name
    school_phone
    school_website
    school_city
    school_state
    school_zip
    school_country
    school_timezone
    school_capacity
    school_address1
    school_address2
    school_logo

  }
}
`
export const CREATE_ANNOUNCEMENT = gql`
  mutation($msg:String,$status:String,$userlocations:[String],$managerlocations:[String],$teacherlocations:[String],$roles:[String],$date:String,
    $userPrograms:[String],
    $teacherPrograms:[String],
    $appNotification:Boolean,
    $color:String,
    $is_public:String,
    $sendStudentMsg:Boolean,
    $sendStaffMsg:Boolean,
    $msg_students:[ID],
    $location:ID!
    ) {
    createAnnouncement(
      msg: $msg
      date:$date
      status:$status
      color:$color
      is_public:$is_public
      userlocations:$userlocations
      managerlocations:$managerlocations
      teacherlocations:$teacherlocations
      roles:$roles
      userPrograms:$userPrograms
      teacherPrograms:$teacherPrograms
      appNotification:$appNotification
      sendStudentMsg:$sendStudentMsg
      sendStaffMsg:$sendStaffMsg
      msg_students:$msg_students
      location:$location

    )
    {
      message
      status
      color
    }
  }
`
export const ALL_ANNOUNCEMENTS = gql`query AllAnnouncements {
  announcements{ 
    id
    message
    status
    created_at
    expiry_date
    is_public
    color_code
    is_notification
    location_id
    # role{
    #   id
    #   pivot {
    #     role
    #   }
    # }
    roles{
        id
        name
    }
    locations{
        id
        name
        pivot {
          role
        }
    }
    programs{
        id
        name
        color_code
        pivot {
          role
        }
    }
}
}
`
export const UPDATE_ANNOUNCEMENT = gql`
  mutation($id:ID,$msg:String,$status:String,$userlocations:[String],$managerlocations:[String],$teacherlocations:[String],$roles:[String],$date:String,
    $userPrograms:[String],
    $teacherPrograms:[String],
    $color:String,
    $is_public:String
    $appNotification:Boolean
    ) {
    updateAnnouncement(
      id:$id
      msg: $msg
      date:$date
      status:$status
      color:$color
      is_public:$is_public
      userlocations:$userlocations
      managerlocations:$managerlocations
      teacherlocations:$teacherlocations
      roles:$roles
      userPrograms:$userPrograms
      teacherPrograms:$teacherPrograms
      appNotification:$appNotification
     
    )
    {
      message
      status
      color
    }
  }
`
export const REMOVE_ANNOUNCEMENT = gql`
mutation($id:ID!) {
  deleteAnnouncement(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const DUPLICATE_ANNOUNCEMENT = gql`
mutation($id:ID!) {
  duplicateAnnouncement(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const UPDATE_ANNOUNCEMENT_STATUS = gql`
mutation($id:ID,$status:String) {
  updateAnnouncementStatus(
    id: $id
    status:$status
  )
  {
    message
    status
    color
  }
}
`
export const GET_TOP_ANNOUNCENMENT = gql` query TopAnnouncements($location:ID){
  topAnnouncements(location:$location){ 
    message
    status
    id
    color_code
   
  }
}
`
export const DROPDOWN_ALL_LOCATIONS = gql`query DropdownLocationQuery {
  dropdownLocations {
    id
    name
    is_signup
    signup_code
  }
}
`
export const ACTIVE_LOCATIONS = gql`query DropdownLocationQuery {
  activeLocations {
    id
    name
    color_code
  }
}
`
export const GET_ALL_LOCATIONS = gql`query getAllLocations {
  getAllLocations {
    id
    name
    billing
    color_code
  }
}
`
export const GET_ALL_LOCATIONS_WITH_TIMEZONE = gql`query getAllLocations {
  getAllLocations {
    id
    name
    billing
    color_code
    timezone{
      id
      name
      value
    }
  }
}
`
export const CREATE_ALERT = gql`
  mutation($msg:String,$users:[AlertUserInput],$instant:Boolean,$sms:Boolean,$students:[ID],$files: [fileNameInput],$reminder:Boolean) {
    createAlert(
      msg: $msg
      instant:$instant
      sms:$sms
      users:$users
      students:$students
      files:$files
      reminder:$reminder
    )
    {
      message
      status
      color
      users
    }
  }
`

export const ALL_ALERT = gql`query AllAlertsQuery {
  allAlert{
    id
    message
    sender{
      id
      fname
      lname
      username
    }
    created_at
    alert_user{
      id
      status
      phone
      user_id{
        id
        fname
        lname
        username
      }
    }
    alert_student{
       id
       status
        student_id{
        id
        fname
        lname
        image
      }
    }
    alert_program{
      id
      status
      program_id{
      id
      name
      color_code
      }
    }
  }
}
`
export const CREATE_INSTANT_SMS = gql`
  mutation($msg:String,$phones:[String]) {
    createInstantSms(
      msg: $msg
      phones:$phones
    )
    {
      message
      status
      color
    }
  }
`
// export const GET_INSTANT_SMS = gql`query AllInstantSmsQuery {
// getInstantSms
// {
//     id
//     type
//     status
//     message
//     receiver
//     created_at
//     invited_by{
//       fname
//       lname
//     }
//   }
// }
// `
export const GET_INSTANT_SMS = gql`query AllInstantSmsQuery {
  getInstantSms{
    id
    message
    sender{
      id
      fname
      lname
      username
    }
    created_at
    instant_message_user{
      id
      status
      phone
    }
  }
}
`
export const SINGLE_LOCATION_ROOM_CHART = gql`
  mutation($id:ID) {
    SingleLocationRoomChart(
      id: $id
    )
    {
      students_count
      room{
        id
        name
      }
    }
  }
`
export const GET_STUDENT_BY_PROGRAMS = gql`
  mutation ($program_id:[ID]){
    programsStudent(program_id:$program_id) {
      id
      fname
      lname
      middle_name
      image
      users{
        id
        fname
        lname
        phone
        avatar
        phone_verified
        pivot{
         alert
         black_list
        }
      }
      program{
        id
        name
      }
    }
  }
`
export const GET_PROGRAM_BY_LOCATIONS = gql`
  mutation ($location_id:ID!){
    locations_programs(location_id:$location_id) {
      id
      name
      location_id
      color_code
    }
  }
`
export const CREATE_TEACHER = gql`
  mutation
  createTeacher($fname: String! ,$middle_name: String,$lname:String!,$nick_name:String, $username: String! ,$email: String!,$phone: String, $locations:[Int!]!,$status: Boolean,$email_confirmed: Boolean!,$avatar:String,  $invite_email:Boolean,
    $password:String,
    $job:String,
    $programs:[ID]
    $roles: [Int]){
      createTeacher (input: {
      fname:$fname
      middle_name:$middle_name
      lname:$lname
      username:$username
      nick_name:$nick_name
      job:$job
      email:$email
      phone:$phone
      locations:$locations
      programs:$programs
      email_confirmed:$email_confirmed
      status:$status
      invite_email:$invite_email
      avatar:$avatar
      password:$password
      roles:$roles
    }) {
      status
      user{
        id
      }

    }
  }
`
export const ALL_TEACHERS_QUERY = gql`query AllTeachersQuery {
  getTeachersList(
    name:"teacher"
  ) {
    name
    users{
      id
      fname
      lname
      nick_name
      middle_name
      username
      avatar
      job_title
      email
      phone
      email_confirmed
      status
      pending
      locations{
        id
        name
      }
      programs{
        id
        name
      }
    }
  }
}
`
export const UPDATE_TEACHER = gql`
  mutation
    updateTeacher($id: ID!,$fname: String ,$middle_name: String,$lname:String,$nick_name: String, $username: String,$email: String,$phone: String,$locations:[Int!]!,$status: Boolean,$email_confirmed: Boolean,$avatar:String,$programs:[ID],$job:String,$roles:[Int]){
      updateTeacher (id:$id ,
        input: {
      fname:$fname
      middle_name:$middle_name
      lname:$lname
      username:$username
      nick_name:$nick_name
      job:$job
      email:$email
      phone:$phone
      locations:$locations
      programs:$programs
      email_confirmed:$email_confirmed
      status:$status
      avatar:$avatar
      roles:$roles
    }) {
      status
      message
      color
    }
  }
  `
export const USER_LOCATION = gql`
  query ($id:ID!){
    user(id:$id) {
      id
      fname
      locations{
        id
        name
      }
    }
  }
  `
export const ROLE_LOCATIONS = gql`
    mutation ($role_id:ID!){
      roleLocations(role_id:$role_id) {
        id
        name
      }
    }
    `
export const GET_TEACHER_PROGRAM_BY_LOCATIONS = gql`
mutation ($location_id:ID,$teacher_id:ID){
  teacher_locations_programs(location_id:$location_id,teacher_id:$teacher_id) {
    id
    name
    location_id
  }
}
`
export const UPDATE_USER_ALERT = gql`
mutation
updateUserAlert($id: ID!,$user_id:ID!,$alert: Boolean!){
  updateUserAlert (
    id:$id,
    user_id:$user_id
    alert:$alert
    ) {
    status
  }
}
`
export const UPDATE_USER_CAMERA_WATCH = gql`
mutation
updateUserCameraWatch($id: ID!,$user_id:ID!,$alert: Boolean!){
  updateUserCameraWatch (
    id:$id,
    user_id:$user_id
    alert:$alert
    ) {
    status
  }
}
`
export const MANAGER_TOTAL_COUNTER = gql`query ManagerTotalCounter {
  ManagerTotalCounter{
    invited
    pending
    students
    users
    locations
    managers
    }
}
`
export const TEACHER_TOTAL_COUNTER = gql`query TeacherTotalCounter {
  TeacherTotalCounter{
    invited
    pending
    students
    users
    locations
    managers
    }
}
`
export const SEND_MSG = gql`
  mutation($student_id:ID!,$msg:String!,$files: String) {
    sendMsg(
      student_id:$student_id
      msg: $msg
      files:$files
    )
    {
      message
      status
      color
      users
    }
  }
`
export const GET_STUDENT_MESSAGE = gql`
mutation ($student:ID! ,$id:ID){
  getStudentMsg(student:$student,id:$id) {
    id
    message
    type
    student_id
    user_id{
      id
      fname
      lname
      username
      avatar
      roles{
        id
        name
      }
    }
    attachment{
      id
      file_name
      orignal_name
      storage_link
    }
    created_at
    parent_relation
  }
}
`

export const STUDENT_LAST_MSG = gql`
  mutation($student_id:ID!){
    student_last_msg(
      student_id:$student_id
    )
    {
      message
      created_at
    }
  }
`
// export const GET_UPCOMING_BIRTHDAY_TEACHER = gql`query TeacherBirthdayQuery {
//   TeacherStudentsBirthday {
//     id
//     fname
//     lname
//     image
//     dob
//     age
//     day
//   }
// }
// `
// export const GET_UPCOMING_BIRTHDAY_MANAGER = gql`query ManagerBirthdayQuery {
//   ManagerStudentsBirthday {
//     id
//     fname
//     lname
//     image
//     dob
//     age
//     day
//   }
// }
// `
export const GET_UPCOMING_BIRTHDAY_TEACHER = gql` 
mutation(
$date:String!
) {
 TeacherStudentsBirthday (
 date:$date
)
{
    id
    fname
    lname
    image
    dob
    age
    day
 }
 }
`
export const GET_UPCOMING_BIRTHDAY_MANAGER = gql` 
mutation(
$date:String!
) {
 ManagerStudentsBirthday (
 date:$date
)
{
    id
    fname
    lname
    image
    dob
    age
    day
 }
 }
`
export const GET_TEACHER_STUDENTS = gql`query TeacherStudentQuery {
  teacher_students {
    id
    fname
    middle_name
    nick_name
    full_name
    image
    dob
    lname
    type
    updated_at

    program{
        id
        name
        color_code
    }
    location{
        id
        name
    }
    users{
        id
        fname
        lname
        middle_name
        email
    }
    cameras{
        id
        name
        code
        color_code
        camera_id
    }
  

}
}
`
export const CREATE_ALERT_PROGRAM = gql`
  mutation($msg:String,$programs:[ID],$files: [fileNameInput],$reminder:Boolean) {
    createAlertProgram(
      msg: $msg
      programs:$programs
      files:$files
      reminder:$reminder
    )
    {
      message
      status
      color
      users
    }
  }
`
export const CREATE_NEW_FORM = gql`
  mutation($location:ID!,$name:String,$description:String,$instructions:String,$type:String,$share_with:String) {
    createNewForm(
      location:$location,name:$name,description:$description,instructions:$instructions,type:$type,share_with:$share_with
    )
    {
    id
    name
    type
    description
    instructions
    share_with
      
    }
  }
`
export const GET_FORMS = gql`
  mutation($location:ID!) {
    getForms(
      location:$location
    ){
      id
      name
      type
      description
      instructions
      share_with
      form_builder_url
      kv_form
      external_form_id
      count
      total_count
    }
  
  }
`
export const GET_SINGLE_FORM = gql`
  mutation($id:ID) {
    getSingleForm(
      id:$id
    ){
      id
      name
      type
      description
      instructions
      share_with
      form_builder_url
      kv_form
    }
  
  }
`
export const ADD_FORM_FIELD = gql`
  mutation($id:ID,$name:String,$type:String) {
    addFormField(
      id:$id,
      name:$name,
      type:$type
    ){
    status
    message
    color
    }
  
  }
` 
export const UPDATE_FORM_FIELD = gql`
  mutation($id:ID,$name:String,$type:String,$data:[OptionsInput]) {
    updateFormField(
      id:$id,
      name:$name,
      type:$type,
      data:$data
    ){
    status
    message
    color
    }
  
  }
` 
export const REMOVE_FORM_FIELD = gql`
  mutation($formId:ID,$id:ID) {
    removeFormField(
      id:$id
      formId:$formId
    ){
    status
    message
    color
    }
  
  }
`

export const SET_FIELD_REQUIRED= gql`
  mutation($id:ID,$value:Boolean) {
    setFieldRequired(
      id:$id,
      value:$value

    ){
    status
    message
    color
    }
  
  }
`

export const GET_FORM_COLUMNS = gql`
  mutation($id:ID) {
    getFormColumns(
      id:$id
    ){
      id
      name 
      type
      required
      form_id
      values{
        id
        name
        field_id
        order
      }
    }
  
  }
`

export const GET_SHARED_FORM_FIELDS = gql`
  mutation($id:ID,$student:ID) {
    getStudentSharedFields(
      id:$id,
      student:$student
    ){
      id
      name 
      type
      required
      form_id
    }
  
  }
`

export const GET_PROGRAM_MESSAGE = gql`
mutation ($program:ID!,$id:ID){
  getProgramMsg(program:$program,id:$id) {
    id
    message
    type
    student_id
    user_id{
      id
      fname
      lname
      username
      avatar
      roles{
        id
        name
      }
    }
    attachment{
      id
      file_name
      orignal_name
      storage_link
    }
    created_at
  }
}
`
export const PROGRAM_LAST_MSG = gql`
  mutation($program_id:ID!){
    program_last_msg(
      program_id:$program_id
    )
    {
      message
      created_at
    }
  }
`
export const SEND_PROGRAM_MSG = gql`
  mutation($program_id:ID!,$msg:String!,$files: String) {
    sendProgramMsg(
      program_id:$program_id
      msg: $msg
      files:$files
    )
    {
      message
      status
      color
      users
    }
  }
`
export const TEACHER_PROGRAMS = gql`query TeacherProgramsQuery {
  teacher_programs {
    id
    name
    color_code
    location_id
    location
    {
      id
      name
    }
  }
}
`
export const TEACHER_CHAT_PROGRAMS = gql`
query TeacherProgramsQuery {
  teacher_chat_programs {
    id
    name
    color_code
    counter
    message{
      id
      message
      created_at
    }
  }
}
`
export const USER_PROGRAMS = gql`query UserProgramsQuery {
  user_programs {
    id
    name
    color_code
    location
    {
      id
      name
    }
  }
}
`
export const TEACHER_CHAT_STUDENT = gql`query TeacherChatStudentQuery {
  teacher_chat_student {
    id
    fname
    middle_name
    image
    lname
    message{
      id
      message
      created_at
      counter
    }

    
}
}
`
export const USER_CHAT_STUDENT = gql`query UserChatStudentQuery {
  user_chat_student {
    id
    fname
    middle_name
    image
    lname
    message{
      id
      message
      created_at
      counter
    }
}
}
`

export const TEACHER_SINGLE_STUDENT = gql`
query ($id:ID!){
  teacher_student(id:$id) {
    id
    fname
    middle_name
    nick_name
    image
    dob
    lname
    type
    gender 
    race 
    allergies {
      id 
      name
    }
    medications {
      id 
      name
    }
    doctor_name 
    doctor_phone 
    note
    ethnicity 
    updated_at
    created_at
    program{
        id
        name
        color_code
    }
    location{
        id
        name
    }
    users{
        id
        fname
        lname
        middle_name
        email
        avatar
        phone
        phone2
        phone_type
        phone2_type
        check_in_pin
        username
        status
        email_confirmed
        pending
        invited
        pivot {
        emergency_contact
        alert
        black_list
        relation
        pickup
        legal_guardian
      }
    }
  }
}
`
export const ADMIN_CHAT_PROGRAMS = gql`query AdminProgramsQuery {
  admin_chat_programs {
    id
    name
    color_code
    counter
    location
    {
      id
      name
    }
    message{
      id
      message
      created_at
    }
  }
}
`
export const GET_USER_LOCATION_STUDENTS = gql`
mutation($locations:[ID!]!,$user_id:ID) {
  user_locations_student(
    locations: $locations
    user_id:$user_id
  )
}
`
export const ADD_USER_STUDENT = gql`
mutation($student:ID,$user:ID,$relation:ID) {
    add_student_user(
      student: $student
      user:$user
      relation:$relation
  )
  {
   status 
  }
}
`
export const ADD_NEWSLETTER_TEMPLATE = gql`
mutation($name:String!,$template:String,$image:String,$key:String,$is_temp:Boolean,$location:ID!,$uploaded:Boolean) {
  addNewsletterTemplate(
      name: $name
      template:$template
      image:$image
      key:$key
      is_temp:$is_temp
      uploaded:$uploaded
      location:$location
  )
  {
   status
   key
   id 
  }
}
`
export const ALL_NEWSLETTERS = gql`
query AllNewslettersQuery($location:ID!){
  newsletters(location:$location){
    id
    name
    is_temp
    image
    key
    uploaded
    published
    log{
      id
      user
      status
      send_by{
        username
      }
    }
  }
}
`
export const ALL_TEMPLATES = gql`
query getAllLocationNewsletterTemplate($location:ID!) {
  templates(location:$location) {
    id
    name
    is_temp
    image
    key
    tag{
      id
      name
      color
    }
  }
}
`
export const ALL_TEMPLATES_LOAD = gql` 
query loadtemplates($location:ID!){
  loadtemplates(location:$location){
    id
    name
    template
    is_temp
    image
  }
}
`

export const REMOVE_TEMPLATE = gql`
mutation($id:ID!) {
  deleteNewsletterTemplate(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const UPDATE_NEWSLETTER_TEMPLATE = gql`
mutation($id:ID!,$template:String!,$name:String!,$is_temp:Boolean!,$image:String!) {
  updateNewsletterTemplate(
      id:$id
      template: $template
      name:$name
      is_temp:$is_temp
      image:$image
  )
  {
   status
   message
   color 
  }
}
`
export const SINGLE_NEWSLETTER = gql`
query ($id:ID!){
  newsletter(id:$id) {
    id
    name
    template
    key
  }
}
`
export const EDIT_NEWSLETTER_TEMPLATE = gql`
mutation($id:ID!,$name:String!,$is_temp:Boolean) {
  editNewsletterTemplate(
      id:$id
      name: $name,
      is_temp:$is_temp
  )
  {
   status
   message
   color 
  }
}
`
export const BASE64_TO_FILE = gql`
mutation($fileString:String) {
  base64ToFile(
    fileString:$fileString
  )
  {
   file
  }
}
`
export const SEND_NEWSLETTER = gql`
  mutation(
  $newsletter_id:ID,
  $sub:String,
  $msg:String,
  $users:[SendNewsletterUserInput],
  $img: String,

) {
    sendNewsletter(
      newsletter_id:$newsletter_id
      sub: $sub
      msg: $msg
      users:$users
      img:$img
    )
    {
      message
      status
      color
    }
  }
`
export const GET_STUDENT_BY_PROGRAMS_NEWSLETTER = gql`
  mutation ($program_id:[ID]){
    programsStudentNewletter(program_id:$program_id) {
      id
      fname
      lname
      image
      users{
        id
        fname
        email
        pending
        invited
    }
  }
  }
`
export const DUPLICATE_NEWSLETTER = gql`
mutation($id:ID,$name:String,$key:String) {
  duplicateNewsletter(
      id: $id
      name: $name
      key:$key
  )
  {
   status
   message
   color 
  }
}
`
export const PUBLISH_NEWSLETTER = gql`
mutation($id:ID,$published:Boolean) {
  publishNewsletter(
      id: $id
      published: $published
      
  )
  {
   status
   message
   color 
  }
}
`
export const ADD_TEMPLATE_TAG = gql`
mutation($id:ID,$tag:String) {
  addTemplateTag(
      id: $id
      tag: $tag
  )
  {
   status
   message
   color 
  }
}
`
export const REMOVE_TEMPLATE_TAG = gql`
mutation($id:ID,$tag:String) {
  removeTemplateTag(
      id: $id
      tag: $tag
  )
  {
   status
   message
   color 
  }
}
`
export const SAVE_CAMERA_ORDER = gql`
mutation($cameras:[OrderCamerasInput]) {
  saveCameraOrder(
    cameras: $cameras
  )
  {
   status
   message
   color 
  }
}
`
export const ALL_ROLE = gql`query AllRoleQuery {
  roles {
    id
    name
    permissions{
      id
      name
      display_name
    }
  }
}
`
export const REMOVE_ROLE_PERMISSION = gql`
mutation($role_id:ID,$permission_id:ID) {
  removeRolePermission(
       role_id: $role_id
       permission_id: $permission_id
  )
  {
   status
   message
   color 
  }
}
`
export const ADD_NEW_PERMISSION = gql`
mutation($name:String,$display:String,$about:String,$roles:[ID]) {
  addNewPermission(
    name: $name
    display: $display
    about: $about
    roles:$roles
  )
  {
   status
   message
   color 
  }
}
`
export const ALL_PERMISSIONS = gql`query AllPermissionsQuery {
  permissions {
    id
    name
  }
}
`
export const UPDATE_ROLE_PERMISSION = gql`
mutation($role_id:ID,$permission_id:[ID]) {
  updateRolePermissions(
    role_id: $role_id
    permission_id: $permission_id
  )
  {
   status
   message
   color 
  }
}
`
export const MARK_AS_READ_CHAT = gql`
mutation($student_id:ID,$user_id:ID,$type:String) {
  markAsReadChat(
    student_id: $student_id
    user_id: $user_id
    type:$type
  )
}
`
export const GET_UNSEEN_MESSAGE = gql`
mutation($user_id:ID) {
  getUnseenChat(
    user_id: $user_id
  )
  {
    id
    name
    color_code
    location_user_count
   ##counter
  }
}
`
export const GET_UNREAD_MESSAGE = gql`
mutation($user_id:ID,$student_id:ID,$type:String) {
  getUnreadChat(
    user_id: $user_id
    student_id: $student_id
    type:$type
  )
  {
   counter
  }
}
`
export const REMOVE_PERMISSION = gql`
  mutation($id:ID) {
    removePermission(
      id: $id
    )
    {
      message
      status
      color
    }
  }
`

export const UPDATE_LOCATION_SIGNUP_CODE = gql`
  mutation
  updateLocationSignupCode(
    $id: ID
    $code:String
  ){
    updateLocationSignupCode (
      id:$id
      code:$code
) {
     status
     message
     color
    }
  }
`
export const UPDATE_LOCATION_BILLING = gql`
  mutation
  updateLocationBilling(
    $id: ID
    $billing:Boolean
  ){
    updateLocationBilling (
      id:$id
      billing:$billing
) {
     status
     message
     color
    }
  }
`
export const UPDATE_LOCATION_BILLING_REQUEST_SETTING = gql`
  mutation
  updateLocationBillingRequestSetting(
    $id: ID
    $billing:String
  ){
    updateLocationBillingRequestSetting (
      id:$id
      billing:$billing
) {
     status
     message
     color
    }
  }
`
export const CHECK_LOCATION_CODE = gql`
mutation($code:String!) {
  checkLocationCode(
    code: $code
  )
  {
   check
  }
}
`

export const UPDATE_STUDENT_CAMERA = gql`
mutation($id:ID,$cameras:[ID]) {
  updateStudentCamera(
    id: $id
    cameras: $cameras
  )
  {
     status
     message
     color
  }
}
`
export const ADD_IMAGE_TO_LIBRARY = gql`
  mutation
  addImageToLibrary($name: String,$key: String,$url: String,$folder:String){
    addImageToLibrary (
      name:$name
      key:$key
      url:$url
      folder:$folder
    ) 
    {
      status
      color
      message
    }
  }
`
export const GET_IMAGE_LIBARY = gql`query GetImageLibrary {
  getImageLibrary {
    id
    name
    key
    url
    created_at
  }
}
`
export const ADD_IMAGE_FOLDER = gql`
mutation($name:String,$parent:String) {
  createFolder(
    name: $name
    parent:$parent
  )
  {
     status
     color
  }
}
`
export const GET_FOLDER = gql`query GetFolder {
  getFolder {
    folder{
      id
      name
      parent
    }
     status
  }
}
`
export const GET_FOLDER_IMAGE = gql`
mutation($id:ID) {
  getFolderImages(
    id: $id
  )
  {
     id
     name
     url
     key
     folder
  }
}
`
export const CHANGE_IMG_NAME = gql`
mutation($id:ID,$name:String) {
  changeImgName(
    id: $id
    name:$name
  )
  {
     status
     message
     color
  }
}
`
export const CHANGE_FOLDER_NAME = gql`
mutation($id:ID,$name:String) {
  changeFolderName(
    id: $id
    name:$name
  )
  {
     status
     message
     color
  }
}
`
export const DELETE_IMG_FROM_LIBRARY = gql`
mutation($id:ID) {
  deleteImgFromLibrary(
    id: $id
  )
  {
     status
     message
     color
  }
}
`
export const DELETE_IMG_LIBRARY_FOLDER = gql`
mutation($id:ID) {
  deleteImgLibraryFolder(
    id: $id
  )
  {
     status
     message
     color
  }
}
`
export const GET_SERVER_DIRECTORY = gql`query getServerDirectory {
  getServerDirectory {
    images{
       id
       name
       key
       url
       created_at
     }
   status
  }
}
`
export const GET_DIRECTORY_IMAGES = gql`
mutation($path:String) {
  getDirectoryImages(
    path: $path
  )
  {
     folder{
       id
       name
       created_at     
       }
     status
  }
}
`
export const BULK_DELETE_IMAGES = gql`
mutation($id:[ID]) {
  bulkDeleteImges(
    id: $id
  )
  {
     status
     color
     message
  }
}
`
export const SAVE_FB_IMAGES = gql`
mutation(
  $imgs:[FbImgInput]
  ) 
  {
  saveFbImgs(
    imgs: $imgs
  )
  {
     status
     color
     message
  }
}
`
export const GET_FACEBOOK_FOLDER = gql`query GetFolder {
  getfacebookFolder {
    folder{
      id
      name
      parent
    }
     status
  }
}
`
export const GET_ALL_IMAGE_LIBARY = gql`query GetAllImageLibrary {
  getAllImageLibrary {
    id
    name
    key
    url
    created_at
  }
}
`


export const GET_FOLDER_WITH_IMAGES = gql`query GetFolderWithImages {
  GetFolderWithImages {
      id
      name
      images{
        id
        name
        key
        url
        created_at
      }
    }
}
`

export const GET_FOLDER_SUBFOLDER = gql`
mutation($id:ID) {
  getFolderSubfolder(
    id: $id
  )
  {
    id
    name
    parent
  }
}
`
export const GET_DIRECTORY_BREDCRUM = gql`
mutation($id:ID) {
  getDirectoryBredcrum(
    id: $id
  )
  {
    id
    name
    parent
  }
}
`
export const BULK_RESIZE_IMAGES = gql`
mutation($id:[ID],$width:String) {
  bulkResizeImges(
    id: $id
    width:$width
  )
  {
     status
     color
     message
  }
}
`

export const SEND_VERIFY_USER_EMAIL = gql`
mutation($email:String) {
  sendVerifyEmail(
    email: $email
  )
  {
     status
     color
     message
  }
}
`
export const MATCH_VERIFY_USER_EMAIL_CODE = gql`
mutation($email:String,$code:String) {
  matchVerifyEmailCode(
    email: $email
    code: $code
  )
  {
     status
     color
     message
  }
}
`
export const SEND_VERIFY_USER_SMS = gql`
mutation($phone:String) {
  sendVerifySms(
    phone: $phone
  )
  {
     status
     color
     message
  }
}
`
export const MATCH_VERIFY_USER_SMS_CODE = gql`
mutation($phone:String,$code:String) {
  matchVerifySmsCode(
    phone: $phone
    code: $code
  )
  {
     status
     color
     message
  }
}
`
export const GET_WEB_TEMP = gql`query WebTemplateQuery {
  webTemplate{
    template
  }
}
`
export const SAVE_WEB_TEMP = gql`
mutation($html:String,$css:String,$site:String,$page:String) {
  saveWebTemplate(
    html: $html
    css: $css
    site:$site
    page:$page
  )
  {
     status
     color
     message
  }
}
`

export const GET_ALL_WEB_PAGES = gql`query WebTemplateQuery {
  allWebPages{
    templates
  }
}
`
export const GET_PAGE_CONTENT = gql`
mutation($page:String,$name:String,$is_menu:Boolean,$menu:String) {
  getPageContent(
    page: $page
    name: $name
    is_menu:$is_menu
    menu:$menu
  )
  {
    template
    status
    ispage
    files
  }
  
}
`
export const SAVE_NEW_WEBPAGE = gql`
mutation($name:String,$content:String,$ext:String) {
  saveNewWebPage(
    name: $name
    content: $content
    ext:$ext
  )
  {
     status
     color
     message
  }
}
`
export const SAVE_NEW_SITE = gql`
mutation($name:String,$server:String) {
  saveNewSite(
    name: $name
    server: $server
  )
  {
     status
     color
     message
  }
}
`
export const DELETE_WEB_PAGE = gql`
mutation($page:String) {
  deleteWebPage(
    page: $page
  )
  {
     status
     color
     message
  }
}
`
export const COPY_WEB_PAGE = gql`
mutation($page:String,$name:String) {
  copyWebPage(
    page: $page
    name: $name
  )
  {
     status
     color
     message
  }
}
`
export const SAVE_WEB_DRAFT = gql`
mutation($site:String,$page:String,$html:String,$css:String) {
  saveWebDraft(
    site: $site
    page: $page
    html: $html
    css: $css
  )
  {
     status
     color
     message
  }
}
`
export const GET_ALL_DRAFT = gql`
mutation($site:String,$page:String) {
  allDrafts(
    site: $site
    page: $page
  )
}
`
export const GET_DRAFT_CONTENT = gql`
mutation($page:String) {
  getDraftContent(
    page: $page
  )
  {
    template
  }
  
}
`
export const GET_MAIN_MENU = gql`
mutation($page:String) {
  getMainMenu(
    page: $page
  )
  {
    template
  }
  
}
`
export const ALL_TEAM = gql`query AllUsersQuery {
  getAllTeamList{
    id
    fname
    lname
    middle_name
    full_name
    nick_name
    username
    email
    phone
    email_confirmed
    check_in_pin
    status
    invited
    avatar
    job_title
    last_login_time
    roles{
      id
      name
    }
    locations{
      id
      name
      color_code
    }
    managerlocations{
      id
      name
      color_code
    }
    programs{
      id
      name
      color_code
    }

}
}
`
export const ALL_TEAM_FOR_CENTER = gql`query AllUsersQuery {
  getAllTeamListForCenter{
    id
    fname
    lname
    middle_name
    nick_name
    username
    email
    phone
    email_confirmed
    status
    avatar
    job_title
    students{
        id
        fname
        lname
        middle_name
    }
    roles{
      id
      name
    }
    locations{
      id
      name
    }
    managerlocations{
      id
      name
    }
    programs{
      id
      name
    }

}
}
`

export const CREATE_LOCATION_CAMERA_SETTING = gql`
mutation($location:String!,$width:String,$height:String,$server:String,$fullscreen:Boolean) {
  createLocationCameraSetting(
    location: $location,
    server: $server,
    height: $height,
    width: $width
    fullscreen:$fullscreen
  )
  {
    status
  }
  
}
`
export const REMOVE_USER_FROM_STUDENT = gql`
mutation($users:[ID],$student:ID) {
  removeUserFromStudent(
    users: $users,
    student: $student,
  )
  {
    status
  }
  
}
`
export const ADD_USER_TO_STUDENT = gql`
mutation($users:[ID],$student:ID,$relation:ID) {
  addUserToStudent(
    users: $users,
    student: $student,
    relation:$relation
  )
  {
    status
  }
  
}
`
export const CREATE_NEW_LOCATION = gql`
mutation(
  $name: String!,
  $timezone:String,
  $email:String
  $phone:String
  $longitude:String
  $latitude:String
  $address:String
  $pin_url:String
  $map_url:String
  $is_signup:Boolean
  $signup_code:String
  $color:String
  $managers: [ID]
  $schedule_name:String
  $scheduledates:[CreateDatesInput]
  )
  {
    createNewLocation (input: {
    name:$name,
    timezone:$timezone,
    email:$email,
    phone:$phone,
    longitude:$longitude,
    latitude:$latitude,
    address:$address,
    pin_url:$pin_url,
    map_url:$map_url,
    is_signup:$is_signup
    signup_code:$signup_code
    color:$color
    scheduledates:$scheduledates
    schedule_name:$schedule_name
    managers: $managers
    }) 
    {
      location
      status
      color
    }
  }
`
export const ACTIVE_USER_STUDENT = gql`
mutation($id:ID!) {
  activateUserStudent(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const ACTION_USER_BLACK_LIST = gql`
mutation($status:Boolean,$student_id:ID,$user_id:ID) {
  actionUserBlackList(
    status: $status
    student_id: $student_id
    user_id: $user_id
  )
  {
    message
    status
    color
  }
}
`
export const GET_USER_STUDENTS = gql`
mutation ($id:ID!){
  getUserStudents(id:$id) {
    id
    fname
    middle_name
    nick_name
    image
    dob
    lname
    status
    type
    updated_at
    alert
    msg_counter
    program{
        id
        name
    }
    location{
        id
        name
    }
    cameras{
        id
        name
        color_code
        code
        camera_id
    location_setting{
      id
      name
      location_camera_setting{
        id
        key
        value
      }
    }
    location{
        id
        name
    }
    }
    }
    }
`
export const GET_ONLINE_USER = gql`
query GetOnlineUser($location:ID!) {
  GetOnlineUser(location:$location){
    id
    fname
    lname
    avatar
    last_login_time
    }
}
`
export const CREATE_TEAM_ACTIVITY = gql`
  mutation
  createTeamActivity($object_id: ID!,$object_type: String!,$activity: String!){
    createUserActivity (input: {
      object_id:$object_id
      object_type:$object_type
      activity:$activity

    }) {
      status

    }
  }
`
export const CREATE_MULTIPLEUSER_ACTIVITY = gql`
  mutation
  createMultipleUserActivity($object_id: [ID],$object_type: String!,$activity: String!){
    createMultipleUserActivity (input: {
      object_id:$object_id
      object_type:$object_type
      activity:$activity

    }) {
      status

    }
  }
`
export const GET_ALL_SITES = gql`query AllSITES {
  allSites{
    id
    name
    slug
    img
    full_path
    webserver{
    id 
    name
    }
  }
}
`
export const CREATE_NEW_PROGRAM_TEMPLATE = gql`
mutation($html:String,$site:String,$page:String) {
  createNewProgramTemplate(
    html: $html
    site:$site
    page:$page
  )
  {
     status
     color
     message
  }
}
`
export const ADD_NEW_MENU_WEEK = gql`
mutation($data:String) {
  addNewMenuWeek(
    data:$data
  )
  {
    status
  }
  
}
`
export const GET_ALL_MENU_WEEKS = gql`
mutation($site:String) {
  getAllMenuWeeks(
    site:$site
  )
  { 
    id
    name
    status
    date
  }
  
}
`
export const ADD_WEEK_MENU_ITEMS = gql`
mutation($data:String,$week:String) {
  addWeekMenuItems(
    data:$data
    week:$week
  )
  { 
   status
   message
   color
  }
  
}
`

export const ADD_NEW_MENU_OPTION = gql`
mutation($site:String,$item:String) {
  addNewMenuOption(
    site:$site
    item:$item
  )
  { 
   status
   message
   color
  }
  
}
`
export const GET_ALL_MENU_OPTION = gql`
mutation($site:String) {
  getAllMenuOption(
    site:$site
  )
  { 
    id
    name
    status
  }
  
}
`
export const DELETE_MENU_WEEK = gql`
mutation($week:String) {
  deleteMenuWeek(
    week:$week
  )
  { 
    status
  }
  
}
`
export const GET_WEEK_DATA = gql`
mutation($week:String,$site:String) {
  getWeekData(
    week:$week
    site:$site
  )
  { 
    data
    status
  }
  
}
`
export const SET_CURRENT_WEEK = gql`
mutation($week:String,$site:String) {
  setCurrentWeek(
    week:$week,
    site:$site
  )
  { 
    status
  }
  
}
`
export const MAKE_FOOD_MENU = gql`
mutation($site:String) {
  makeFoodMenu(
    site:$site
  )
  { 
    status
    data
  }
  
}
`
export const GET_FOOD_MENU_SETTING = gql`
mutation($site:String) {
  getFoodMenuSetting(
    site:$site
  )
  { 
    week
    rotate
  }
  
}
`
export const SET_FOOD_MENU_SETTING = gql`
mutation($site:String,$rotate:String,$week:String) {
  setFoodMenuSetting(
    site:$site,
    rotate:$rotate,
    week:$week
  )
  { 
    status
  }
  
}
`
export const GET_MENU_TEMP = gql`
mutation($site:String) {
  getMenuTemp(
    site:$site,
  ){
     menu_temp
     menu_data
     url
     files
  }
  
}
`
export const SAVE_MENU_FILE = gql`
mutation($site:String,$data:String) {
  saveMeneFile(
    site:$site,
    data:$data
  ){
    status
  }
  
}
`
export const SAVE_MENU_SECTION = gql`
mutation($site:String,$data:String,$html:String) {
  saveMenuSection(
    site:$site,
    data:$data,
    html:$html
  ){
    status
  }
  
}
`
export const GET_SOCIAL_TEMP = gql`
mutation($site:String) {
  getSocialTemp(
    site:$site,
  ){
     menu_temp
     menu_data
  }
  
}
`
export const SAVE_SOCIAL_DRAFT = gql`
mutation($site:String,$social:String) {
  saveSocialDraft(
    site: $site
    social: $social
    )
  {
     status
     color
     message
  }
}
`
export const GET_BLOCK_CONTENT = gql`
mutation($site:String,$name:String,$type:String,$page:String) {
  getBlockContent(
    site:$site,
    name:$name,
    type:$type,
    page:$page
  ){
     status
     content
     files
  }
  
}
`
export const PUBLISH_SITE = gql`
mutation($site:String) {
  publishSite(
    site:$site,
  ){
     status
     color
     message
  }
  
}
`
export const GET_PROGRAM_TEMP = gql`
mutation($site:String) {
  getProgramTemp(
    site:$site,
  ){
     template
     data
  }
  
}
`
export const SAVE_PROGRAM_SECTION = gql`
mutation($site:String,$data:String,$html:String) {
  saveProgramSection(
    site:$site,
    data:$data,
    html:$html
  ){
    status
  }
  
}
`
export const SAVE_STAFF_SECTION = gql`
mutation($site:String,$data:String,$html:String) {
  saveStaffSection(
    site:$site,
    data:$data,
    html:$html
  ){
    status
  }
  
}
`
export const SAVE_BLOCKS_SECTION = gql`
mutation($site:String,$data:String,$html:String,$block:String) {
  saveBlocksSection(
    site:$site,
    data:$data,
    html:$html,
    block:$block
  ){
    status
    data
  }
  
}
`
export const GET_STATIC_BLOCKS = gql`
mutation($site:String) {
  getStaticBlocks(
    site:$site,
  ){
     template
     data
  }
  
}
`
export const UPDATE_NEW_SITE = gql`
mutation($id:String,$name:String,$server:String) {
  updateNewSite(
    id:$id
    name: $name
    server: $server
 
  )
  {
     status
     color
     message
  }
}
`
export const SAVE_MENU_DRAFT = gql`
mutation($site:String,$menu:String) {
  saveMenuDraft(
    site:$site,
    menu:$menu
  ){
    status
  }
  
}
`
export const UPLOAD_SITE_THEME = gql`
  mutation
  uploadSiteTheme(
    $file:Upload,
    $site:String
  ){
    uploadSiteTheme (file:$file,site:$site) 
  }
`
export const CREATE_LOCATION_GROUP = gql`
  mutation
  createLocationGroup(
    $name: String!,
    $location:ID!
    $cameras:[ID]
    $check:Boolean
  ){
     createLocationGroup (
      name:$name,
      location:$location,
      cameras:$cameras,
      check:$check,
    ) {
      status
      color
      message
    }
  }
`
export const GROUP_BY_LOCATION = gql`
  mutation
  groupsByLocation(
    $location:ID!
  ){
    groupsByLocation (
      location:$location
    ) {
        id
        name
      }
    }
`
export const GET_GROUP_CAMERAS = gql`
mutation($group_id:ID) {
  getGroupCameras(
    group_id:$group_id,
  ){
    id
    name
  }
  
}
`
export const UPDATE_GROUP_CAMERA = gql`
  mutation
  updateGroupCamera(
    $group: ID,
    $cameras:[ID]
  ){
    updateGroupCamera (
      group:$group,
      cameras:$cameras
    ) {
      status
      color
      message
    }
  }
`
export const ADD_CAMERAS_TO_STUDENT_ACTION = gql`
  mutation
  addCamerasToStudentAction(
    $data:String,
    $cameras:String,
    $isReplace:Boolean
  ){
    addCamerasToStudentAction (
      data:$data,
      cameras:$cameras,
      isReplace:$isReplace
    ) {
      status
      color
      message
    }
  }
`
export const GET_STAFF_TEMP = gql`
mutation($site:String) {
  getStaffTemp(
    site:$site,
  ){
     template
     data
  }
  
}
`
export const SAVE_SOCIAL_SECTION = gql`
mutation($site:String,$data:String,$html:String) {
  saveSocialSection(
    site:$site,
    data:$data,
    html:$html
  ){
    status
  }
  
}
`
export const GET_SITE_ALL_EVENTS = gql`
mutation($site:String) {
  getSiteAllEvents(
    site:$site
  )
  { 
    id
    title
    img
    details
    date
    start_time
    end_time
    forpublic
    status
  }
  
}
`
export const CREATE_SITE_EVENT = gql`
mutation($site:String,$title:String,$details:String,$date:String,$start_time:String,$end_time:String,$forpublic:Boolean,$active:Boolean,$img:String) {
  createSiteEvent(
    site:$site
    title:$title
    details: $details
    date: $date
    start_time:$start_time
    end_time: $end_time
    forpublic: $forpublic
    active:$active
    img:$img
  )
  {
     status
     color
     message
  }
}
`
export const UPDATE_SITE_EVENT = gql`
mutation($id:ID,$site:String,$title:String,$details:String,$date:String,$start_time:String,$end_time:String,$forpublic:Boolean,$active:Boolean,$img:String) {
  updateSiteEvent(
    id:$id
    site:$site
    title:$title
    details: $details
    date: $date
    start_time:$start_time
    end_time: $end_time
    forpublic: $forpublic
    active:$active
    img:$img
  )
  {
     status
     color
     message
  }
}
`
export const DELETE_SITE_EVENT = gql`
mutation($id:ID) {
  deleteSiteEvent(
    id:$id
  )
  {
     status
     color
     message
  }
}
`
export const CHANGED_WEEK_OPTIONS_STATUS = gql`
mutation($site:String,$active:[ID],$available:[ID]) {
  changedFoodOptionsStatus(
    site:$site
    active:$active
    available:$available
  )
  { 
    status
  }
  
}
`
export const DELETE_FOOD_OPTION = gql`
mutation($id:ID) {
  deleteFoodOption(
    id:$id
  )
  { 
    status
  }
  
}
`
export const UPDATE_FOOD_OPTION = gql`
mutation($id:ID,$name:String) {
  updateFoodOption(
    id:$id
    name:$name
  )
  { 
    status
    message
    color
  }
  
}
`
export const COPY_MENU_TO_WEEKS = gql`
mutation($week:ID,$toweek:[ID]) {
  copyMenutoWeek(
    week:$week
    toweek:$toweek
  )
  {
    status
  }
  
}
`
export const GET_AUTOFILL_MENU_DATA = gql`
mutation($item:String) {
  getAutofillMenuData(
    item:$item
  )
}
`
export const GET_CAMERA_SETTING = gql`
mutation($id:ID) {
  getSingleCameraSetting(
    id:$id
  ){
        id
        name
        color_code
        code
        camera_id
        location_setting{
        id
        name
        location_camera_setting{
          id
          key
          value
        }
       }
  }
}
`
export const GET_STUDENT_SCHEDULE = gql`
mutation($id:ID) {
  getStudentSchedule(
    id:$id
  ){
        id
        schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
       
  }
}
`
 
// export const GET_STUDENT_CAMERAS = gql`
// mutation($site:String){
//   newStudents(site:$site){
//         id
//         cameras{
//         id
//         name
//         color_code
//         }
//   }
// }
// `
// export const GET_STUDENT_TAGS = gql`
// mutation($site:String){
//   newStudents(site:$site){
//         id
//         tags{
//         id
//         name
//         }
//   }
// }
// `

export const GET_USER_TAGS = gql`query GetAllUserQuery {
getAllUserTags{
  id
  tags{
   id
   name
  }
  }
}`
export const GET_MANAGER_USER_TAGS = gql`query GetAllManagerUserQuery {
  getAllManagerUserTags{
    id
    tags{
    id
    name
  }
  }
}`

export const GET_USER_SCHEDULE = gql`
mutation($id:ID) {
  getUserSchedule(
    id:$id
  ){
        id
        schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
        }
    }
       
  }
}
`
export const GET_SITE_STAFF = gql`
mutation($site:String) {
  getSiteStaff(
    site:$site,
  )
  {
    id
    name
    job_title
    short_details
    long_details
    status
    page
    image
  }
  
}
`
export const CREATE_NEW_STAFF_MEMBER = gql`
mutation($site:String,$name:String,$job_title:String,$short_details:String,$long_details:String,$image:String,$page:String) {
  createNewStaffMember(
    site:$site,
    name:$name,
    job_title:$job_title,
    short_details:$short_details,
    long_details:$long_details,
    image:$image,
    page:$page
  )
  {
    status
  }
  
}
`
export const DELETE_STAFF_MEMBER = gql`
mutation($site:String,$id:ID) {
  deleteStaffMember(
    site:$site,
    id:$id,
    
  )
  {
    status
  }
  
}
`
export const GET_SITE_DATA = gql`
mutation($site:String) {
  getSiteData(
    site:$site,    
  )
  {
    id
    name
    full_path
    webserver{
    id
    url
    }
  }
  
}
`
export const UPDATE_STAFF_MEMBER = gql`
mutation($id:ID,$name:String,$job_title:String,$short_details:String,$long_details:String,$image:String,$page:String) {
  updateStaffMember(
    id:$id,
    name:$name,
    job_title:$job_title,
    short_details:$short_details,
    long_details:$long_details,
    image:$image,
    page:$page
  )
  {
    status
  }
  
}
`
export const GET_SITE_PROGRAM = gql`
mutation($site:String) {
  getSiteProgram(
    site:$site,
  )
  {
    id
    name
    short_details
    long_details
    fields
    status
    page
    image
  }
  
}
`
export const CREATE_NEW_PROGRAM_MEMBER = gql`
mutation($site:String,$name:String,$fields:String,$short_details:String,$long_details:String,$image:String,$page:String) {
  createNewProgramMember(
    site:$site,
    name:$name,
    fields:$fields,
    short_details:$short_details,
    long_details:$long_details,
    image:$image,
    page:$page
  )
  {
    status
  }
  
}
`
export const UPDATE_PROGRAM_MEMBER = gql`
mutation($id:ID,$name:String,$short_details:String,$long_details:String,$fields:String,$image:String,$page:String) {
  updateProgramMember(
    id:$id,
    name:$name,
    fields:$fields,
    short_details:$short_details,
    long_details:$long_details,
    image:$image,
    page:$page
  )
  {
    status
  }
  
}
`
export const DELETE_PROGRAM_MEMBER = gql`
mutation($site:String,$id:ID) {
  deleteProgramMember(
    site:$site,
    id:$id,
    
  )
  {
    status
  }
  
}
`
export const REFRESH_LOGIN = gql`
mutation($id:ID){
  refreshToken(
      id:$id,
     ) 
     {
      access_token 
      expires_in 
      token_type 
  }
  }
`
export const GET_SINGLE_STUDENT_CACHE_BY_ID = gql`
mutation($id:ID) {
  newSingleStudentById(
    id:$id,
  )
  {
   id 
   fname 
   lname 
   middle_name  
   nick_name
   full_name
   dob
   image  
   status  
   type
   users{
    id 
    fname  
    lname  
    middle_name   
    email
    avatar
   }
   program{
    id 
    name 
    color_code 
    }
   location{
    id 
    name 
    billing 
   }
   cameras{
        id
        name
        color_code
    }
    tags{
    id
    name
    }
  }
  
}
`
export const SAVE_BLOCKS_FILE = gql`
mutation($site:String,$data:String) {
  saveBlocksFile(
    site:$site,
    data:$data,
  ){
    status
  }
  
}
`
export const SAVE_STATIC_BLOCKS_FILE = gql`
mutation($site:String,$data:String) {
  saveStaticBlocksFile(
    site:$site,
    data:$data
  ){
    status
  }
  
}
`
export const GET_CSRF = gql`
query getCSRF {
  getCSRF
     
}
`
export const MANAGER_ALL_LOCATION_LIST = gql`query ManagerAllLocationList {
  managerAllLocationsList {
    id
    name
    email
    phone
    longitude
    latitude
    pin_url
    map_url
    address
    is_signup
    signup_code
    billing
    active
    color_code
    location_billing_request{
      value
    }
    timezone{
      id
      name
      value
    }
    rooms{
      id
      name
    }
    groups{
    id
    name
    cameras{
        id
        name
        code
        color_code
    }
    }
    camera_setting{
        id
        key
        value
    }
    managers{
      id
      fname
      lname
      email
      username
    }
    cameras{
      id
    name
    code
    color_code
    camera_id
    room{
      id
      name
    }
    groups{
      id
      name
    }
    location_setting{
      id
      name
      location_camera_setting{
        id
        key
        value
      }
    }
    location_id
    status
    order
    location{
      name
      id
      schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }

    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }
  }
}
`
export const GET_LOCATION_HISTORY = gql`
mutation($location:ID!) {
  getLocationHistory(
    location:$location,
  ){
    id
    description
    summary
    created_by{
     id
     fname
     lname
    }
    username
    created_at
   }
  
}
`
export const CREATE_STREAM = gql`
mutation($server:String,$code:String) {
  createStream(
    server: $server,
    code: $code,
  )
  {
    status
  }
  
}
`
export const GET_ALL_STREAMS = gql`query AllSTREAMS {
  allStreams{
    id
    host
  }
}
`
export const REMOVE_STREAM = gql`
  mutation($id:ID!) {
    deleteStream(
      id: $id
    )
    {
      message
      status
      color
    }
  }
`
export const UPDATE_STREAM = gql`
mutation($id:ID,$server:String,$code:String,$change:Boolean) {
  updateStream(
    id:$id,
    server: $server,
    code: $code,
    change:$change
  )
  {
    status
  }
  
}
`
export const CREATE_MANAGER_TICKET = gql`
mutation
  createManagerTicket($name: String!, $description: String!,$status:String!,$category:String!,$created_by:String!,$action_by:String,$files: [fileNameInput],$locations:[ID!]!){
    createManagerTicket (input: {
    name: $name,
    description: $description
    status:$status
    category:$category
    created_by:$created_by
    action_by:$action_by
    files:$files
    locations:$locations
  }) {
    status
    message
    color
  }
}
`
export const UPDATE_MANAGER_TICKET = gql`
  mutation
  updateManagerTicket($id:ID!,$name: String!, $description: String!,$status:String!,$category:String!,$updated_by:String!,$action_by:String,$locations:[ID!]!){
    updateManagerTicket (input: {
      id:$id
      name: $name,
      description: $description
      status:$status
      category:$category
      updated_by:$updated_by
      action_by:$action_by
      locations:$locations
    }) {
      status
    }
  }
`
export const REMOVE_MANAGER_TICKET = gql`
mutation($id:ID!) {
  deleteManagerTicket(
    id: $id
  )
  {
    status
  }
}
`

export const ALL_MANAGER_TICKETS = gql`query AllManagerTickets {
  ManagerTickets {
    id
    ticket_number
    name
    description
    created_at
    created_by{
    id
    fname
    lname
    }
    locations{
      location_id
    }
    users{
      user_id
      name
    }
    students{
      student_id
      name
    }
    status
    {
      id
      name
      color
    }
    category
    {
      id
      name
      description
    }
    center{
      id
      name
      url
    }
  }

}
`
export const ALL_TICKET_BY_CENTER = gql`
mutation ($center:ID!,$locations:[ID!]!,$active:Boolean){
centertickets(center:$center,locations:$locations,active:$active) {
        id
        name
        ticket_number
        description
        created_at
        updated_at
        attachment{
            id
            file_name
            orignal_name
            storage_link
          }
          status{
            id
            name
            color
          }
        category{
          id
          name
        }
        history{
          id
          summary
          description
          created_at
          attachment{
            id
            file_name
            orignal_name
            storage_link
            deleted_at
          }
        }
}
}
`
export const ALL_CENTER_TICKETS = gql`
mutation ($center:String){
centertickets(center:$center) {
        id
        name
        ticket_number
        description
        created_at
        updated_at
        action_by
        attachment{
            id
            file_name
            orignal_name
            storage_link

          }
        created_by{
          id
          username
          fname
          lname
        }
        status{
          id
          name
          color
        }
        category{
          id
          name
        }
        updated_by{
          id
          username
          fname
          lname
        }
        history{
          id
          summary
          description
          created_at
          attachment{
            id
            file_name
            orignal_name
            storage_link
            deleted_at
          }
          created_by{
          id
          username
          avatar
          fname
          lname
           }
          action_by 

        }

}
}
`
export const REMOVE_MANAGER_TICKET_ATTACHMENT = gql`
mutation($id:ID,$created_by:String,$action_by:String) {
  deleteManagerTicketAttachment(
    id:$id
    created_by:$created_by
    action_by:$action_by
  )
  {
    status
    color
    message
  }
}
`
export const ADD_MANAGER_TICKET_COMMENT = gql`
  mutation
  addManagerTicketComment($id:ID!,$comment: String!,$comment_by: String!,$files: [fileNameInput],$action_by:String){
    addManagerTicketComment (input: {
      id:$id
      comment: $comment,
      comment_by: $comment_by
      action_by: $action_by
      files:$files
    }) {
      status
    }
  }
`
export const APPROVE_USER_BY_LINK = gql` 
mutation approveUserByLink($token: String!){
approveUserByLink(
    token:$token
  )
  {
    status
    message
  }
}`

export const GET_STUDENT_CACHE_BY_IDS = gql`
mutation($id:[ID]) {
  newMultipleStudentById(
    id:$id,
  )
  {
   id 
   fname 
   lname 
   middle_name  
   nick_name
   dob
   image  
   status  
   users{
    id 
    fname  
    lname  
    middle_name   
    email 
   }
   program{
    id 
    name 
    color_code 
    }
   location{
    id 
    name 
    billing 
   }
   cameras{
        id
        name
        color_code
    }
  }
  
}
`
export const GET_STUDENTS_AND_USERS_BY_LOCATION = gql`
  query ($location:[ID!]!){
    getStudentAndUserByLocation(location:$location) {
     students{
      id
      fname
      lname
      program{
      id
      name
      }
      location{
      id
      name
      }
     }
     users{
      id
      fname
      lname
      email
      username
     }
    }
  }
`

export const SEND_PASSWORD_RESET_EMAIL = gql`
mutation forgotPassword($email: String!) {
  forgotPassword(input: {
    email:$email,
  }) {
    status
    message
  }
}`

export const LOGIN_AS_USER = gql`
mutation loginAsUser($user: ID!) {
    loginAsUser( 
      user:$user,
     ) {
    status
    access_token
    refresh_token
    expires_in
    token_type
    user {
      id
      fname
      lname
      email_confirmed
      email
      phone
      phone_verified
      status
      pending
      avatar
      roles {
        id
        name
        permissions{
        id
        name
         }
        }

    }
  }
}`

export const UPDATE_MAIN_CENTER_TICKET = gql`
  mutation
  updateMainCenterTicket($id:ID!,$name: String!, $description: String!,$status:String!,$category:String!,$updated_by:String!){
    updateMainCenterTicket (input: {
      id:$id
      name: $name,
      description: $description
      status:$status
      category:$category
      updated_by:$updated_by
    }) {
      status
    }
  }
`
export const CREATE_MAIN_CENTER_TICKET = gql`
  mutation
  createMainCenterTicket($name: String!, $description: String!,$status:String!,$category:String!,$created_by:String!,$files: [fileNameInput],$locations:[Ticket_Location]){
    createMainCenterTicket (input: {
    name: $name,
    description: $description
    status:$status
    category:$category
    created_by:$created_by
    files:$files
    locations:$locations
  }) {
    status
  }
}
`
export const GET_MAIN_CENTER_ALL_LOCATIONS = gql` query AllMainCenterLocations {
  allMainCenterLocation {
    id
    name
    address
    center_location_id
  }
}
`
export const GET_LOCATION_DEFAULT_CAMERAS = gql`
mutation ($id:ID!){
  getLocationDefaultCameras(id:$id) {
        id
        name
        color_code
        code
        camera_id
    }
    }
`
export const GET_MANAGER_SINGLE_TICKET = gql`
mutation ($id:ID!){
  managerSingleticket(id:$id) {
        id
        name
        ticket_number
        description
        created_at
        updated_at
        action_by
        setting{
        center_object_id
        user{
            id
            fname
            lname
            username
            }
        }
        attachment{
            id
            file_name
            orignal_name
            storage_link
          }
          status{
            id
            name
            color
          }
        locations{
         location_id
         center_location_id
        }  
        users{
          user_id
          setting{
          center_object_id
        }
        }
        students{
          student_id
          setting{
            center_object_id
        }
        }
        category{
          id
          name
        }
        history{
          id
          summary
          description
          created_at
          action_by
          attachment{
            id
            file_name
            orignal_name
            storage_link
            deleted_at
          }
          setting{
            center_object_id
            user{
            id
            fname
            lname
            avatar
            username
            }
          }
        }
}
}
`

export const GET_STUDENTS_AND_USER_DATA = gql`
mutation getStudentAndUserById($students: [ID],$users:[ID]) {
  getStudentAndUserById(
    students:$students,
    users:$users,
   ) {
    students{
    id
    fname
    lname
    }
    users{
    id
    fname
    lname
    }
  }
}`

export const GET_ALL_CENTERS = gql`query ALLCENTERS {
  centers{
    id
    name
    url
    path
    port
    aws_center_id
    last_updated_time
  }
}
`
export const GET_CENTER_PROFILE = gql`
  mutation getCenterProfile($id: String!){
    getCenterProfile(id:$id)
  }
`
export const ADD_NEW_CENTER = gql`
  mutation
  addNewCenter($name: String,$url:String,$db:String,$path:String,$port:String){
    addNewCenter (name: $name,url:$url,db:$db,path:$path,port:$port) {
      status
      message
    }
  }
`
export const UPDATE_CENTER = gql`
  mutation
  updateCenter($id:ID,$name: String,$url:String,$path:String,$port:String){
    updateCenter (id:$id,name:$name,url:$url,path:$path,port:$port) {
      status
    }
  }
`
export const UPDATE_CENTER_SETTINGS = gql`
  mutation
  updateCenterSetting($id:ID,$server: String,$key:String){
    updateCenterSetting (id:$id,server: $server,key:$key) {
      status
    }
  }
`

export const GET_CENTER_SETTINGS = gql`
  mutation
  getCenterSettings($id: ID){
    getCenterSettings (id: $id) {
    settings{
      key
      value
    }
    check
    }
  }
`
export const CENTER_AUTO_LOGIN = gql`
  mutation
  centerAutoLogin($id: ID){
    centerAutoLogin (id: $id) {
      status
      access_token
    }
  }
`
export const AWS_CENTER_AUTO_LOGIN = gql`
  mutation
  awsCenterAutoLogin($hostname: String){
    awsCenterAutoLogin (hostname: $hostname) {
      status
      access_token
    }
  }
`
export const APPROVE_AUTO_LOGIN = gql`
  mutation
  approveAutoLogin($token: String){
    approveAutoLogin (token: $token)
  }
`
export const GET_CENTER_LOCATIONS = gql`
  mutation
  getCenterLocations($id: ID){
    getCenterLocations (id: $id) {
      id
      name
      address
    }
  }
`
export const GET_SSL_KEYS = gql`
  mutation
  getSslKeys($id: ID){
    getSslKeys (id: $id) {
       public
    }
  }
`

export const UPDATE_LOCATION_TEAM_NOTIFICATION = gql`
  mutation
  updateLocationTeamNotification(
    $id: ID
    $emails:[String]
    $phones:[String]
    $is_signup_notification:Boolean
    $signup_notification_email:String
    $signup_notification_phone:String
    $appNotification:Boolean
    $emailNotification:Boolean
    $smsNotification:Boolean
  ){
    updateLocationTeamNotification (
      id:$id
      emails:$emails
      phones:$phones
      is_signup_notification:$is_signup_notification
      signup_notification_email:$signup_notification_email
      signup_notification_phone:$signup_notification_phone
      appNotification:$appNotification
      emailNotification:$emailNotification
      smsNotification:$smsNotification
      
) {
     status
     message
     color
    }
  }
`

export const GET_LOCATION_TEAM_NOTIFICATION = gql`
  mutation
  getLocationTeamNotification($id: ID){
    getLocationTeamNotification (id:$id)
    {
      emails
      phones
    }
  }
`
export const SEND_VERIFY_LOCATION_EMAIL = gql`
mutation($email:String,,$id:ID) {
  sendVerifyLocationEmail(
    email: $email
     id:$id
  )
  {
     status
     color
     message
  }
}
`
export const MATCH_VERIFY_LOCATION_EMAIL_CODE = gql`
mutation($email:String,$code:String,$id:ID) {
  matchVerifyLocationEmailCode(
    email: $email
    code: $code
    id:$id
  )
  {
     status
     color
     message
  }
}
`
export const SEND_EDIT_USER_EMAIL = gql`
mutation($email:String,,$id:ID) {
  sendVerifyEditUserEmail(
    email: $email
     id:$id
  )
  {
     status
     color
     message
  }
}
`

export const MATCH_VERIFY_EDIT_USER_EMAIL_CODE = gql`
mutation($email:String,$code:String,$id:ID,$old_email:String) {
  matchVerifyEditUserEmailCode(
    email: $email
    code: $code
    id:$id
    old_email:$old_email
  )
  {
     status
     color
     message
  }
}
`
export const ALL_TEAM_FOR_NOTIFICATION = gql`
mutation($id:ID) {
  getAllTeamForNotification(
    id:$id
  )
  {
    id
    fname
    lname
    middle_name
    username
    email
    phone
    roles{
      id
      name
    }
  }
}
`
export const ADD_NEW_WEB_SERVER = gql`
mutation($name:String,$url:String,$ftp:String,$path:String,$username:String,$password:String,$port:String,$type:String) {
  addNewWebServer(
    name: $name
    url: $url
    ftp:$ftp
    path: $path
    username: $username
    password:$password
    port:$port
    type:$type
    
  )
  {
     status
     color
     message
  }
}
`
export const UPDATE_WEB_SERVER = gql`
mutation($id:String,$name:String,$url:String,$ftp:String,$path:String,$username:String,$password:String,$port:String,$type:String) {
  updateWebServer(
    id:$id
    name: $name
    url: $url
    ftp:$ftp
    path: $path
    username: $username
    password:$password
    port:$port
    type:$type
  )
  {
     status
     color
     message
  }
}
`
export const GET_ALL_WEB_SERVERS = gql`query AllWEBSERVERS {
  getAllWebServers{
    id
    name
    port
    host
    username
    password
    url
    path
  }
}
`

export const REMOVE_WEB_SERVER = gql`
mutation($id:ID!) {
  deleteWebServer(
    id: $id
  )
  {
    message
    status
    color
  }
}
`

export const GET_ALL_WEB_SERVERS_DROPDOWN = gql`query AllWEBSERVERS {
  getAllWebServerDropdown{
    id
    name
    url
  }
}
`
export const DELETE_STUDENT_CHAT_MESSAGE = gql`
mutation ($id:ID!,$student_id:ID!){
  deleteStudentChatMessage(
      id:$id
      student_id:$student_id
   )  
   {
        message
        status
        color
        users
     }
    }
`
export const UPDATE_SEND_MSG = gql`
  mutation($id:ID!,$msg:String!,$student_id:ID!) {
    updateSendMsg(
      student_id:$student_id
      id:$id
      msg: $msg
     )
    {
      message
      status
      color
      users
      
    }
  }
`
export const DELETE_PROGRAM_CHAT_MESSAGE = gql`
mutation ($id:ID!,$program_id:ID!){
  deleteProgramChatMessage(
    program_id:$program_id
      id:$id
   )  
   {
        message
        status
        color
        users
     }
    }
`
export const UPDATE_PROGRAM_SEND_MSG = gql`
  mutation($id:ID!,$msg:String!,$program_id:ID!) {
    updateProgramSendMsg(
      program_id:$program_id
      id:$id
      msg: $msg
     )
    {
      message
      status
      color
      users
    }
  }
`
export const UNSUBSCRIBE_EMAIL = gql` 
mutation unsubscribeEmail($token: String!){
  unsubscribeEmail(
    token:$token
  )
  {
    status
    message
  }
}`

export const GET_CAMERA_HISTORY = gql`
mutation($camera:ID) {
  getCameraHistory(
    camera:$camera,
  ){
    id
    description
    summary
    created_at
    username
    created_by{
     id
     fname
     lname
    }
   }
  
}
`
export const GET_UNSUBSCRIBED_EMAIL = gql`query AllUnsubscribedEmailQuery {
  unsubscribedemail {
    id
    email
    created_at
  }
}
`
export const GET_UNSUBSCRIBED_PHONE = gql`query AllUnsubscribedPhoneQuery {
  unsubscribedphone {
    id
    phone
    created_at
  }
}
`
export const REMOVE_UNSUBSCRIBED_EMAIL = gql`
  query($id:ID!) {
    deleteUnsubscribedEmail(
      id: $id
    ){
      id
    }
  }
`
export const REMOVE_UNSUBSCRIBED_PHONE = gql`
  query($id:ID!) {
    deleteUnsubscribedPhone(
      id: $id
    ){
      id
    }
  }
`
export const CREATE_WEB_NEWS = gql`
mutation($site:String,$title:String,$shortDetails:String,$longDetails:String,$category:String,$img:String,$status:Boolean,$page:String) {
  addNewWebNews(
    title: $title
    site:  $site
    shortDetails: $shortDetails
    longDetails:$longDetails
    img: $img
    status: $status
    page:$page
    category:$category
  )
  {
     status
     color
     message
  }
}
`
export const UPDATE_WEB_NEWS = gql`
mutation($id:ID,$site:String,$title:String,$shortDetails:String,$longDetails:String,$category:String,$img:String,$status:Boolean) {
  updateWebNews(
    id:$id
    site:  $site
    title: $title
    shortDetails: $shortDetails
    longDetails:$longDetails
    img: $img
    status: $status
    category:$category
  )
  {
     status
     color
     message
  }
}
`
export const GET_WEB_NEWS = gql`
mutation($site:String) {
  getWebNews(
    site:$site
  ){
    id
    title
    summary
    description
    img
    status
    category{
      id
      name
    }
   }
  }
`
export const DELETE_WEB_NEWS = gql`
mutation ($id:ID!){
  deleteWebNews(
      id:$id
   )  
   {
        message
        status
        color
     }
    }
`

export const GET_WEB_NEWS_CATEGORY = gql`
mutation($site:String) {
  getWebNewsCategories(
    site:$site
  ){
    id
    name
   }
  }
`

export const CREATE_WEB_NEWS_CATEGORY = gql`
mutation($site:String,$name:String) {
  addNewWebNewsCategory(
    name: $name
    site:  $site
  )
  {
     status
     color
     message
  }
}
`
export const GET_NEWS_TEMP = gql`
mutation($site:String) {
  getNewsTemp(
    site:$site,
  ){
     template
     data
  }
  
}
`

export const SAVE_NEWS_SECTION = gql`
mutation($site:String,$html:String) {
  saveNewsSection(
    site:$site,
     html:$html
  ){
    status
  }
  
}
`
export const CREATE_WEB_NEWS_TAG = gql`
mutation($site:String,$name:String) {
  addNewWebNewsTag(
    name: $name
    site:  $site
  )
  {
     status
     color
     message
  }
}
`

export const RESEND_INVITED_USER_SMS = gql` 
mutation resendSmsQuery($id: ID,$phone:String) {
  resendInvitedUserSms(
    id:$id
    phone:$phone,
  ) {
    status
     color
     message
   }
}`
export const SEND_MULIPLE_USER_INVITE = gql`
mutation
sendMultipleUserInvite(
  $type: String,
  $user_ids:[ID]

){
  sendMultipleUserInvite (
    type:$type,
    user_ids:$user_ids
  ) {
    status
    success_count
    failed_count
  }
}
`
export const SAVE_PROCARE_DATE = gql` 
mutation saveProCareData($data:String,$program:Boolean,$location:ID!) {
  saveProCareData(
    data:$data
    program:$program
    location:$location
   ) {
     status
     errors
     data
   }
}`
export const CREATE_MULTIPLE_CAMERAS = gql`
mutation
createMultipleCameras(
  $cameras: [createMultipleCamerasInput],
  $location:ID!
){
  createMultipleCameras (
    cameras:$cameras
    location:$location
    ) {
    status
    message
    color
    }
}
`
export const UPDATE_LOCATION_MANAGER = gql`
  mutation
  updateLocationManager(
    $id: ID!,
    $managers: [ID!]
  ){
    updateLocationManager (
      id:$id ,
      managers:$managers
      ) 
     {
      id
      name
    }
  }
`
// export const STOP_PHON_NUMBER = gql`
// mutation($phone:String,$text:String,$type:String) {
//   stopPhoneNumber(
//     phone:$phone
//     text:$text
//     type:$type
//   )
//   {
//     status
//     color
//     message
//   }
// }
// `
export const GET_SMS_RESPONSE = gql`
query AllResponsePhoneQuery {
  smsResponse {
    id
    phone
    text
    created_at
  }
}
`
export const GET_SITE_DETAILS = gql`
  mutation getSiteDetails($site: String){
    getSiteDetails (
      site:$site
      ) 
     {
     site{
      id
      name
      slug
      img
      full_path
      webserver{
      id 
      name
      url
      }
      }
      program
      news
      staff
      event
    }
  }
`

export const SITE_THEME_FILES = gql`
mutation
siteThemeFiles(
  $site: String,
   
){
  siteThemeFiles (
    site:$site
     )  
}
`
export const GET_S3_FOLDER_FILES = gql`
mutation
getS3FolderFiles(
  $dir: String,
   
){
  getS3FolderFiles (
    dir:$dir
     )  
}
`
export const DELETE_S3_FOLDER_FILES = gql`
mutation
deleteS3FolderFile(
  $file: String,
  $dir: String,
 ){
  deleteS3FolderFile (
    file:$file
    dir:$dir
     ) 
}
`
export const GET_S3_FILE_CONTENT = gql`
mutation
getS3FileContent(
  $file: String,
  ){
    getS3FileContent (
    file:$file
      ) 
}
`
export const SAVE_S3_FILE_CONTENT = gql`
mutation
saveS3FileContent(
  $data: String,
  $path: String,
  ){
    saveS3FileContent (
      data:$data
      path:$path
      ) 
      {
      status
      }
}
`
export const SAVE_STUDENT_GENDER = gql`
mutation
  saveStudentGender(
  $id:ID
  $gender: String
  ){
  saveStudentGender (
  id:$id
  gender:$gender
  ) 
  {
    status
  }
}
`
export const SAVE_STUDENT_ETHNICITY = gql`
mutation
  saveStudentEthnicity(
  $id:ID
  $ethnicity: String
  ){
  saveStudentEthnicity (
  id:$id
  ethnicity:$ethnicity
  ) 
  {
    status
  }
}
`
export const SAVE_STUDENT_ADDRESS = gql`
mutation
  saveStudentAddress(
  $id:ID
  $street1 :String,
  $street2 :String,
  $city :String,
  $state :String,
  $country :String,
  $zip:String
  ){
  saveStudentAddress (
  id:$id
  street1 :$street1,
  street2 :$street2,
  city :$city,
  state :$state,
  country :$country,
  zip:$zip
  ) 
  {
    status
  }
}
`

export const CREATE_NEW_STUDENT = gql`
  mutation
  createNewStudent(
    $fname: String!
    $lname: String!
    $middle_name: String
    $nick_name: String
    $dob:String
    $image:String
    $status: Boolean
    $location_id:String!
    $program_id: String!
    $cameras: [ID!]!
    $users: [ID!]!
    $race:String,
    $type:String, 
    $ethnicity:String, 
    $allergies:[ID], 
    $medications:[ID], 
    $drname:String, 
    $drphone:String, 
    $note:String, 
    $gender:String
    $street :String,
    $city :String,
    $state :String,
    $zip:String,
    $enrollment_date:String, 
    $graduation_date:String,
    $billing_program:ID
    $other_rooms:[ID],
    $check_duplicate:Boolean
  ){
    createNewStudent (input: {
      fname:$fname,
      lname:$lname,
      middle_name:$middle_name,
      nick_name:$nick_name,
      dob:$dob,
      image:$image,
      status:$status,
      program_id:$program_id,
      location_id:$location_id
      cameras:$cameras
      users:$users
      gender:$gender
      race:$race 
      type:$type 
      ethnicity:$ethnicity 
      allergies:$allergies 
      medications:$medications
      drname:$drname 
      drphone:$drphone 
      note:$note 
      street:$street,
      city:$city,
      state:$state,
      zip:$zip,
      enrollment_date:$enrollment_date,
      graduation_date:$graduation_date,
      billing_program:$billing_program
      other_rooms:$other_rooms
      check_duplicate:$check_duplicate
      
    }) {
      status
      message
      id
    }
  }
`
export const UPDATE_NEW_STUDENT = gql`
  mutation
  updateNewStudent(
    $id:ID!
    $fname: String
    $lname: String
    $middle_name: String
    $nick_name: String
    $dob:String
    $image:String
    $status: Boolean
    $location_id:String!
    $program_id: String
    $schedule_id: String
    $cameras: [ID!]
    $users: [ID!]
    $siblings: [ID!]
    $gender:String
    $race:String,
    $type:String, 
    $ethnicity:String, 
    $allergies:[ID], 
    $medications:[ID], 
    $drname:String, 
    $drphone:String, 
    $note:String, 
    $street:String, 
    $city:String, 
    $state:String, 
    $zip:String, 
    $enrollment_date:String, 
    $graduation_date:String,
    $billing_program:ID
    $other_rooms:[ID]
  ){
    updateNewStudent (
      id:$id,
      input: {
      fname:$fname,
      lname:$lname,
      middle_name:$middle_name,
      nick_name:$nick_name,
      dob:$dob,
      image:$image,
      status:$status,
      schedule_id:$schedule_id
      program_id:$program_id,
      location_id:$location_id
      cameras:$cameras
      users:$users
      siblings:$siblings
      gender:$gender
      race:$race 
      type:$type 
      ethnicity:$ethnicity 
      allergies:$allergies 
      medications:$medications
      drname:$drname 
      drphone:$drphone 
      note:$note 
      street:$street
      city:$city
      state:$state
      zip:$zip
      enrollment_date:$enrollment_date
      graduation_date:$graduation_date
      billing_program:$billing_program
      other_rooms:$other_rooms
    }) {
      status
      message
      id
    }
  }
`
export const SAVE_STUDENT_COLUMN_DATA = gql`
mutation
saveStudentColumnData(
  $id:ID
  $data: String
  $column: String
  ){
saveStudentColumnData (
  id:$id
  data:$data
  column:$column
  ) 
  {
    status
  }
}
`
export const SAVE_USER_COLUMN_DATA = gql`
mutation
saveUserColumnData(
  $id:ID
  $data: String
  $column: String
  ){
  saveUserColumnData (
  id:$id
  data:$data
  column:$column
  ) 
  {
    status
  }
}
`
export const CHECK_USER_INVITE_EXPIRE = gql`
mutation
checkUserInviteExpire(
  $id:ID
  ){
  checkUserInviteExpire (
  id:$id
  ) 
}
`
export const SAVE_STUDENT_NAME = gql`
mutation
  saveStudentName(
  $id:ID
  $fname :String,
  $middle_name :String,
  $lname :String,
  ){
  saveStudentName (
    id:$id
    fname:$fname
    middle_name :$middle_name
    lname :$lname
  ) 
  {
    status
  }
}
`
export const SAVE_USER_NAME = gql`
mutation
  saveUserName(
  $id:ID
  $fname :String,
  $middle_name :String,
  $lname :String,
  ){
  saveUserName (
    id:$id
    fname:$fname
    middle_name :$middle_name
    lname :$lname
  ) 
  {
    status
  }
}
`
export const SAVE_USER_EMAIL_DATA = gql`
mutation
saveUserEmailData(
  $id:ID
  $email: String
   ){
  saveUserEmailData (
  id:$id
  email:$email
   ) 
  {
    status
  }
}
`
export const SAVE_USER_USERNAME_DATA = gql`
mutation
 saveUserUserNameData(
  $id:ID
  $username: String
   )
  {
  saveUserUserNameData (
  id:$id
  username:$username
   ) 
  {
    status
  }
}
`
export const UPDATE_CENTER_UPDATE_TIME = gql`
mutation
 updateCenterUpdateTime(
  $id:ID
  )
  {
  updateCenterUpdateTime (
  id:$id
    ) 
  {
    status
  }
}
`
export const DELETE_CENTER = gql`
mutation
deleteCenter(
  $id:ID
  )
  {
deleteCenter (
  id:$id
    ) 
  {
    status
  }
}
`
export const SAVE_SITE_IMG = gql`
mutation
 saveSiteImg(
  $site:ID
  $img:String
  )
  {
  saveSiteImg (
    site:$site
    img:$img
    ) 
  {
    status
  }
}
`
export const SAVE_SITE_FB_IMAGES = gql`
mutation
saveSiteFbImgs(
  $site:ID
  $imgs:[createSiteImgs]
  )
  {
    saveSiteFbImgs (
    site:$site
    imgs:$imgs
    ) 
  {
    status
  }
}
`
export const CREATE_WEB_TESTIMONIAL = gql`
mutation($site:String,$name:String,$details:String,$img:String,$status:Boolean) {
  addNewWebTestimonial(
    name: $name
    site:  $site
    details:$details
    img: $img
    status: $status
 
  )
  {
     status
     color
     message
  }
}
`
export const UPDATE_WEB_TESTIMONIAL = gql`
mutation($id:ID$site:String,$name:String,$details:String,$img:String,$status:Boolean) {
  updateWebTestimonial(
    id:$id
    name: $name
    site:  $site
    details:$details
    img: $img
    status: $status
  )
  {
     status
     color
     message
  }
}
`
export const GET_WEB_TESTIMONIAL = gql`
mutation($site:String) {
  getWebTestimonial(
    site:$site
  ){
    id
    name
    details
    image
    status
   }
  }
`
export const DELETE_WEB_TESTIMONIAL = gql`
mutation ($id:ID!){
  deleteWebTestimonial(
      id:$id
   )  
   {
        message
        status
        color
     }
    }
`

export const GET_TESTIMONIAL_TEMP = gql`
mutation($site:String) {
  getTestimonialTemp(
    site:$site,
  ){
     template
     data
  }
  
}
`
export const SAVE_TESTIMONIAL_SECTION = gql`
mutation($site:String,$html:String) {
  saveTestimonialsSection(
    site:$site,
     html:$html
  ){
    status
  }
  
}
`
export const GET_STUDENT_HISTORY = gql`
query ($id:ID!){
  student(id:$id) {
    id
    activities{
      activity
      user{
        fname
        lname
      }
      username
      created_at
    }
  }
}
`
export const GET_USER_HISTORY = gql`
query ($id:ID!){
  user(id:$id) {
    id
    activities{
      activity
      user{
        fname
        lname
      }
      username
      created_at
    }
  }
}
`
export const GET_TEACHER_STUDENT_BY_PROGRAMS = gql`
  mutation ($program_id:[ID]){
    programsStudent(program_id:$program_id) {
      id
      fname
      lname
      middle_name
      image
      checked_in_out
    }
  }
`
export const SAVE_BOTTLE_ACTIVITY = gql`
mutation
saveBottleActivity(
    $date: String,
    $time: String,
    $amount: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveBottleActivity (
    date: $date
    time: $time
    amount: $amount
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_KUDOS_ACTIVITY = gql`
mutation
saveKudosActivity(
    $date: String,
    $time: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveKudosActivity (
    date: $date
    time: $time
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_NAME_TO_FACE_ACTIVITY = gql`
mutation
saveNameToFaceActivity(
    $date: String,
    $time: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
    $amount:String
  )
  {
    saveNameToFaceActivity (
    date: $date
    time: $time
    note: $note
    students:$students
    staffOnly:$staffOnly
    amount:$amount
    ) 
  {
    status
  }
}
`
export const SAVE_HEALTH_CHECK_ACTIVITY = gql`
mutation
saveHealthCheckActivity(
    $date: String,
    $time: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
    $amount:String
  )
  {
    saveHealthCheckActivity (
    date: $date
    time: $time
    note: $note
    students:$students
    staffOnly:$staffOnly
    amount:$amount
    ) 
  {
    status
  }
}
`
export const SAVE_MEAL_ACTIVITY = gql`
mutation
saveMealActivity(
    $date: String,
    $time: String,
    $amount: String,
    $type: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveMealActivity (
    date: $date
    time: $time
    amount: $amount
    type:$type
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_NAP_ACTIVITY = gql`
mutation
saveNapActivity(
    $date: String,
    $time: String,
    $end_time: String,
    $nap: Boolean,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveNapActivity (
    date: $date
    time: $time
    end_time:$end_time
    nap: $nap
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_DIAPER_ACTIVITY = gql`
mutation
saveDiaperActivity(
    $date: String,
    $time: String,
    $type: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveDiaperActivity (
    date: $date
    time: $time
    type:$type
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`

export const SAVE_POTTY_ACTIVITY = gql`
mutation
savePottyActivity(
    $date: String,
    $time: String,
    $type: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    savePottyActivity (
    date: $date
    time: $time
    type:$type
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const GET_ACTIVITY_REPORTS = gql`
mutation
getActivityReports(
    $date: String,
  )
  {
    getActivityReports (
    date: $date
    ) 
}
`
export const GET_ACTIVE_CAMERAS = gql`
query getOnlineCameras($location:ID!) 
{
  getOnlineCameras(
    location:$location
  )
}
`

export const SAVE_ACTIVITY_ACTIVITY = gql`
mutation
saveActivityActivity(
    $date: String,
    $time: String,
    $title: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveActivityActivity (
    date: $date
    time: $time
    title:$title
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_SUPPLIES_ACTIVITY = gql`
mutation
saveSuppliesActivity(
    $date: String,
    $time: String,
    $type: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveSuppliesActivity (
    date: $date
    time: $time
    type:$type
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_MED_ACTIVITY = gql`
mutation
saveMedActivity(
    $date: String,
    $time: String,
    $title: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveMedActivity (
    date: $date
    time: $time
    title:$title
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_INCIDENT_ACTIVITY = gql`
mutation
saveIncidentActivity(
    $date: String,
    $time: String,
    $title: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveIncidentActivity (
    date: $date
    time: $time
    title:$title
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_NOTE_ACTIVITY = gql`
mutation
saveNoteActivity(
    $date: String,
    $time: String,
    $title: String,
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveNoteActivity (
    date: $date
    time: $time
    title:$title
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_CHECKIN_ACTIVITY = gql`
mutation
saveCheckinActivity(
    $date: String,
    $time: String,
    $by: String,
    $students:[ID]
    $program:ID,
    $staffOnly:Boolean
  )
  {
    saveCheckinActivity (
    date: $date
    time: $time
    by:$by
    students:$students
    program:$program
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_CHECK_IN_SETTING = gql`
mutation saveCheckinSetting($id:ID,$setting:[CheckinSetting]) {
  saveCheckinSetting(id:$id,setting:$setting) {
          status
  }
}
`
export const GET_CHECK_IN_SETTING = gql`
mutation getCheckinSetting($id:ID,$param:String) {
  getCheckinSetting(id:$id,param:$param) {
          id
          key
          value
  }
}
`
export const GET_USER_HEALTH_QUESTIONS = gql`
mutation getUserHealthQuestionnaire($id:ID) {
  getUserHealthQuestionnaire(id:$id) {
          id
          statement
  }
}
`
export const SAVE_USER_HEALTH_QUESTIONS = gql`
mutation saveUserHealthScreenActivity($student:ID,$date:String,$time:String,$questions:String) {
  saveUserHealthScreenActivity(student:$student,date:$date,time:$time,questions:$questions) {
         status
         message
  }
}`

export const GET_USER_CHECK_IN_SETTING = gql`
mutation getUserCheckinSetting($id: ID) {
  getUserCheckinSetting(id: $id)
}

`

export const SAVE_ABSENT_ACTIVITY = gql`
mutation
saveAbsentActivity(
 
    $students:[ID]
    $date: String
  )
  {
    saveAbsentActivity (
 
    students:$students
    date:$date
    ) 
  {
    status
  }
}
`
export const SAVE_CHECKOUT_ACTIVITY = gql`
mutation
saveCheckoutActivity(
    $date: String,
    $time: String,
    $by: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    saveCheckoutActivity (
    date: $date
    time: $time
    by: $by
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
    message
  }
}
`
export const SAVE_MOVE_CHECKOUT_ACTIVITY = gql`
mutation
saveMoveCheckoutActivity(
    $date: String,
    $time: String,
    $by: String,
    $students:[ID]
    $program:ID
  )
  {
    saveMoveCheckoutActivity (
    date: $date
    time: $time
    by: $by
    students:$students
    program:$program
    ) 
  {
    status
    message
  }
}
`
export const SAVE_PHOTO_ACTIVITY = gql`
mutation
savePhotoActivity(
    $date: String,
    $time: String,
    $photos: [String],
    $note: String,
    $students:[ID]
    $staffOnly:Boolean
  )
  {
    savePhotoActivity (
    date: $date
    time: $time
    photos:$photos
    note: $note
    students:$students
    staffOnly:$staffOnly
    ) 
  {
    status
  }
}
`
export const SAVE_VIDEO_ACTIVITY = gql`
mutation
saveVideoActivity(
    $date: String,
    $time: String,
    $video: String,
    $note: String,
    $students:[ID],
    $thumbnail:String
    $staffOnly:Boolean


  )
  {
    saveVideoActivity (
    date: $date
    time: $time
    video:$video
    note: $note
    students:$students
    thumbnail:$thumbnail
    staffOnly:$staffOnly

    ) 
  {
    status
  }
}
`
export const GET_FILTERED_ACTIVITT_REPORT = gql`
mutation
getFilterActivityReports(
    $date:String
    $isStatus:Boolean
    $isProgram:Boolean
    $statuses:[String]
    $program:[ID]
  )
  {
    getFilterActivityReports (
    date:$date
    isStatus:$isStatus
    isProgram:$isProgram
    statuses:$statuses
    program:$program
    ) 
}
`
export const GET_SINGLE_STUDENT_ACTIVITY_REPORTS = gql`
mutation
getSingleStudentActivityReport(
    $date: String,
    $id:ID
  )
  {
    getSingleStudentActivityReport (
    date: $date
    id:$id
    ){
    data
    date
    end
    }
}
`
export const GET_SINGLE_STUDENT_DAILY_REPORTS = gql`
mutation
getSingleStudentDailyReport(
    $date: String,
    $id:ID
  )
  {
    getSingleStudentDailyReport (
    date: $date
    id:$id
    ) 
}
`
export const GET_SINGLE_STUDENT_FILTERED_ACTIVITY_REPORTS = gql`
mutation
getSingleStudentFilteredActivityReports(
    $to: String,
    $from: String,
    $type: String,
    $id:ID
  )
  {
    getSingleStudentFilteredActivityReports (
    to: $to
    from: $from
    type: $type
    id:$id
    ) 
}
`

export const SEND_ACTIVITY_REPORT = gql`
mutation
sendActivityReport(
    $student:String
    $date:String
    $receivers: [String],
    $emailData: String,
  )
  {
    sendActivityReport (
      student:$student
      date:$date
      receivers: $receivers
      emailData: $emailData
    ) {
      status
      message
    }
}
`
export const UPDATE_BOTTLE_ACTIVITY = gql`
mutation
updateBottleActivity(
    $id:ID
    $date: String,
    $time: String,
    $amount: String,
    $note: String,
    $students:[ID]
  )
  {
    updateBottleActivity (
    id:$id
    date: $date
    time: $time
    amount: $amount
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`

export const UPDATE_MEAL_ACTIVITY = gql`
mutation
updateMealActivity(
    $id:ID
    $date: String,
    $time: String,
    $amount: String,
    $type: String,
    $note: String,
    $students:[ID]
  )
  {
    updateMealActivity (
    id:$id
    date: $date
    time: $time
    amount: $amount
    type:$type
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_NAP_ACTIVITY = gql`
mutation
updateNapActivity(
    $id:ID
    $date: String,
    $time: String,
    $end_time: String,
    $nap: Boolean,
    $note: String,
    $students:[ID]
  )
  {
    updateNapActivity (
    id:$id
    date: $date
    time: $time
    end_time:$end_time
    nap: $nap
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_DIAPER_ACTIVITY = gql`
mutation
updateDiaperActivity(
    $id:ID
    $date: String,
    $time: String,
    $type: String,
    $note: String,
    $students:[ID]
  )
  {
    updateDiaperActivity (
    id:$id
    date: $date
    time: $time
    type:$type
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`

export const UPDATE_POTTY_ACTIVITY = gql`
mutation
updatePottyActivity(
    $id:ID
    $date: String,
    $time: String,
    $type: String,
    $note: String,
    $students:[ID]
  )
  {
    updatePottyActivity (
    id:$id
    date: $date
    time: $time
    type:$type
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`

export const UPDATE_ACTIVITY_ACTIVITY = gql`
mutation
updateActivityActivity(
    $id:ID
    $date: String,
    $time: String,
    $title: String,
    $note: String,
    $students:[ID]
  )
  {
    updateActivityActivity (
    id:$id
    date: $date
    time: $time
    title:$title
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_SUPPLIES_ACTIVITY = gql`
mutation
updateSuppliesActivity(
    $id:ID
    $date: String,
    $time: String,
    $type: String,
    $note: String,
    $students:[ID]
  )
  {
    updateSuppliesActivity (
    id:$id
    date: $date
    time: $time
    type:$type
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_MED_ACTIVITY = gql`
mutation
updateMedActivity(
    $id:ID
    $date: String,
    $time: String,
    $title: String,
    $note: String,
    $students:[ID]
  )
  {
    updateMedActivity (
    id:$id
    date: $date
    time: $time
    title:$title
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_INCIDENT_ACTIVITY = gql`
mutation
updateIncidentActivity(
    $id:ID
    $date: String,
    $time: String,
    $title: String,
    $note: String,
    $students:[ID]
  )
  {
    updateIncidentActivity (
    id:$id
    date: $date
    time: $time
    title:$title
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_NOTE_ACTIVITY = gql`
mutation
updateNoteActivity(
    $id:ID
    $date: String,
    $time: String,
    $title: String,
    $note: String,
    $students:[ID]
  )
  {
    updateNoteActivity (
    id:$id
    date: $date
    time: $time
    title:$title
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_CHECKIN_ACTIVITY = gql`
mutation
updateCheckinActivity(
    $id:ID
    $date: String,
    $time: String,
    $by: String,
    $students:[ID]
  )
  {
    updateCheckinActivity (
    id:$id
    date: $date
    time: $time
    by:$by
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_CHECKOUT_ACTIVITY = gql`
mutation
updateCheckoutActivity(
    $id:ID
    $date: String,
    $time: String,
    $by: String,
    $students:[ID]
  )
  {
    updateCheckoutActivity (
    id:$id
    date: $date
    time: $time
    by: $by
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_PHOTO_ACTIVITY = gql`
mutation
updatePhotoActivity(
    $id:ID
    $date: String,
    $time: String,
    $photos: [String],
    $note: String,
    $students:[ID]
  )
  {
    updatePhotoActivity (
    id:$id
    date: $date
    time: $time
    photos:$photos
    note: $note
    students:$students
    ) 
  {
    status
  }
}
`
export const UPDATE_VIDEO_ACTIVITY = gql`
mutation
updateVideoActivity(
    $id:ID
    $date: String,
    $time: String,
    $video: String,
    $note: String,
    $students:[ID],
    $thumbnail:String

  )
  {
    updateVideoActivity (
    id:$id
    date: $date
    time: $time
    video:$video
    note: $note
    students:$students
    thumbnail:$thumbnail

    ) 
  {
    status
  }
}
`
export const DELETE_DAILY_ACTIVITY = gql`
  mutation
  deleteDailyActivity(
    $id:ID
    $student:ID
  ){
    deleteDailyActivity (
      id:$id,
      student:$student
    )
    {
      status
    }
  }
`
export const CHECK_STUDENT_PROFILE_PERMISSION = gql`
  mutation
  checkStudentProfilePermission(
    $id:ID   
  ){
    checkStudentProfilePermission(
      id:$id
    )
    {
      found
      permission
    }
  }
`
export const UPDATE_USER_CHECKIN_CODE = gql`
  mutation
  updateUserCheckinCode(
    $id:ID   
    $code:String
  ){
    updateUserCheckinCode(
      id:$id
      code:$code
    ){
      status
    }
  }
`
export const GET_STUDENT_EDIT_PERMISSIONS = gql`
  query
  getStudentEditPermissions(
    $location:ID!   
  ){
    getStudentEditPermissions(
      location:$location 
    ){
      can_edit_student
      can_edit_fields
    }
  }
`

export const UPDATE_USER_PERMISSION_STUDENT = gql`
  mutation
  updateUserPermissionStudent(
    $id:ID!
    $fname: String
    $lname: String
    $middle_name: String
    $nick_name: String
    $dob:String
    $image:String
    $gender:String
    $race:String
    $ethnicity:String
    $allergies:[ID]
    $medications:[ID]
    $drname:String
    $drphone:String
    $note:String
  ){
    updateUserPermissionStudent (
      id:$id,
      input: {
      fname:$fname,
      lname:$lname,
      middle_name:$middle_name,
      nick_name:$nick_name,
      dob:$dob,
      image:$image,
      gender:$gender,
      race:$race,
      ethnicity:$ethnicity, 
      allergies:$allergies, 
      medications:$medications,
      drname:$drname, 
      drphone:$drphone, 
      note:$note     
    }) {
      status
      message
      id
    }
  }
`
export const UPDATE_LOCATION_CHECKIN_QR = gql`
  mutation
  updateLocationCheckinQr(
    $id:ID   
    $type:Boolean
  ){
    updateLocationCheckinQr(
      id:$id 
      type:$type
    )
  }
`
export const CHECK_VALID_CHECK_IN_OUT = gql`
  mutation
  checkValidCheckInOut(
    
    $code:String
    $date:String
  ){
    checkValidCheckInOut(
     
      code:$code
      date:$date
    )
    {
      user{
             id
             fname
             lname
          }
          students{
            id
            fname
            lname
            middle_name
            image
            checked_in_out
            program{
              id
              name
              color_code
              }
          }
          status
          type
          programs{
          id 
          name
          color_code
          }
          program_status
          attendance{
            id
            start_time
          }
          signature
    }
  }
`
export const GET_STUDENTS_AFTER_CHECK_IN_LOCATION = gql`
  mutation
  getStudentsAfterCheckInLocation(
    $id:ID
    $date:String
  ){
    getStudentsAfterCheckInLocation(
      id:$id,
      date:$date
    )
    {
      id
      fname
      lname
      middle_name
      image
      checked_in_out
      program{
        id
        name
        color_code
        }
    }
  }
`


export const SAVE_USER_STUDENT_CHECK_IN_OUT_ACTIVITY = gql`
  mutation
  saveUserStudentCheckInOutActivity(
    $students:String,
    $date:String
    $time:String
  ){
    saveUserStudentCheckInOutActivity(
      students:$students
      date:$date
      time:$time
    )
    {
      status
    }
  }

`
export const SAVE_HEALTH_QUESTIONNAIRE = gql`
  mutation
  saveHealthQuestionnaire(
    $location:ID!,
    $questionnaire:[UpdateHealthQuestionnaire]
    $delete:[ID]
  ){
    saveHealthQuestionnaire(
      location:$location
      questionnaire:$questionnaire
      delete:$delete
    )
    {
      status
    }
  }
  `
export const DELETE_HEALTH_QUESTIONNAIRE = gql`
  mutation
  deleteHealthQuestionnaire(
    $id:ID,
   
  ){
    deleteHealthQuestionnaire(
      id:$id
    
    )
    {
      status
    }
  }
  `
  
export const GET_HEALTH_QUESTIONNAIRE = gql`
  mutation
  getHealthQuestionnaire(
    $id:ID,
    $param:String,

    
  ){
    getHealthQuestionnaire(
      id:$id,
      param:$param
     
    )
    {
      id
      statement
    }
  }
  `
export const VALIDATE_USER_CHECKIN_PIN = gql`
  mutation
  validateUserCheckinPin(
    $pin:String
  ){
    validateUserCheckinPin(
      pin:$pin
    )
  }
`
export const GET_STAFF_CHECKIN_QR = gql`
query GetStaffCheckINQR {
  getStaffCheckinQr  
}
`

export const GET_STUDENT_BY_USER_CHECKIN_PIN = gql`
  mutation
  getStudentByUserCheckinPin(
    $pin:String
    $location:ID!
    $date:String
  ){
    getStudentByUserCheckinPin(
      pin:$pin
      location:$location
      date:$date
    ){
    students{
      id
      fname
      lname
      middle_name
      image
      checked_in_out
      program{
        id
        name
        color_code
        }
    }
    user
    status
  }}
`
export const GET_LOCATION_CHECKIN_QR_SETTING = gql`
  mutation
  getLocationCheckinQrSetting(
    $location:ID!
  ){
    getLocationCheckinQrSetting(
      location:$location
    )
  }
`

export const GET_CHECKIN_QR_LOCATIONS = gql`
query getCheckinQrLocations {
  getCheckinQrLocations  {
      id
      name
  }
}
`

export const UPDATE_LOCATION_SETTINGS_QR_EXPIRE = gql`
  mutation
  updateLocationSettingsQrExpire(
  $id: ID!,
  $check_in_qr_expire:String
  ){
    updateLocationSettingsQrExpire (
      id:$id,
      check_in_qr_expire:$check_in_qr_expire
      ){
       status
    }
  }
`
export const GET_LOCATION_CHECKIN_QR_EXPIRE = gql`
  query ($id:ID!){
    getLocationCheckinQrExpire(id:$id) {
      status
      value
    }
  }
`
export const GET_STUDENT_BY_USER_CHECKIN_PIN_PHONE = gql`
  mutation
  getStudentByUserCheckinPinPhone(
    $pin:String
    $phone:String
    $location:ID!
    $date:String
  ){
    getStudentByUserCheckinPinPhone(
      pin:$pin
      phone:$phone
      location:$location
      date:$date
    ){
    students{
      id
      fname
      lname
      middle_name
      image
      checked_in_out
      program{
        id
        name
        color_code
        }
    }
    user
    status
  }}
`
export const UPDATE_LOCATION_PARENT_NOTIFICATION_SETTINGS = gql`
  mutation
  updateLocationParentNotificationSettings(
  $id: ID!,
  $alert:Boolean
  $email:Boolean
  $sms:Boolean
  $app:Boolean
  $time:String
  $report:Boolean
  $reportTime:String
  ){
    updateLocationParentNotificationSettings (
      id:$id,
      alert:$alert,
      email:$email
      sms:$sms
      app:$app
      time:$time
      report:$report
      reportTime:$reportTime
      ){
       status
    }
  }
`
export const GET_LOCATION_PARENT_NOTIFICATION_SETTINGS = gql`
  query ($id:ID!){
    getLocationParentNotificationSettings(id:$id) {
      check_in_parent_alert
      check_in_parent_alert_email
      check_in_parent_alert_sms
      check_in_parent_alert_app
      check_in_parent_alert_time
      send_parent_activity_report_time
      send_parent_activity_report
    }
  }
`
export const GET_LOG_REPORT_BY_USER = gql`
  mutation($id:ID) {
    getLogReportByUser(
      id: $id
    )
    {
      id
      object_type
      object_id
      activity
      created_at
      updated_at
      user{
        id
        fname
        lname
      }
    }
  }
`
export const INCIDENTS_LIST = gql`
  mutation {
    incidentsList
    {
    status
    incidents 
    }
    }
`
export const REQUEST_MAIN_INCIDENT = gql`
  mutation
  requestMainIncident(
    $name: String
    $details:String
    $status:String
    $location:String!
    $requested_by: String
    $times:[RequestIncidentTime]
    $center:ID
  ){
    requestMainIncident (input: {
      name:$name,
      details:$details,
      status:$status,
      location:$location,
      requested_by:$requested_by,
      times:$times
      center:$center
    }) {
     status
      }
  }
`
export const UPDATE_MAIN_INCIDENT = gql`
  mutation
  updateMainKVIncident(
    $id:ID
    $name: String
    $details:String
    $status:String
    $location:String!
    $times: [UpdateIncidentTime]
    $center:ID
  ){
    updateMainKVIncident (
    id:$id,
    input: {
      name:$name,
      details:$details,
      status:$status
      location:$location,
      times:$times
      center:$center
    }) {
       status
       message
       color
      }
  }
`
export const PM2_RESTART = gql`
mutation Pm2Restart {
  Pm2Restart{
    status
    message
    pm2
  }
}
`

export const GET_USER_CAMERA_REPORT_BREAKS = gql`
  mutation
  userCameraReportBreaks(
  $id: ID,
  $filter:String
  $start_date:String
  $end_date:String
  ){
    userCameraReportBreaks (
      id:$id,
      filter:$filter
      start_date:$start_date
      end_date:$end_date
      ) 
  }
`
export const GET_EMAIL_AND_SMS_LOG_COUNT = gql`
  mutation
  getEmailAndSmsLogCount(
 
  $filter:String
  $start_date:String
  $end_date:String
  ){
    getEmailAndSmsLogCount (
      filter:$filter
      start_date:$start_date
      end_date:$end_date
      ) 
  }
`
export const GET_USER_APP_NOTIFICATION_SETTINGS = gql`
  query ($id:ID!){
    getUserAppNotificationSettings(id:$id) {
      push_notification
      food_notification
      nap_notification
      meds_notification
      activity_notification
      notes_notification
      checks_notification
      msgs_notification
      media_notification
      kudos_notification
      health_check_notification
      name_to_face_notification
    }
  }
`
export const UPDATE_USER_APP_NOTIFICATION_SETTINGS = gql`
  mutation
  updateUserAppNotificationSettings(
      $id: ID,
      $push_notification:Boolean,
      $food_notification:Boolean,
      $nap_notification:Boolean,
      $meds_notification:Boolean,
      $activity_notification:Boolean,
      $notes_notification:Boolean,
      $checks_notification:Boolean,
      $media_notification:Boolean,
      $msgs_notification:Boolean,
      $kudos_notification:Boolean,
      $health_check_notification:Boolean,
      $name_to_face_notification:Boolean
  ){
    updateUserAppNotificationSettings (
      input: {
      id:$id,
      push_notification:$push_notification
      food_notification:$food_notification
      nap_notification:$nap_notification
      meds_notification:$meds_notification
      activity_notification:$activity_notification
      notes_notification: $notes_notification
      checks_notification:$checks_notification
      media_notification:$media_notification
      msgs_notification:  $msgs_notification
      kudos_notification:$kudos_notification
      health_check_notification:$health_check_notification
      name_to_face_notification:$name_to_face_notification
        }
      ) {
       status
       message
       color
      }
  }
`
export const SAVE_FCM_TOKEN = gql`
mutation
saveFcmToken(
    $token: String,
    $device: String,
  )
  {
    saveFcmToken (
    token: $token
    device: $device
    ) 
  {
    status
  }
}
`
export const GET_NOTIFICATION_SHOT_LIST = gql`
query getNotificationShortList {
  getNotificationShortList 
}
`
export const GET_NOTIFICATION_LONG_LIST = gql`
query getNotificationLongList {
  getNotificationLongList 
}
`
export const MARK_SEEN_NOTIFICATION = gql`
mutation
markSeenNotification(
    $id: ID,
    )
  {
    markSeenNotification (
      id: $id
    ) 
  {
    status
  }
}
`
export const MARK_SEEN_NOTIFICATION_ALL = gql`
mutation
markSeenNotificationAll 
  {
    markSeenNotificationAll  
  {
    status
  }
}
`
export const GET_USER_STUDENTS_CAMERAS = gql`
mutation ($id:ID!){
  getUserStudentsCameras(id:$id) {
    id
    fname
    type
    location_id
    cameras{
        id
        name
        color_code
        code
        camera_id
    location_setting{
      id
      name
      location_camera_setting{
        id
        key
        value
      }
    }
    location{
        id
        name
    }
    }
    }
    }
`
export const GET_ROOM_RATIO = gql`
query getRoomRatio($location:ID!,$date:String) {
  getRoomRatio(location:$location,date:$date)
}
`
export const UPLOAD_ADVANDCE_ONBOARDING = gql`
  mutation
  uploadAdvanceOnbording(
    $file:Upload
    $location:ID!
  ){
    uploadAdvanceOnbording (file:$file,location:$location) {
       status
       students
       relations
       errors
       kvcolumns
       filecolumns
       filepath
    }
  }
`
export const UPLOAD_BRIGHT_WHEEL_ROSTER = gql`
  mutation
  uploadBrightWheelRoster(
    $file:Upload
    $location:ID!
  ){
    uploadBrightWheelRoster (file:$file,location:$location) 
  }
`
export const UPLOAD_CSV_FILE_FRAMEWORK = gql`
  mutation
  importFrameworksCSVFile(
    $location:ID!,
    $file:Upload
  ){
    importFrameworksCSVFile (file:$file,location:$location) {
      status
      message
    }
  }
`
export const SAVE_ADVANDCE_ONBOARDING_DATA = gql`
  mutation
  saveAdvanceOnbordingData(
     $students:String
  ){
    saveAdvanceOnbordingData (students:$students) {
       status
      
    }
  }
`
export const UPLOAD_PROCARE_FILE = gql`
  mutation
  uploadProcareFile(
    $file:Upload
    $location:ID!
  ){
    uploadProcareFile (file:$file,location:$location) {
       status
       students
       relations
       errors
       kvcolumns
       filecolumns
       filepath
    }
  }
`
export const UPLOAD_PROCARE_STAFF_FILE = gql`
  mutation
  uploadProcareStaffFile(
    $file:Upload
    $location:ID!
  ){
    uploadProcareStaffFile (file:$file,location:$location) {
       status
       students
       relations
       errors
       kvcolumns
       filecolumns
       filepath
    }
  }
`
export const GET_ATTANDANCE_TEAM = gql`
mutation getAttandanceTeam($program_id:ID,$date:String){
  getAttandanceTeam(program_id: $program_id,date:$date) 
  {
    id
    fname
    lname
    check_in_program
    avatar
  }
}
`
export const SAVE_ATTENDANCE_TEAM = gql`
  mutation
  saveAttendanceTeam($program_id:ID,$action:Boolean,$team:ID,$time:String,$date:String){
    saveAttendanceTeam (program_id:$program_id,action:$action,team:$team,time:$time,date:$date) {
       status 
    }
  }
`
export const GET_PROGRAM_BY_STAFF_PIN = gql`
  mutation
  getProgramByStaffPin(
    $pin:String
  ){
    getProgramByStaffPin(
      pin:$pin
    ){
      program{
      id
      name
      color_code
      }
      status
      
     }
     }
`
export const CREATE_TAG = gql`
mutation($name:String,$type:String,$location:ID!) {
  addNewTag(
    name: $name
    type: $type
    location:$location

   )
  {
     status
     color
     message
  }
}
`
export const UPDATE_TAG = gql`
mutation($id:ID,$name:String) {
  updateTag(
    id:$id
    name: $name
   )
  {
     status
     color
     message
  }
}
`
export const DELETE_TAG = gql`
mutation($id:ID!) {
  deleteTag(
    id: $id
  )
  {
    message
    status
    color
    refresh
  }
}
`
export const GET_ALL_TAGS = gql` 
query tags ($location_id:ID!) {
  tags(location_id:$location_id) {
    id
    name
    student_count
    user_count
  }
}
`
export const UPDATE_STUDENT_ASSIGN_TAGS = gql`
mutation($id:ID,$tags:[StudentAssignTags],$location:ID!) {
  updateStudentAssignTag(
    id:$id
    tags: $tags
    location:$location
   )
  {
     status
     color
     message
  }
}
`
export const UPDATE_STUDENT_ASSIGN_ALLERGIES = gql`
mutation($id:ID,$allergies:[StudentAssignTags],$location:ID!) {
  updateStudentAssignAllergies(
    id:$id
    allergies: $allergies
    location:$location
   )
  {
     status
     color
     message
  }
}
`
export const UPDATE_STUDENT_ASSIGN_MEDICATIONS = gql`
mutation($id:ID,$medications:[StudentAssignTags],$location:ID!) {
  updateStudentAssignMedications(
    id:$id
    medications: $medications
    location:$location
   )
  {
     status
     color
     message
  }
}
`
export const UPDATE_USER_ASSIGN_TAGS = gql`
mutation($id:ID,$tags:[String],$location:ID!) {
  updateUserAssignTag(
    id:$id
    tags: $tags,
    location:$location
   )
  {
     status
     color
     message
  }
}
`
export const GET_ALL_TAGSDROPDOWN = gql`
query tags ($location_id:ID!) {
  tags(location_id:$location_id) {
    id
    name
  }
}
`
export const GET_ALL_STUDENT_TAGSDROPDOWN = gql`
query tags ($location_id:ID!) {
  tags(location_id:$location_id) {
    id
    name
    student_count
  }
}
`
export const GET_ALL_ALLERGIES_DROPDOWN = gql`
query allergies ($location_id:ID!) {
  allergies(location_id:$location_id) {
    id
    name
  }
}
`
export const GET_ALL_MEDICATIONS_DROPDOWN = gql`
query medications ($location_id:ID!) {
  medications(location_id:$location_id) {
    id
    name
  }
}
`
export const SAVE_BRIGHTWHEEL_SYNC_DATA = gql`
  mutation
  saveBrightWheelSyncData(
     $students:String
  ){
    saveBrightWheelSyncData (students:$students) {
       status
       message
       color
      
    }
  }
`
export const CHECK_LOCATION_TIMEZONE_DETAIL = gql`
  mutation (
  
  $timezone:String
){
  checkLocationTimezoneDetail( 
  timezone:$timezone
) 
  }
`
export const GET_STUDENT_DEFAULT_ADDRESS = gql`
  query ($location:ID!){
    getStudentDefaultAddress(location:$location) {
      default_city
      default_state
      default_zip
      status
    }
  }
`
export const CREATE_CALENDAR_EVENT = gql`
  mutation
  createCalendarEvent(
     $name:String,
     $details:String,
     $date:String,
     $start_time:String,
     $end_time:String,
     $location:ID!,
     $program:[ID],
     $recursing:String,
     $days:String,
  ){
    createCalendarEvent (
      name:$name,
      details:$details,
      date:$date,
      start_time:$start_time,
      end_time:$end_time,
      location:$location,
      program:$program,
      recursing:$recursing,
      days:$days,
     ) {
       status
       message
       color
      
    }
  }
`
export const UPDATE_CALENDAR_EVENT = gql`
  mutation
  updateCalendarEvent(
     $id:ID
     $name:String,
     $details:String,
     $date:String,
     $start_time:String,
     $end_time:String,
     $location:ID!,
     $program:[ID],
     $type:String,
  ){
    updateCalendarEvent (
      id:$id,
      name:$name,
      details:$details,
      date:$date,
      start_time:$start_time,
      end_time:$end_time,
      location:$location,
      program:$program
      type:$type
     ) {
       status
       message
       color
      
    }
  }
`
export const DELETE_CALENDAR_EVENT = gql`
mutation($id:ID!,$type:String) {
  deleteCalendarEvent(
    id: $id
    type:$type
  )
  {
    message
    status
    color
  }
}
`
 
 
export const GET_SINGLE_STUDENT_CHAT_COUNTER = gql`
mutation($id:ID) {
  getSingleStudentChatCounter(
    id: $id
  )
}
`
export const GET_SINGLE_PROGRAM_CHAT_COUNTER = gql` 
mutation($id:ID) {
  getSingleProgramChatCounter(
    id: $id
  ){
    id
    name
    color_code
    counter
    message{
      id
      message
      created_at
    }
  }
}
`
export const FILTER_CALENDAR_EVENTS = gql`
  mutation($location:ID!,$program_ids:[ID],$date:String) {
    filterCalendarEvents(
      location:$location
      program_ids:$program_ids
      date: $date
    )
    {
        id
        name
        details
        date
        start_time
        end_time
        recursive_id
        location{
          id
          name
          color_code
        }
        programs{
        id
        name
        location_id
        color_code
        }
    }
  }
`
export const ADD_NEW_FOOD_MENU = gql`
mutation($location:ID!,$item:String) {
  addNewFoodMenu(
    location:$location
    item:$item
  )
  { 
   status
   message
   color
  }
  
}
`
export const UPDATE_FOOD_MENU = gql`
mutation($id:ID,$name:String) {
  updateFoodMenu(
    id:$id
    name:$name
  )
  { 
    status
  }
  
}
`
export const GET_ALL_FOOD_MENU = gql`
mutation($location:ID!) {
  getAllFoodMenu(
    location:$location
  )
  { 
    id
    name
    status
  }
  
}
`
export const CHANGED_FOOD_MENU_STATUS = gql`
mutation($active:[ID],$available:[ID]) {
  changedFoodMenuStatus(
    active:$active
    available:$available
  )
  { 
    status
  }
  
}
`
export const DELETE_FOOD_MENU = gql`
mutation($id:ID) {
  deleteFoodMenu(
    id:$id
  )
  { 
    status
  }
  
}
`
export const GET_LOCATION_FOOD_MENU_WEEKS = gql`
mutation($location:ID!) {
  getLocationFoodMenuWeeks(
    location:$location
  )
  { 
    id
    name
    status
    date
    current_week
  }
  
}
`
export const ADD_LOCATION_FOOD_MENU_WEEK = gql`
mutation($location:ID!) {
  addLocationFoodMenuWeek(
    location:$location
  )
  {
    status
  }
}
`
export const DELETE_LOCATION_FOOD_MENU_WEEK = gql`
mutation($week:String) {
  deleteLocationFoodMenuWeek(
    week:$week
  )
  { 
    status
  }
  
}
`
export const SET_LOCATION_FOOD_MENU_CURRENT_WEEK = gql`
mutation($week:String,$location:ID!) {
  setLocationFoodMenuCurrentWeek(
    week:$week,
    location:$location
  )
  { 
    status
  }
  
}
`
export const ADD_LOCATION_WEEK_MENU_ITEMS = gql`
mutation($data:String,$week:String,$location:ID!) {
  addLocationWeekMenuItems(
    data:$data
    week:$week
    location:$location
  )
  { 
   status
   message
   color
  }
  
}
`
export const GET_LOCATION_MENU_WEEK_DATA = gql`
mutation($week:String,$location:ID!) {
  getLocationWeekData(
    week:$week
    location:$location
  )
  { 
    data
    status
  }
  
}
`
export const COPY_LOCATION_MENU_TO_WEEKS = gql`
mutation($week:ID,$toweek:[ID]) {
  copyLocationMenutoWeek(
    week:$week
    toweek:$toweek
  )
  {
    status
  }
  
}
`
export const GET_ALL_LOCATION_AUTOFILL_MENU_DATA = gql`
mutation($location:ID!) {
  getAllLocationAutofillMenuData(
    location:$location
   )
   {
     id
     item
     type {
      id 
      name
     }
  }
  
}
`

export const GET_LOCATION_AUTOFILL_MENU_DATA = gql`
mutation($item:String) {
  getLocationAutofillMenuData(
    item:$item
  )
}
`

export const GET_LOCATION_FOOD_MENU_SETTING = gql`
mutation($location:ID!) {
  getLocationFoodMenuSetting(
    location:$location
  )
  { 
    week
    rotate
  }
  
}
`
export const SET_LOCATION_FOOD_MENU_SETTING = gql`
mutation($location:ID!,$rotate:String,$week:String) {
  setLocationFoodMenuSetting(
    location:$location,
    rotate:$rotate,
    week:$week
  )
  { 
    status
  }
  
}
`
export const LOCATION_TOTAL_COUNTER = gql`
query  LocationTotalCounter($location:ID!) {
  LocationTotalCounter(
    location:$location
  ){
    invited
    pending
    students
    users
    programs
    managers
    teachers
    waitlist
    }
}
`
export const GET_LOCATION_UPCOMING_BIRTHDAY = gql` 
mutation(
$date:String!,
$location:ID!
) {
locationStudentsBirthday (
 date:$date,
 location:$location
)
{
    id
    fname
    lname
    image
    dob
    age
    day
 }
 }
`
export const CHAT_LOCATION_STUDENTS = gql`
query chatLocationStudents($location:ID!,$program:ID,$tags:[ID]) {
  chatLocationStudents(location:$location,program:$program,tags:$tags) 
}
`
export const CHAT_LOCATION_PROGRAMS = gql`
query chatLocationPrograms($location:ID!){
  chatLocationPrograms(location:$location){
    id
    name
    color_code
    counter
    message{
      id
      message
      created_at
    }
  }
}
`
export const GET_STUDENTS_COUNTER_AND_LAST_MSG = gql` 
query($id:[ID]) {
  getStudentsCountersAndLastMsg(
    id: $id
  ){
    id
    message{
      id
      message
      created_at
      counter
    }
  }
}
`
export const CHECK_USER_PROFILE_PERMISSION = gql`
  mutation
  checkUserProfilePermission(
    $id:ID   
  ){
    checkUserProfilePermission(
      id:$id
    ){
      found
      permission
    }
  }
`
export const UPDATE_STUDENT_USER_RELATION = gql`
mutation($student:ID,$user:ID,$relation:String) {
  updateStudentUserRelation(
    student:$student,
    user:$user,
    relation:$relation
  )
  { 
    status
  }
  
}
`
export const GET_RELATION_TYPES = gql`query AllRelationshipsType {
  relationship_types{
    id
    name
  }
  }
`
export const GET_ALL_RELATIONS = gql`query AllUsersRelationships {
  relationships{
    id
    name
    is_default
    legal_guardian
    relationship_type{
      id
      name
    }
  }
  }
`
export const CREATE_RELATION = gql`
mutation($name:String,$type:String) {
  addNewRelation(
    name: $name
    type: $type
   )
  {
     status
     color
     message
  }
}
`
export const UPDATE_RELATION = gql`
mutation($id:ID,$name:String,$type:String) {
  updateRelation(
    id:$id
    name: $name
    type:$type
   )
  {
     status
     color
     message
  }
}
`
export const DELETE_RELATION = gql`
mutation($id:ID!) {
  deleteRelation(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const GET_STUDENT_DROPDOWN_BY_PROGRAMS = gql`
  mutation ($program_id:[ID]){
    programsStudent(program_id:$program_id) {
      id
      fname
      lname
      middle_name
      image
      type
    }
  }
`
export const CREATE_STUDENT_SCHEDULE_MODULE = gql`
  mutation ($program:ID,$type:String,$schedule:String,$student:[ID],$start_date:String,$end_date:String,$days:String,$start_time:String,$end_time:String)
  {
    createStudentScheduleModule(
      schedule:$schedule
      type:$type
      student:$student
      program:$program
      start_date:$start_date
      end_date:$end_date
      start_time:$start_time
      end_time:$end_time
      days:$days
    )
    {
      status
      message
      color
    }
  }
`
export const CREATE_STAFF_SCHEDULE_MODULE = gql`
  mutation ($type:String,$teams:[ID],$program:ID,$repeat:Boolean,$date:String,$start_date:String,$end_date:String,$start_time:String,$end_time:String,$days:[String],$note:String)
  {
    createStaffScheduleModule(
      type:$type
      teams:$teams
      program:$program 
      repeat:$repeat
      date:$date
      start_date:$start_date
      end_date:$end_date
      start_time:$start_time
      end_time:$end_time
      days:$days
      note:$note
    )
    {
      status
      message
      color
    }
  }
`
export const FILTER_STAFF_SCHEDULE = gql`
  mutation($location:ID!,$start_date:String,$end_date:String,$program:ID) {
    filterStaffSchedule(
      location:$location
      start_date: $start_date,
      end_date: $end_date,
      program:$program
    )
    { 
      user{
        id
        fname
        lname
        middle_name
        avatar
      }
      user_schedules{
      date
      schedules{
         id
         start_date
         end_date
         start_time
         end_time
         type
         days
         repeate
         note
         program{
           id
           name
         }
      }
      absences{
         id
         start_date
         end_date
         start_time
         end_time
         note
         repeate
         type
      }
      ptos {
         id
         start_date
         end_date
         start_time
         end_time
         note
         repeate
         type
        }
      }
    }
  }
`
export const GET_SCHOOL_NAME_AND_SETTING = gql`
query getSchoolNameWithSetting($location:ID!){
  getSchoolNameWithSetting(location:$location){
    school_name
    camera_login
  }
}
`
export const UPDATE_USER_CAN_PICKUP = gql`
mutation
updateUserCanPickup($id: ID!,$user_id:ID!,$pickup: Boolean!){
  updateUserCanPickup (
    id:$id,
    user_id:$user_id
    pickup:$pickup
    ) {
    status
  }
}
`
export const UPDATE_STUDENT_PAYER = gql`
mutation
updateStudentPayer($id: ID!,$user_id:ID!,$payer: Boolean!){
  updateStudentPayer (
    id:$id,
    user_id:$user_id
    payer:$payer
    ) {
    status
  }
}
`
export const GET_CURRENT_SECTION = gql`
mutation
getCurrentSection{
  getCurrentSection 
}
`
export const CHECK_USER_SESSION = gql`
mutation checkUserSession($email: String!, $password: String!,$session_id:String) {
  checkUserSession( 
    username:$email,
    password: $password,
    session_id:$session_id
  ){
    status
    device
  }
}`
export const DETACH_USER_FROM_STUDENT = gql` 
mutation detachUserFromStudent($id: ID,$student:ID,$sibling:Boolean) {
  detachUserFromStudent(
    id:$id
    student:$student,
    sibling:$sibling
  ) {
    status
    color
    message
   }
}`

export const VIEW_CENTER_STATISTICS = gql`
  mutation
  viewCenterStatistics($id: ID){
    viewCenterStatistics (id: $id) {
      status
      students
      users
      locations
    }
  }
`
export const SAVE_CENTER_STREAM_SETTINGS = gql`
  mutation
  saveCenterStreamSettings(
    $id: ID,$server:String,$width:String,$height:String,$full_screen:String,$location:ID){
      saveCenterStreamSettings (id: $id,server:$server,width:$width,height:$height,full_screen:$full_screen,location:$location)  
  }
`
export const VIEW_STREAM_SETTINGS = gql`
  mutation
  viewStreamSettings($id: ID){
    viewStreamSettings (id: $id)  
  }
`
export const STUDENT_MONTH_SCHEDULE = gql`
mutation($id:ID) {
  getStudentMontlySchedule(
    id: $id
  ){
    dates
    infinit_date
    absences
    vacations
  }
}
`
export const CREATE_STUDENT_SCHEDULE_VACATION = gql`
  mutation ($type:String,$student:[ID],$start_date:String,$end_date:String,$reason:String,$note:String)
  {
    createStudentScheduleVacation(
      type:$type
      student:$student
      start_date:$start_date
      end_date:$end_date
      reason:$reason
      note:$note
    )
    {
      status
      message
      color
    }
  }
`
export const UPDATE_STUDENT_SCHEDULE_VACATION = gql`
  mutation ($type:String,$student:ID,$start_date:String,$end_date:String,$old_start_date:String,$old_end_date:String)
  {
    updateStudentScheduleVacation(
      type:$type
      student:$student
      start_date:$start_date
      end_date:$end_date
      old_start_date:$old_start_date
      old_end_date:$old_end_date
    )
    {
      status
      message
      color
    }
  }
`
export const GET_STUDENT_MONTH_SCHEDULE_LIST = gql`
mutation($id:ID) {
  getStudentMonthScheduleList(
    id: $id
  )
}
`

export const DELETE_STUDENT_SCHEDULE_VACATION = gql`
  mutation ($type:String,$student:ID,$old_start_date:String,$old_end_date:String)
  {
    deleteStudentScheduleVacation(
      type:$type
      student:$student
      old_start_date:$old_start_date
      old_end_date:$old_end_date
    )
    {
      status
      message
      color
    }
  }
`
export const ADD_SCHEDULE_NEW_DATE = gql`
mutation($id:ID,$date:String,$schedule:String) {
  addScheduleNewDate(
    id: $id
    date:$date
    schedule:$schedule
  ){
    status
  }
}
`
export const REMOVE_SCHEDULE_NEW_DATE = gql`
mutation($id:ID,$date:String,$schedule:String) {
  removeScheduleNewDate(
    id: $id
    date:$date
    schedule:$schedule
  ){
    status
  }
}
`
export const DELETE_STUDENT_SCHEDULE_MODULE = gql`
mutation($id:ID) {
  removeStudentScheduleModule(
    id: $id
  ){
    status
  }
}
`
export const UPDATE_STUDENT_SCHEDULE_MODULE = gql`
  mutation ($schedule:String,$id:ID,$start_date:String,$end_date:String,$days:String,$program:String,$start_time:String,$end_time:String)
  {
    updateStudentScheduleModule(
      schedule:$schedule
      program:$program
      id:$id
      start_date:$start_date
      end_date:$end_date
      start_time:$start_time
      end_time:$end_time
      days:$days
    )
    {
      status
      message
      color
    }
  }
`

export const GENERATE_LOCATION_TIME_CLOCK_LINK = gql`
mutation($id:ID) {
  generateLocationTimeclockLink(
    id: $id
  ){
     url 
     active
     signature
  } 
}
`
export const GET_LOCATION_TIME_CLOCK_LINK = gql`
mutation($id:ID) {
  getLocationTimeclockLink(
    id: $id
  ){
     url 
     active
     signature
  } 
}
`
export const GET_LOCATION_BY_TIME_CLOCK_LINK = gql`
mutation($parm:String,$device:String,$device_token:String) {
  getLocationByTimeclockLink(
    parm: $parm
    device:$device
    device_token:$device_token
  ) 
}
`
export const GET_LEARNING_FRAMEWORKS = gql`
mutation($location:ID!) {
  getLearningFrameworks(
    location: $location
  ) 
}
`
export const GET_SINGLE_PLAN = gql`
mutation($id:ID) {
  getSingleLessonPlan(
    id: $id
  ) 
}
`
export const GET_SINGLE_ROOM_PLAN = gql`
mutation($id:ID) {
  getSingleRoomPlan(
    id: $id
  ) 
}
`
export const ASSIGN_PLAN_ROOMS = gql`
mutation($id:ID,$date:String,$room:[ID]) {
  assignPlanRoom(
    id: $id,
    date:$date,
    room:$room
  ){
    status
  } 
}
`
export const ASSIGN_ROOM_PLAN_DATE = gql`
mutation($id:ID,$date:String,$weekend:Boolean,$room:ID) {
  assignRoomPlanDate(
    id: $id,
    date:$date,
    weekend:$weekend,
    room:$room
  ){
    status
  } 
}
`

export const REMOVE_ROOM_PLAN_DATE = gql`
mutation($id:ID) {
  removeRoomPlanDate(
    id: $id,
  ){
    status
  } 
}
`
export const UPDATE_ROOM_PLAN_THEME = gql`
mutation($id:ID,$name:String) {
  updateRoomPlanTheme(
    id: $id,
    name:$name
  ){
    status
  } 
}
`


export const DELETE_LESSON_PLAN = gql`
mutation($id:ID) {
  deleteLessonPlan(
    id:$id
  ){
    status
  } 
}
`
export const DELETE_ROOM_PLAN = gql`
mutation($id:ID) {
  deleteRoomPlan(
    id:$id
  ){
    status
  } 
}
`

export const SAVE_PLAN_NOTES = gql`
mutation($id:ID,$notes:String) {
  savePlanNotes(
    id: $id,
    notes:$notes,
   
  ){
    status
  } 
}
`
export const SAVE_ROOM_PLAN_NOTES = gql`
mutation($id:ID,$notes:String) {
  saveRoomPlanNotes(
    id: $id,
    notes:$notes,
   
  ){
    status
  } 
}
`


export const GET_SECTION_ACTIVITIES = gql`
mutation($plan:ID,$section:ID,$topic:ID) {
  getSectionActivities(
    plan:$plan,
    section:$section,
    topic:$topic

  ) 
}
`
export const GET_ROOM_SECTION_ACTIVITIES = gql`
mutation($plan:ID,$section:ID,$topic:ID) {
  getRoomSectionActivities(
    plan:$plan,
    section:$section,
    topic:$topic

  ) 
}
`
export const ADD_LESSON_PLAN_ACTIVITY = gql`
mutation($id:ID,$plan:ID,$section:ID,$topic:ID) {
  addLessonPlanActivity(
    id:$id,
    plan:$plan,
    section:$section,
    topic:$topic
  ) {
    status
  }
}
`
export const ADD_ROOM_PLAN_ACTIVITY = gql`
mutation($id:ID,$plan:ID,$section:ID,$topic:ID,$date:String) {
  addRoomPlanActivity(
    id:$id,
    plan:$plan,
    section:$section,
    topic:$topic,
    date:$date
  ) {
    status
  }
}
`

export const MOVE_LESSON_PLAN_ACTIVITY = gql`
mutation($id:ID,$activity:ID,$plan:ID,$section:ID,$topic:ID) {
  moveLessonPlanActivity(
    id:$id,
    plan:$plan,
    section:$section,
    topic:$topic,
    activity:$activity
  ) {
    status
  }
}
`
export const MOVE_ROOM_PLAN_ACTIVITY = gql`
mutation($id:ID,$activity:ID,$plan:ID,$section:ID,$topic:ID,$date:String) {
  moveRoomPlanActivity(
    id:$id,
    plan:$plan,
    section:$section,
    topic:$topic,
    activity:$activity,
    date:$date
  ) {
    status
  }
}
`

export const SAVE_SECTION_NAME = gql`
mutation($id:ID,$name:String) {
  saveSectionName(
    id:$id,
    name:$name
  ) {
    status
  }
}
`
export const SAVE_ROOM_SECTION_NAME = gql`
mutation($id:ID,$name:String) {
  saveRoomPlanSectionName(
    id:$id,
    name:$name
  ) {
    status
  }
}
`
export const DELETE_SECTION = gql`
mutation($id:ID) {
  deleteSection(
    id:$id
  ) {
    status
  }
}
`
export const DELETE_ROOM_SECTION = gql`
mutation($id:ID) {
  deleteRoomPlanSection(
    id:$id
  ) {
    status
  }
}
`


export const FILTER_LEARNING_ACTIVITIES = gql`
mutation($location:ID!,$framework_id:ID,$skill_id:ID,$category_id:ID,$type_id:ID) {
  filterLearningActivities(
    location:$location,framework_id:$framework_id,skill_id:$skill_id,category_id:$category_id,type_id:$type_id
  ) 
}
`
export const FILTER_LEARNING_PLANS = gql`
mutation($id:ID,$framework_id:ID,$skill_id:ID,$category_id:ID,$type_id:ID) {
  filterLearningPlan(
    id:$id,framework_id:$framework_id,skill_id:$skill_id,category_id:$category_id,type_id:$type_id
  ) 
}
`
export const FILTER_LEARNING_ROOM_PLANS = gql`
mutation($id:ID,$framework_id:ID,$skill_id:ID,$category_id:ID,$type_id:ID) {
  filterLearningRoomPlan(
    id:$id,framework_id:$framework_id,skill_id:$skill_id,category_id:$category_id,type_id:$type_id
  ) 
}
`
export const SHARE_PLAN_WITH_PARENTS = gql`
mutation($id:ID,$value:Boolean) {
  shareRoomPlanWithParents(
    id:$id,
    value:$value
  ) {
    status
  }
}
`


export const CREATE_LESSON_PLAN = gql`
mutation($location:ID!,$name:String,$theme:String,$weekend:Boolean) {
  createLessonPlan(
    location:$location,name:$name,theme:$theme,weekend:$weekend
  ) {
    status
    plan_id
  }
}
`
export const CREATE_LESSON_PLAN_SECTION = gql`
mutation($id:ID) {
  addLessonPlanSection(
    id:$id
  ) {
    status
  }
}
`
export const CREATE_ROOM_PLAN_SECTION = gql`
mutation($id:ID) {
  addRoomPlanSection(
    id:$id
  ) {
    status
  }
}
`

export const REMOVE_LESSON_PLAN_ACTIVITY = gql`
mutation($id:ID,$topic:ID,$section:ID) {
  removeLessonPlanActivity(
    id:$id,
    topic:$topic,
    section:$section
  ) {
    status
  }
}
`
export const REMOVE_SINGLE_LESSON_PLAN_ACTIVITY = gql`
mutation($id:ID,$topic:ID,$section:ID) {
  removeSingleLessonPlanActivity(
    id:$id,
    topic:$topic,
    section:$section
  ) {
    status
  }
}
`

export const REMOVE_ROOM_PLAN_ACTIVITY = gql`
mutation($id:ID,$topic:ID,$section:ID) {
  removeRoomPlanActivity(
    id:$id,
    topic:$topic,
    section:$section
  ) {
    status
  }
}
`
export const REMOVE_SINGLE_ROOM_PLAN_ACTIVITY = gql`
mutation($id:ID,$topic:ID,$section:ID) {
  removeSingleRoomPlanActivity(
    id:$id,
    topic:$topic,
    section:$section
  ) {
    status
  }
}
`
export const UPDATE_LESSON_PLAN_TOPIC = gql`
mutation($id:ID,$title:String,$description:String) {
  updateLessonPlanTopic(
    id:$id,title:$title,description:$description
  ) {
    status
  }
}
`
export const UPDATE_ROOM_PLAN_TOPIC = gql`
mutation($id:ID,$title:String,$description:String) {
  updateRoomPlanTopic(
    id:$id,title:$title,description:$description
  ) {
    status
  }
}
`

export const UPDATE_SECTION_NOTES = gql`
mutation($id:ID,$notes:[String]) {
  updateSectionNotes(
    id:$id,notes:$notes,
  ) {
    status
  }
}
`
export const UPDATE_ROOM_SECTION_NOTES = gql`
mutation($id:ID,$notes:[String]) {
  updateRoomSectionNotes(
    id:$id,notes:$notes,
  ) {
    status
  }
}
`

export const GET_SKILLS = gql`
mutation($location:ID!) {
  getSkills(
    location: $location
  ) 
}
`
export const GET_ALL_SKILLS = gql`
mutation($location:ID!) {
  getAllSkills(
    location: $location
  ) 
}
`
export const GET_FRAMEWORK_SKILL = gql`
mutation($id:ID) {
  getFrameworkSkill(
    id: $id
  ) 
}
`
export const ADD_DOMAIN = gql`
mutation($location:ID!,$name:String,$color:String) {
  addLearningDomain(
    location:$location,
    name:$name,
    color:$color
  ) {
    status
  }
}
`
export const UPDATE_DOMAIN = gql`
mutation($id:ID,$name:String,$color:String) {
  updateLearningDomain(
    id:$id,
    name:$name,
    color:$color
  ) {
    status
  }
}
`
export const ADD_LEARNING_SKILL = gql`
mutation($location:ID!,$name:String,$heading:String,$description:String,$framework:ID,$attribute:[ID],$domain:[ID]) {
  addLearningSkill(
    location:$location,name:$name,heading:$heading,description:$description,framework:$framework,attribute:$attribute,domain:$domain
  ) {
    status
  }
}
`
export const DELETE_LEARNING_SKILL = gql`
mutation($id:ID) {
  deleteLearningSkill(
    id:$id
  ) {
    status
  }
}
`

export const UPDATE_LEARNING_SKILL = gql`
mutation($id:ID,$name:String,$heading:String,$description:String,$framework:ID,$attribute:[ID],$domain:[ID]) {
  updateLearningSkill(
    id:$id,name:$name,heading:$heading,description:$description,framework:$framework,attribute:$attribute,domain:$domain
  ) {
    status
  }
}
`

export const DELETE_DOMAIN = gql`
mutation($id:ID) {
  deleteLearningDomain(
    id:$id
  ) {
    status
  }
}
`
export const GET_DOMAINS = gql`
mutation($location:ID!) {
  getLearningDomains(
    location:$location
  ) {
    id
    name
    color_code
  }
}
`
export const GET_FRAMEWORK_DOMAINS = gql`
mutation ($id:ID) {
  getFrameworkDomains(id: $id) {
     id
     name
     color_code
          
  }
}
`
export const GET_FRAMEWORK_CATEGORIES = gql`
mutation ($id:ID) {
  getFrameworkAttributes(id: $id) {
      id
      name
            
          
  }
}
`

export const ADD_ATTRIBUTE = gql`
mutation($location:ID!,$name:String) {
  addLearningAttribute(
    location:$location,
    name:$name
  ) {
    status
  }
}
`
export const UPDATE_ATTRIBUTE = gql`
mutation($id:ID,$name:String) {
  updateLearningAttribute(
    id:$id,
    name:$name
  ) {
    status
  }
}
`
export const DELETE_ATTRIBUTE = gql`
mutation($id:ID) {
  deleteLearningAttribute(
    id:$id
  ) {
    status
  }
}
`
export const GET_ATTRIBUTES = gql`
mutation($location:ID!) {
  getLearningAttributes(
    location:$location
  ) {
    id
    name
  }
}
`


export const ADD_PROGRESS = gql`
mutation($location:ID!,$name:String) {
  addLearningProgress(
    location:$location,
    name:$name
  ) {
    status
  }
}
`
export const UPDATE_PROGRESS = gql`
mutation($id:ID,$name:String) {
  updateLearningProgress(
    id:$id,
    name:$name
  ) {
    status
  }
}
`
export const DELETE_PROGRESS = gql`
mutation($id:ID) {
  deleteLearningProgress(
    id:$id
  ) {
    status
  }
}
`
export const GET_PROGRESS = gql`
mutation($location:ID!) {
  getLearningProgress(
    location:$location
  ) {
    id
    name
  }
}
`


export const GET_ALL_LEARNING_FRAMEWORKS = gql`
mutation($location:ID!) {
  getAllLearningFrameworks(location: $location)
}
`
export const SAVE_LEARNING_FRAMEWORKS = gql`
mutation($location:ID!,$update:[ID],$delete:[ID]) {
  saveLearningFrameworks(
    location:$location,update:$update,delete:$delete
  ) {
    status
  }
}
`
export const DELETE_LEARNING_FRAMEWORK = gql`
mutation($id:ID) {
  deleteFramework(
    id:$id
  ) {
    status
  }
}
`
export const SET_DEFAULT_FRAMEWORK = gql`
mutation($id:ID,$location:ID!,$default:Boolean) {
  setDefaultFramework(
    id:$id,
    location:$location,
    default:$default
  ) {
    status
  }
}
`
export const ADD_CATEGORY = gql`
mutation($location:ID!,$name:String) {
  addCategory(
    location:$location,
    name:$name
  ) {
    status
  }
}
`
export const ADD_SUPPLIES = gql`
mutation($location:ID!,$name:String) {
  addSupplies(
    location:$location,
    name:$name
  ) {
    status
  }
}
`
export const UPDATE_SUPPLIES = gql`
mutation($id:ID,$name:String) {
  updateSupplies(
    id:$id,
    name:$name
  ) {
    status
  }
}
`
export const DELETE_SUPPLIES = gql`
mutation($id:ID) {
  deleteSupplies(
    id:$id
  ) {
    status
  }
}
`
export const GET_SUPPLIES = gql`
mutation($location:ID!) {
  getSupplies(
    location:$location
  ) {
    id
    name
  }
}
`
export const GET_LESSON_PLAN = gql`
mutation($id:ID) {
  getLessonPlan(
    id:$id
  ) {
    id
    name
    weekend
    notes
  }
}
`
export const GET_ROOM_PLAN = gql`
mutation($id:ID) {
  getRoomPlan(
    id:$id
  ) 
}
`
export const SAVE_LESSON_PLAN_NAME = gql`
mutation($id:ID,$name:String) {
  saveLessonPlanName(
    id:$id
    name:$name
  ) {
    status
  }
}
`
export const SAVE_ROOM_PLAN_NAME = gql`
mutation($id:ID,$name:String) {
  saveRoomPlanName(
    id:$id
    name:$name
  ) {
    status
  }
}
`

export const GET_LESSON_PLAN_TOPICS = gql`
mutation($id:ID) {
  getLessonPlanTopics(
    id:$id
  ) 
}
`
export const GET_ROOM_PLAN_TOPICS = gql`
mutation($id:ID) {
  getRoomPlanTopics(
    id:$id
  ) 
}
`

export const GET_ALL_LESSON_PLANS = gql`
mutation($id:ID,$orderBy:String) {
  getAllLessonPlans(
    id:$id,
    orderBy:$orderBy
  ) {
    id
    name
    theme
  }
}
`
export const GET_ALL_ROOM_PLANS = gql`
mutation($location:ID!) {
  getAllRoomPlans(
    location:$location
  ) 
}
`

export const DELETE_LEARNING_ACTIVITY = gql`
mutation($id:ID) {
  deleteLearningActivity(
    id:$id
  ) {
    status
  }
}
`
export const GET_LEARNING_ACTIVITIES = gql`
mutation($location:ID!) {
  getLearningActivities(
    location:$location
  ) 
}
`
export const CREATE_LEARNING_ACTIVITY = gql`
mutation($location:ID!,$title:String,$category:ID,$type:ID,$summary:String,$minAge:String,$maxAge:String,$hours:String,$mins:String,$loc:String,$description:String,$notes:String,$framework_id:ID,$skills:[ID],$supplies:[ID]) {
  createLearningActivity(
    location:$location,title:$title,category:$category,type:$type,summary:$summary,minAge:$minAge,maxAge:$maxAge,hours:$hours,mins:$mins,loc:$loc,description:$description,notes:$notes,framework_id:$framework_id,skills:$skills,supplies:$supplies
  ) {
    status
  }
}
`
export const UPDATE_LEARNING_ACTIVITY = gql`
mutation($id:ID,$location_id:ID!,$title:String,$category:ID,$type:ID,$summary:String,$minAge:String,$maxAge:String,$hours:String,$mins:String,$loc:String,$description:String,$notes:String,$framework_id:ID,$skills:[ID],$supplies:[ID]) {
  updateLearningActivity(
    id:$id,location_id:$location_id,title:$title,category:$category,type:$type,summary:$summary,minAge:$minAge,maxAge:$maxAge,hours:$hours,mins:$mins,loc:$loc,description:$description,notes:$notes,framework_id:$framework_id,skills:$skills,supplies:$supplies
  ) {
    status
  }
}
`

export const ADD_TYPE = gql`
mutation($location:ID!,$name:String,$category:[ID]) {
  addType(
    location:$location,
    name:$name,
    category:$category
  ) {
    status
  }
}
`
export const UPDATE_TYPE = gql`
mutation($id:ID,$name:String,$category:[ID]) {
  updateType(
    id:$id,
    name:$name,
    category:$category
  ) {
    status
  }
}
`
export const UPDATE_CATEGORY = gql`
mutation($id:ID,$name:String) {
  updateCategory(
    id:$id,
    name:$name
  ) {
    status
  }
}
`
export const DELETE_CATEGORY = gql`
mutation($id:ID) {
  deleteCategory(
    id:$id
  ) {
    status
  }
}
`
export const DELETE_TYPE = gql`
mutation($id:ID) {
  deleteType(
    id:$id
  ) {
    status
  }
}
`
export const GET_CATEGORY = gql`
mutation($location:ID!) {
  getCategories(
    location:$location
  ) {
    id
    name
  }
}
`

export const GET_TYPES = gql`
mutation($location:ID!) {
  getTypes(
    location:$location
  ) {
    id
    name
    categories{
      id
      name
      
      
    }
  }
}
`
export const ADD_LEARNING_FRAMEWORKS = gql`
mutation($location:ID!,$name:String,$template:String,$default:Boolean,$domains:[ID],$attributes:[ID],$indicators:[ID]) {
  addLearningFrameworks(
    location:$location,name:$name,template:$template,default:$default,domains:$domains,attributes:$attributes,indicators:$indicators
  ) {
    status
  }
}
`
export const UPDATE_LEARNING_FRAMEWORKS = gql`
mutation($id:ID,$location:ID!,$name:String,$template:String,$default:Boolean,$domains:[ID],$attributes:[ID],$indicators:[ID]) {
  updateLearningFrameworks(
    id:$id,location:$location,name:$name,template:$template,default:$default,domains:$domains,attributes:$attributes,indicators:$indicators
  ) {
    status
  }
}
`


export const VERIFY_USER_CHECKIN_PIN = gql`
  mutation ($pin:String)
  {
    verifyUserCheckinPin(
       pin:$pin
      )
  }
`
export const VERIFY_USER_CHECKIN_PIN_AND_PHONE = gql`
  mutation ($pin:String,$phone:String,$location:ID!,$date:String)
  {
    verifyUserCheckinPinAndPhone(
       pin:$pin
       phone:$phone
       location:$location
       date:$date
     ){
          user{
             id
             fname
             lname
          }
          students{
            id
            fname
            lname
            middle_name
            image
            checked_in_out
            program{
              id
              name
              color_code
              }
            other_rooms{
              id
              name
              color_code
              }
          }
          status
          type
          programs{
          id 
          name
          color_code
          }
          program_status
          attendance{
            id
            start_time
          }
      }
  }
`

export const SAVE_USER_STUDENT_CHECK_IN_OUT_ACTIVITY_FROM_SCREEN = gql`
  mutation
  saveUserStudentCheckInOutActivityFromScreen(
    $students:String
    $action_by:ID
    $signature:String
    $time:String
    $date:String
  ){
    saveUserStudentCheckInOutActivityFromScreen(
      students:$students
      action_by:$action_by
      signature:$signature
      time:$time
      date:$date
    )
    {
      status
    }
  }
`
export const SAVE_ATTANDANCE_TEAM_FROM_SCREEN = gql`
  mutation
  saveAttandanceTeamFromScreen($program_id:ID,$action:Boolean,$team:ID,$time:String,$date:String,$break:String,$id:ID){
    saveAttandanceTeamFromScreen (program_id:$program_id,action:$action,team:$team,time:$time,date:$date,break:$break,id:$id) {
       status
    }
  }
`
export const ACTIVATE_LOCATION_TIME_CLOCK_LINK = gql`
mutation($id:ID,$value:Boolean) {
  activateLocationTimeclockLink(
    id: $id
    value:$value
  )
}
`
export const ENABLE_QUICK_SCAN = gql`
mutation saveCheckinSetting($id:ID,$setting:[CheckinSetting]) {
  saveCheckinSetting(id:$id,setting:$setting) {
          status
  }
}
`
export const GET_QUICK_SCAN = gql`
mutation getCheckinSetting($id:ID) {
  getCheckinSetting(id:$id) {
          id
          key
          value
  }
}
`

export const SIGNATURE_LOCATION_TIME_CLOCK_LINK = gql`
mutation($id:ID,$value:Boolean) {
  signatureLocationTimeclockLink(
    id:$id
    value:$value
  )
}
`
export const GET_TIMECLOCK_DASHBOARD_PROGRAM = gql`
mutation($location:ID! ) {
  getTimeClockProgram(
    location: $location
  ){
     id
     name
     color_code
  } 
}
`

export const GET_TIMECLOCK_DASHBOARD = gql`
mutation($location:ID!,$date:String) {
  getTimeClockReport(
    location: $location
    date:$date
  ){
    scheduled_students{
     id 
     type
     days
     student{
       id
       fname
       lname
       program{
         id
         name
         color_code
       }
       
     }
     scheduled{
        id
        start_date
     }
     signedin
     absences
     extra_scheduled
    }
    non_scheduled_students{
      id 
      type
      days
      student{
       id
       fname
       lname
       program{
         id
         name
         color_code
       }
      }
        signedin
        absences
        extra_scheduled
  } 
  }
}
`
export const VERIFY_USER_CHECKIN_PIN_APP = gql`
  mutation ($pin:String)
  {
    verifyUserCheckinPinApp(
       pin:$pin
      
     )
  }
`
export const VERIFY_USER_CHECKIN_PIN_AND_PHONE_APP = gql`
  mutation ($pin:String,$phone:String,$location:ID!,$date:String)
  {
    verifyUserCheckinPinAndPhoneApp(
       pin:$pin
       phone:$phone
       location:$location
       date:$date
     ){
          user{
             id
             fname
             lname
          }
          students{
            id
            fname
            lname
            middle_name
            image
            checked_in_out
            program{
              id
              name
              color_code
              }
          }
          status
          type
          signature
          programs{
          id 
          name
          color_code
          }
          program_status
          attendance{
            id
            start_time
          }
      }
  }
`
export const SAVE_ATTANDANCE_TEAM_FROM_APP = gql`
  mutation
  saveAttandanceTeamFromApp($program_id:ID,$action:Boolean,$team:ID,$time:String,$date:String,$break:String,$id:ID){
    saveAttandanceTeamFromApp (program_id:$program_id,action:$action,team:$team,time:$time,date:$date,break:$break,id:$id) {
       status
    }
  }
`
export const SAVE_USER_STUDENT_CHECK_IN_OUT_ACTIVITY_FROM_APP = gql`
  mutation
  saveUserStudentCheckInOutActivityFromApp(
    $students:String
    $action_by:ID
    $signature:String
    $time:String
    $date:String
  ){
    saveUserStudentCheckInOutActivityFromApp(
      students:$students
      action_by:$action_by
      signature:$signature
      time:$time
      date:$date
    )
    {
      status
    }
  }
`
export const GET_STUDENT_BY_LOCATION = gql`
  query ($location_id:ID!){
    getStudentByLocation(location_id:$location_id) {
  
      id
      fname
      lname
      middle_name
      image
  
    }
  }
`
export const FILTER_STUDENT_PAGINATION = gql`
  mutation($location:ID!,$program:ID,$page:Int,$first:Int!) {
    filterStudentPagination(
      location:$location
      program:$program
      page:$page
      first:$first
    )
    { 
       data {
             id
           }
      paginatorInfo {
        currentPage
        lastPage
        perPage
        total
      }
       }
  }
`
export const FILTER_UPDATED_STUDENT_SCHEDULE = gql`
  mutation($students:[ID],$start_date:String,$end_date:String,$has_schedule:Boolean) {
    filterUpdatedStudentSchedule(
      students:$students
      start_date: $start_date,
      end_date: $end_date
      has_schedule: $has_schedule
    )
    { 
      student{
        id
        fname
        lname
        middle_name
        image
      }
      student_schedules{
      date
      schedules{
         id
         start_date
         end_date
         start_time
         end_time
         type
         days
         program{
           id
           name
         }
      }
      absences{
         id
         start_date
         note
         reason
      }
      vacations {
         id
         start_date
         note
         reason
        }
        extra{
         id
         start_date
         schedule{
            id
            program{
             id
             name
            }
            start_time
            end_time 
         }
       }
      }
    }
  }
`
export const EDIT_STUDENT_SCHEDULE_MODULE = gql`
  mutation ($schedule:String,$id:ID,$start_date:String,$end_date:String,$days:String,$program:String)
  {
    updateStudentScheduleModule(
      schedule:$schedule
      program:$program
      id:$id
      start_date:$start_date
      end_date:$end_date
      days:$days
    )
    {
      status
      message
      color
    }
  }
`
export const EDIT_STUDENT_SCHEDULE_VACATION = gql`
  mutation ($type:String,$id:ID,$start_date:String,$end_date:String,$reason:String,$note:String)
  {
    editStudentScheduleVacation(
      type:$type
      id:$id
      start_date:$start_date
      end_date:$end_date
      reason:$reason
      note:$note
    )
    {
      status
      message
      color
    }
  }
`
export const REMOVE_STUDENT_SCHEDULE_VACATION = gql`
  mutation ( $id:ID )
  {
    removeStudentScheduleVacation(
      id:$id
    )
    {
      status
      message
      color
    }
  }
`
export const GET_LOCATION_STAFF = gql`
mutation($location:ID!) {
  getLocationStaff(
    location: $location
  ){
      id
      fname
      lname
      middle_name
      avatar
  } 
}
`
export const UPDATE_STAFF_SCHEDULE_MODULE = gql`
  mutation ($type:String,$id:ID,$program:ID,$repeat:Boolean,$start_date:String,$end_date:String,$start_time:String,$end_time:String,$days:[String],$note:String)
  {
    updateStaffScheduleModule(
      type:$type
      id:$id
      program:$program 
      repeat:$repeat
      start_date:$start_date
      end_date:$end_date
      start_time:$start_time
      end_time:$end_time
      days:$days
      note:$note
    )
    {
      status
      message
      color
    }
  }
`

export const REMOVE_STAFF_SCHEDULE_MODULE = gql`
  mutation ( $id:ID )
  {
    removeStaffScheduleModule(
      id:$id
    )
    {
      status
      message
      color
    }
  }
`
export const GET_STUDENT_BY_PROGRAM_FOR_ATTENDANCE = gql`
  mutation ($program_id:[ID],$date: String){
    getStudentForAttendance(program_id:$program_id,date:$date) {
      id
      fname
      lname
      middle_name
      image
      checked_in_out
      absent
    }
  }
`

export const GET_STAFF_HOURS = gql` 
mutation($location:ID!,$date:String) {
  getStaffHours(
    location: $location
    date:$date
  ){
    user {
      id
      fname
      lname
      middle_name
      avatar
   }
   attendance{
    id
    date
    start_time
    end_time
    break_time
    program{
      id
      name
      color_code
   }
  }
  } 
}
`
export const GET_LOCATION_CHECKEDIN_STUDENTS = gql`
  mutation ($location:ID!,$date: String){
    getLocationCheckedinStudents(location:$location,date:$date)
  }
`

export const ADD_SCHOOL_IMG = gql`
  mutation
  addSchoolImg(
    $schoolImg:String,
    $location:ID!,
  ){
    addSchoolImg (
      schoolImg:$schoolImg
      location:$location
      ) {
      status
      message
      color
      }
  }
`
export const UPDATE_STAFF_ATTENDANCE_REPORT = gql`
mutation($staff:ID,$data:String) {
  updateStaffAttendanceReport(
    staff:$staff
    data: $data
   )
  {
     status
     color
     message
  }
}
`
export const DELETE_STAFF_ATTENDANCE_REPORT = gql`
mutation($id:ID) {
  deleteStaffAttendanceReport(
    id:$id
    )
  {
     status
     color
     message
  }
}
`
export const GET_STUDENT_HOURS = gql` 
mutation($location:ID!,$program:ID,$date:String) {
  getStudentHours(
    location: $location
    program:$program
    date:$date
  ){
    student {
      id
      fname
      lname
      middle_name
      image
   }
   attendance{
    id
    date
    start_time
    end_time
    checkedin_signature 
    checkedout_signature
    checkedin_by{
      id
      fname
      lname
      middle_name
    }
    checkedout_by{
      id
      fname
      lname
      middle_name
    }
  }
  } 
}
`
export const GET_STUDENT_DAILY_HOURS = gql` 
mutation($location:ID!,$program:ID,$date:String) {
  getDailyStudentHours(
    location: $location
    program:$program
    date:$date
  ){
    student {
      id
      fname
      lname
      middle_name
      image
      program{
        id 
        name
        color_code
      }
   }
   attendance{
    id
    date
    start_time
    end_time
    checkedin_signature 
    checkedout_signature
    checkedin_by{
      id
      fname
      lname
      middle_name
    }
    checkedout_by{
      id
      fname
      lname
      middle_name
    }
  }
  } 
}
`
export const UPDATE_STUDENT_ATTENDANCE_REPORT = gql`
mutation($student:ID,$data:String) {
  updateStudentAttendanceReport(
    student:$student
    data: $data
   )
  {
     status
     color
     message
  }
}
`
export const DELETE_STUDENT_ATTENDANCE_REPORT = gql`
mutation($id:ID) {
  deleteStudentAttendanceReport(
    id:$id
    )
  {
     status
     color
     message
  }
}
`
export const GET_STUDENT_ATTENDANCE_REPORT_MONTH = gql`
  mutation ($students:[ID],$month:String )
  {
    getStudentAttendanceMonthReport(
      students:$students
       month:$month
    )
  }
`
export const GET_SINGLE_STUDENT_ATTENDANCE_REPORT_MONTH = gql`
  mutation ($student:ID,$month:String )
  {
    getSingleStudentAttendanceMonthReport(
      student:$student
       month:$month
    )
  }
`
export const CREATE_IMMUNIZATION = gql`
mutation(
   $name:String,
   $code:String,
   $data_1st:String,
   $data_2nd:String,
   $data_3rd:String,
   $data_4th:String,
   $data_5th:String,
   $data_6th:String,
   $is_required:Boolean) {
  createImmunization(
    name:$name
    code: $code
    data_1st:$data_1st
    data_2nd:$data_2nd
    data_3rd:$data_3rd
    data_4th:$data_4th
    data_5th:$data_5th
    data_6th:$data_6th
    is_required:$is_required
   )
  {
     status
     color
     message
  }
}
`
export const UPDATE_IMMUNIZATION = gql`
mutation( 
   $id:ID,
   $name:String,
   $code:String,
   $data_1st:String,
   $data_2nd:String,
   $data_3rd:String,
   $data_4th:String,
   $data_5th:String,
   $data_6th:String,
   $is_required:Boolean) {
  updateImmunization(
    id:$id
    name:$name
    code: $code
    data_1st:$data_1st
    data_2nd:$data_2nd
    data_3rd:$data_3rd
    data_4th:$data_4th
    data_5th:$data_5th
    data_6th:$data_6th
    is_required:$is_required
   )
  {
     status
     color
     message
  }
}
`
export const GET_ALL_IMMUNIZATION = gql` 
query ALLIMMUNIZATION {
  immunization{
    id
    name
    code
    dose_1st
    dose_2nd
    dose_3rd
    dose_4th
    dose_5th
    dose_6th
    is_required
  }
}
`
export const REMOVE_IMMUNIZATION = gql`
  mutation($id:ID!) {
    deleteImmunization(
      id: $id
    ){
      status
      message
    }
  }
`
export const UPDATE_REQUIRED_IMMUNIZATION = gql`
  mutation($id:ID,$is_required:Boolean) {
    updateRequiredImm(
      id: $id
      is_required: $is_required
    ){
      status
    }
  }
`
export const STUDENT_IMMUNIZATION_LIST = gql` 
query ALLIMMUNIZATION {
  immunization{
    id
    name
    code
    dose_1st
    dose_2nd
    dose_3rd
    dose_4th
    dose_5th
    dose_6th
  }
}
`
export const STUDENT_IMMUNIZATION_DATA = gql` 
mutation($id:ID!) {
  studentImuniznation(
      id: $id
    ){
      data
      status
     } 
  }
`
export const SAVE_STUDENT_IMMUNIZATION = gql`
  mutation($id:ID,$data:[ImmunizationInput]) {
    saveStudentImmunization(
      id: $id
      data:$data
    ){
      status
    }
  }
`
export const SAVE_STUDENT_DOCUMENT = gql`
  mutation($id:ID,$file:StudentDocFile,$type:String,$expiry:String,$note:String,$roles:[ID]) {
    saveStudentDocument(
      id: $id
      file:$file
      type:$type
      expiry:$expiry
      note:$note
      roles:$roles
    ){
      status
    }
  }
`

export const GET_STUDENT_DOCUMENT = gql`
  mutation($id:ID) {
    getStudentDocument(
      id: $id
    ) {
    
      id
      name
      type
      status
      expiry
      note
      path
      roles{
        id
        name
      }
      created_by{
        id
        fname
        lname
      }
      approved_by{
        id
        fname
        lname
      }
      created_at
    }
  }
`

export const EDIT_STUDENT_DOCUMENT = gql`
mutation($id:ID,$type:String,$expiry:String,$note:String,$roles:[ID],$doc_id:ID) {
  editStudentDocument(
    doc_id:$doc_id
    id:$id
    type:$type
    expiry:$expiry
    note:$note
    roles:$roles
  ){
    status
  }
}
`
export const DELETE_STUDENT_DOCUMENT = gql`
  mutation($id:ID!) {
    deleteStudentDocument(
      id: $id
    ){
      status
    }
  }
`
export const APPROVE_STUDENT_DOCUMENT = gql`
  mutation($id:ID!) {
    approveStudentDocument(
      id: $id
    ){
      status
    }
  }
`
export const CREATE_LOCATION_BLOG_TAG = gql`
mutation($location:ID!,$name:String) {
  addLocationBlogTag(
    name: $name
    location:  $location
  )
  {
     status
     color
     message
  }
}
`
export const CREATE_LOCATION_BLOG_CATEGORY = gql`
mutation($location:ID!,$name:String) {
  addLocationBlogCategory(
    name: $name
    location:  $location
  )
  {
     status
     color
     message
  }
}
`
export const GET_LOCATION_BLOG_CATEGORY = gql`
mutation($location:ID!) {
  getLocationBlogCategory(
    location:$location
  ){
    id
    name
   }
  }
`
export const GET_LOCATION_BLOG_URL = gql`
mutation($location:ID!) {
  getLocationBlogUrl(
    location:$location
  )
  }
`
export const CREATE_LOCATION_BLOG_URL = gql`
mutation($location:ID!,$url:String) {
  addLocationBlogUrl(
    url: $url
    location:  $location
  )
  {
     status
  }
}
`

export const CREATE_LOCATION_BLOG = gql`
mutation($location:ID!,$title:String,$shortDetails:String,$longDetails:String,$category:String,$img:String,$status:Boolean,$author:String,$date:String) {
  createLocationBlog(
    title: $title
    location:  $location
    shortDetails: $shortDetails
    longDetails:$longDetails
    img: $img
    status: $status
    category:$category
    author:$author
    date: $date
  )
  {
     status
  
  }
}
`
export const UPDATE_LOCATION_BLOG = gql`
mutation($id:ID,$title:String,$shortDetails:String,$longDetails:String,$category:String,$img:String,$status:Boolean,$author:String,$date:String,$location:ID!) {
  updateLocationBlog(
    id:$id
    title: $title
    shortDetails: $shortDetails
    longDetails:$longDetails
    img: $img
    status: $status
    category:$category
    author:$author
    date: $date
    location:  $location
  )
  {
     status
 
  }
}
`
export const DELETE_LOCATION_BLOG = gql`
mutation($id:ID ) {
  deleteLocationBlog(
    id:$id
   
  )
  {
     status
   
  }
}
`
export const GET_LOCATION_BLOGS = gql`
mutation($location:ID!) {
  getLocationBlogs(
    location:$location
  ){
    id
    title
    summary
    description
    img
    status
    category{
      id
      name
    }
    date
    author{
      id
      name
      avatar
    }
    location_id
   }
  }
`
export const UPDATE_LEGAL_GURDIAN = gql`
  mutation($id:ID,$legal_guardian:Boolean) {
    updateLegalGurdian(
      id: $id
      legal_guardian: $legal_guardian
    ){
      status
    }
  }
`
export const GET_LOCATION_BLOG_AUTHOR = gql`
mutation($location:ID!) {
  getLocationBlogAuthor(
    location:$location
  ){
    id
    name
    avatar
  }
  }
`

export const DELETE_LOCATION_BLOG_CATEGORY = gql`
  mutation($id:ID) {
    deleteBlogCategory(
      id: $id
    ){
      status
    }
  }
`
export const UPDATE_LOCATION_BLOG_CATEGORY = gql`
mutation($id:ID,$name:String) {
  editLocationBlogCategory(
    name: $name
    id:  $id
  )
  {
     status
     color
     message
  }
}
`
export const CHECK_TEAM_PROFILE_PERMISSION = gql`
  mutation
  checkTeamProfilePermission(
    $id:ID   
  ){
    checkTeamProfilePermission(
      id:$id
    ){
      found
      permission
    }
  }
`
export const GET_SINGLE_TEAM = gql`
  query ($id:ID!){
    user(id:$id) {
    id
    fname
    lname
    middle_name
    nick_name
    full_name
    username
    email
    phone
    check_in_pin
    status
    invited
    avatar
    email_confirmed
    job_title
    roles{
      id
      name
    }
    locations{
      id
      name
      color_code
    }
    managerlocations{
      id
      name
      color_code
    }
    programs{
      id
      name
      color_code
    }
    }
  }
`
export const TRANSFER_STUDENT_LOCATION = gql`
  mutation
  transferStudentLocation(
    $location_id:ID!
    $students:[transferStudentLocationStudentsInput]
   # $program_id:ID
   # $student_id:ID   
  ){
    transferStudentLocation(
      location_id:$location_id
      students:$students
       #program_id:$program_id
       #student_id:$student_id
    ){
       status
    }
  }
`
export const COPY_LOACATION_FOOD_MENU_TO_OTHER_LOCATION = gql`
  mutation
  copyFoodMenutoLocation(
    $location_id:ID!
    $target_location_id:ID
   ){
    copyFoodMenutoLocation(
      location_id:$location_id
      target_location_id:$target_location_id
     ){
       status
    }
  }
`
export const GET_STUDENT_IMMUNIZATIONS_LOGS = gql`
  mutation($id:ID) {
    getStudentImmunizationLog(
      id: $id
    ){
      id
      activity
      user{
       id
       fname
       lname
      }
      created_at
    }
  }
`

export const GET_STUDENT_DOCUMENTS_LOGS = gql`
  mutation($id:ID) {
    getStudentDocmentLog(
      id: $id
    ){
      id
      activity
      user{
       id
       fname
       lname
      }
      created_at
    }
  }
`
export const DELETE_LOCATION_FOOD_MENU_SUGGESTION = gql`
mutation($id:ID) {
  deleteFoodMenuSuggestion(
    id:$id
  )
  { 
    status
  }
  
}
`
export const REMOVE_ALL_SUGGESTION = gql`
mutation($location:ID!) {
  removeAllAutofill(
    location:$location
  )
  { 
    status
  }
  
}
`
export const UPDATE_LOCATION_FOOD_MENU_SUGGESTION = gql`
mutation($id:ID,$name:String) {
  editFoodMenuSuggestion(
    name: $name
    id:  $id
  )
  {
     status
     color
     message
  }
}
`
export const GET_PRESIGNED_URL = gql`
mutation ($file_name: String) {
generatePresignedUrl(file_name: $file_name){
  pre_url
  file_key
}
}
`
export const GET_PRESIGNED_URL_DX = gql`
mutation ($file_name: String) {
  getDropBoxPreSignedUrl(file_name: $file_name){
  pre_url
  file_key
}
}
`
export const ADD_MULTIPLE_STUDENT_TAGS = gql`
mutation ($location:ID! , $students:[ID],$ex_tags:[ID],$new_tags:[String],$is_detach:Boolean) {
  addMultipleStudentTags(
  location: $location
  students: $students
  ex_tags: $ex_tags
  new_tags: $new_tags
  is_detach:$is_detach
  )
  {
   status
  }
}
`
export const ADD_MULTIPLE_USER_TAGS = gql`
mutation ($location:ID! , $users:[ID],$ex_tags:[ID],$new_tags:[String],$is_detach:Boolean) {
  addMultipleUserTags(
  location: $location
  users: $users
  ex_tags: $ex_tags
  new_tags: $new_tags,
  is_detach:$is_detach
  )
  {
   status
  }
}
`
export const GET_ROOM_ACTIVE_STUDENT_REPORT = gql`
query getRoomActiveStudent($location:ID!) {
  getRoomActiveStudent(location:$location){
    program {
       id
       name
       color_code
    }
    student
  }
}
`
export const GET_STUDENT_BY_TAGS = gql`
  mutation ($tag_ids:[ID]){
    tagsStudent(tag_ids:$tag_ids) {
      id
      fname
      lname
      middle_name
      image
      users{
        id
        fname
        lname
        phone
        avatar
        phone_verified
        pivot{
         alert
         black_list
        }
      }
      program{
        id
        name
      }
    }
  }
`

export const CREATE_MULTIPLE_STUDENT_CAMERA_SCHEDULE = gql`
  mutation
  createMultipleStudentCameraSchedule(
    $student_id: [ID],
    $scheduledates: [CreateDatesInput]
  ){
    createMultipleStudentCameraSchedule (
      student_id: $student_id,
      scheduledates:$scheduledates
    ) {
      status
      message
      color
    }
  }
`

export const SAVE_INVITE_TEXT_SETTING = gql`
  mutation
  saveInviteTextSetting(
    $emailText:String,
    $smsText:String,
    $id:ID,
  ){
    saveInviteTextSetting (
      emailText: $emailText,
      smsText:   $smsText
      id:$id,
    ) {
      status
      message
      color
    }
  }
`
export const GET_INVITE_TEXT_SETTING = gql`
  mutation
  getInviteTextSetting(
    $id:ID
  ){
    getInviteTextSetting (
      id:$id
    ) {
        id
        key
        value
        object_id
    }
  }
`
export const GET_LOCATION_SIGNUP_STATUS = gql`
  mutation
  getLocationSignupStatus(
    $id:ID
  ){
    getLocationSignupStatus (
      id:$id
    ) 
  }
`

export const GET_LOGIN_SETTING = gql`
  mutation
  getLoginSetting(
    $id:ID
  ){
    getLoginSetting (
      id:$id
    ) {
        id
        key
        value
        object_id
    }
  }
`
export const SAVE_LOGIN_SETTING = gql`
  mutation
  saveLoginSetting(
    $login_feature:Boolean,
    $daily_logins:String,
    $user_time_out:String,
    $id:ID
  ){
    saveLoginSetting (
      login_feature: $login_feature,
      daily_logins:  $daily_logins
      user_time_out: $user_time_out
      id:$id,
    ) {
      status
      message
      color
    }
  }
`
export const SAVE_SIGNUP_SETTING = gql`
  mutation
  saveSignupSetting(
    $sign_up_status:Boolean,
    $expiry_time:String,
    $success_text:String,
    $fail_text:String,
    $max_no_of_students:String,
    $id:ID
  ){
    saveSignupSetting (
      sign_up_status: $sign_up_status,
      expiry_time:  $expiry_time
      success_text: $success_text
      fail_text: $fail_text
      max_no_of_students:$max_no_of_students
      id:$id,
    ) {
      status
      message
      color
    }
  }
`
export const GET_SIGNUP_SETTING = gql`
  mutation
  getSignupSetting(
    $id:ID
  ){
    getSignupSetting (
      id:$id
    ) {
        id
        key
        value
        object_id
    }
  }
`

export const SAVE_DEFAULT_CAMERA_SETTING = gql`
  mutation
  saveDefaultCameraSetting(
    $default_cameras:[ID],
    $id:ID
  ){
    saveDefaultCameraSetting (
      default_cameras: $default_cameras,
      id:$id,
    ) {
      status
      message
      color
    }
  }
`
export const GET_DEFAULT_CAMERA_SETTING = gql`
  mutation
  getDefaultCameraSetting(
    $id:ID
  ){
    getDefaultCameraSetting (
      id:$id
    ) {
        id
        name
        color_code
    }
  }
`

export const GET_PARENT_SETTING = gql`
  mutation
  getParentSetting(
    $id:ID
  ){
    getParentSetting (
      id:$id
    ) {
        id
        key
        value
        object_id
    }
  }
`
export const SAVE_PARENT_SETTING = gql`
  mutation
  saveParentSetting(
    $can_edit_student:Boolean,
    $can_edit_fields:[String]
    $id:ID
  ){
    saveParentSetting (
      can_edit_student: $can_edit_student,
      can_edit_fields: $can_edit_fields
      id:$id,
    ) {
      status
      message
      color
    }
  }
`
export const GET_ADDRESS_SETTING = gql`
  mutation
  getAddressSetting(
    $id:ID
  ){
    getAddressSetting (
      id:$id
    ) {
        id
        key
        value
        object_id
    }
  }
`
export const SAVE_ADDRESS_SETTING = gql`
  mutation
  saveAddressSetting(
    $default_city:String,
    $default_state:String,
    $default_zip:String,
    $id:ID
  ){
    saveAddressSetting (
      default_city: $default_city
      default_state: $default_state
      default_zip: $default_zip
      id:$id
    ) {
      status
      message
      color
    }
  }
`
export const GET_TEAM_NOTIF_SETTING = gql`
  mutation
  getTeamNotifSetting(
    $id:ID
  ){
    getTeamNotifSetting (
      id:$id
    ) 
    {
        settings{
            id
            key
            value
            object_id
        }
        team{
        
         id
         fname
         lname
         middle_name
         avatar
         email_notification
         sms_notification

        }
    }
  
  }
`
export const GET_PARENT_NOTIF_SETTING = gql`
  mutation
  getAddressSetting(
    $id:ID
  ){
    getParentNotifSetting (
      id:$id
    ) {
        id
        key
        value
        object_id
    }
  }
`
export const GET_PROGRAM_BY_LOCATION_WITH_STUDENT_COUNT = gql`
  query ($location_id:ID!){
    location_programs(location_id:$location_id) {
    id
    name
    color_code
    student_count
    location
    {
      id
      name
    }
    camera_group{
      id 
      name
      cameras{
        id
        name
        color_code
      }
    }
    billing_programs{
        id
        name
        color_code
      }
    }
  }
`
export const GET_DASHBOARD_SETTING = gql`
  mutation
  getDashboardSetting(
    $id:ID
  ){
    getDashboardSetting (
      id:$id
    ) {
        id
        key
        value
        object_id
    }
  }
`
export const SAVE_DASHBOARD_SETTING = gql`
  mutation
  saveDashboardSetting(
    $show_room_ration_widget:Boolean,
    $id:ID
  ){
    saveDashboardSetting (
      show_room_ration_widget: $show_room_ration_widget
      id:$id
    ) {
      status
      message
      color
    }
  }
`
export const SAVE_TEMP_ADVANDCE_ONBOARDING_DATA = gql`
  mutation
  saveTempAdvanceOnbordingData(
     $students:String
  ){
    saveTempAdvanceOnbordingData (students:$students) {
       status
      
    }
  }
`

export const MATCH_HEADER_ADVANDCE_ONBOARDING = gql`
  mutation
  matchHeaderAdvanceOnbording(
    $file_path:String
    $location:ID!
    $matching_headers:[MatchingHeadersInput]
  ){
    matchHeaderAdvanceOnbording (file_path:$file_path,location:$location,matching_headers:$matching_headers) {
       status
       students
       relations
       errors
       kvcolumns
       filecolumns
       filepath
    }
  }
`
export const GET_ALL_SUFORMS_DATA = gql`
  mutation
  getAllSuformsData(
    $location:ID!
   ){
    getAllSuformsData (
      location: $location
    )  
  }
`

export const GET_STUDENT_BY_LOCATION_FOR_INVOICE = gql`
  query ($location_id:ID!){
    getStudentByLocation(location_id:$location_id) {
  
      id
      fname
      lname
      middle_name
      image
  
    }
  }
`

export const SAVE_STUDENT_INVOICE = gql`
  mutation
  saveStudentInvoice(
    $date:String
    $from_date:String
    $to_date:String
    $amount:String
    $invoice_without_payer:[InvoiceInput]
    $invoice_with_payer:[InvoiceWithPayerInput]
    $students:[ID]
   ){
    saveStudentInvoice (
      date: $date
      from_date: $from_date
      to_date: $to_date
      amount: $amount
      invoice_without_payer: $invoice_without_payer
      invoice_with_payer:$invoice_with_payer
      students:$students
    )
    {
      status
    }
  }
`
export const GET_UNPAID_STUDENT = gql`
  mutation ($location_id:ID!,$type:String){
    getUnpaidStudents(location_id:$location_id,type:$type) 
  }
`
export const GET_FILE_URL_DX = gql`
mutation ($file_name: String,$expiry:String) {
  getDropBoxFileLink(file_name: $file_name,expiry:$expiry) 
}
`
export const GET_DX_UPLOADER = gql`
mutation  { getDxUploader }
`
export const CHECK_SCHOOL_PROFILE_COMPLETED = gql`
  mutation
  checkSchoolProfile(
    $location:ID!
   ){
    checkSchoolProfile (
      location: $location
    )  
  }
`

export const TRANSFER_STUDENTS_PROGRAMS = gql`
  mutation
  transferStudentsProgram(
    $program_id:ID
    $students:[ID]
  ){
    transferStudentsProgram(
      program_id:$program_id
      students:$students
    ){
       status
    }
  }
`
export const MANAGER_LOCATION_WITH_TIMEZONE = gql`
query ($id:ID!){
  user(id:$id) {
    id
    fname
    managerlocations{
      id
      name
      billing
      color_code
      timezone{
        id
        name
        value
      }
    }
  }
}
`
export const EXPORT_STUDENT_ROSTER = gql`
  mutation
  exportStudentRoster(
    $location_id:ID!
    $emails:[String]
  ){
    exportStudentRoster(
      location_id:$location_id
      emails:$emails
    ) 
  }
`
export const CHECK_IS_STUDENT_CHECKIN = gql`
  mutation
  checkIsStudentCheckedin(
    $id:ID
    $date:String
  ){
    checkIsStudentCheckedin(
      id:$id
      date:$date
      
    ) 
  }
`
export const GET_ADMIN_ROLE_USER_LIST = gql`
mutation {
  getAdminsList
  {
    id
    email
    fname
    lname
    middle_name
    avatar
  }
  
}
`
export const GET_STUDENT_CAMERAS_USERS_TAG_PROGRAM = gql`
mutation($students:[ID]){
  getStudentCamerasUserTagProgram(students:$students){
        id
        cameras{
        id
        name
        color_code
        }
        location{
          id 
          name 
          billing 
        }
        users{
          id 
          fname  
          lname  
          middle_name   
          email 
          avatar
          pivot{
          black_list
          }
        }
        program{
          id 
          name 
          color_code 
        }
        tags{
        id
        name
        }
  }
}
`

export const GET_STUDENT_CAMERAS = gql`
mutation($location:ID!){
  newStudentsByLocation(location:$location){
        id
        cameras{
        id
        name
        color_code
        }
  }
}
`
export const GET_STUDENT_PHOTOS = gql`
mutation($student:ID){
  getStudentPhotos(student:$student)
}
`

export const GET_STUDENTS_LOCATION = gql`
mutation($location:ID!){
  newStudentsByLocation(location:$location){
        id
        fname
        lname
        image
        status
        type
        program{
          id 
          name 
          color_code 
          }
  }
}
`
export const CREATE_STUDENT_PORTFOLIO = gql`
mutation($id:ID,$location:ID!,$student:ID,$start_date:String,$end_date:String){
  createStudentPortfolio(id:$id,location:$location,student:$student,start_date:$start_date,end_date:$end_date){
       status
       message
  }
}
`
export const GET_ALL_STUDENT_PORTFOLIOS = gql`
mutation($location:ID!){
  getAllStudentPortfolios(location:$location){
      id
      status
      start_date
      end_date
      created_at
      student{
        id
        fname
        middle_name
        lname
        image
      }
      section{
        id
        name
        description
      }
  }
}
`
export const GET_ALL_USER_STUDENT_PORTFOLIOS = gql`
mutation($id:ID){
  getAllUserStudentPortfolio(id:$id){
      id
      status
      start_date
      end_date
      created_at
      student{
        id
        fname
        middle_name
        lname
        image
      }
      section{
        id
        name
        description
      }
  }
}
`
export const GET_SINGLE_STUDENT_PORTFOLIO = gql`
mutation($id:ID){
  getSingleStudentPortfolio(id:$id)
}
`
export const CREATE_PORTFOLIO_SECTION = gql`
mutation($id:ID){
  createPortfolioSection(id:$id){
    status
    message
  }
}
`
export const DETACH_ACTIVITY_FROM_PORTFOLIO = gql`
mutation($activity:ID,$section:ID){
  detachActivity(activity:$activity,section:$section){
    status
    message
  }
}
`
export const REMOVE_PORTFOLIO_SECTION = gql`
mutation($id:ID){
  removePortfolioSection(id:$id){
    status
    message
  }
}
`
export const PUBLISH_PORTFOLIO = gql`
mutation($id:ID){
  publishPortfolio(id:$id){
    status
    message
  }
}
`
export const DELETE_PORTFOLIO = gql`
mutation($id:ID){
  deleteStudentPortfolio(id:$id){
    status
    message
  }
}
`


export const Add_ACTIVITY_IN_PORTFOLIO_SECTION = gql`
mutation($id:ID,$activity:ID){
  addActivityInPortfolioSection(id:$id,activity:$activity){
    status
    message
  }
}
`

export const UPDATE_PORTFOLIO_SECTION = gql`
mutation($id:ID,$name:String,$description:String){
  updatePortfolioSection(id:$id,name:$name,description:$description){
    status
    message
  }
}
`
export const UPDATE_PORTFOLIO_DATE = gql`
mutation($id:ID,$start_date:String,$end_date:String){
  updatePortfolioDate(id:$id,start_date:$start_date,end_date:$end_date){
    status
    message
  }
}
`

export const GET_STUDENT_TAGS = gql`
mutation($location:ID!){
  newStudentsByLocation(location:$location){
        id
        tags{
        id
        name
        }
  }
}
`
export const SHARE_FORM_WITH_PARENTS = gql`
mutation($id:[ID],$form:ID){
  shareFormWithParents(id:$id,form:$form){
       status
  }
}
`
export const GET_SHARED_FORMS_STUDENTS = gql`
mutation($id:ID){
  getStudentSharedForm(id:$id){
    id
    student_id
    form_id
    user_id
    status
    student
    {
      id
      fname
      lname
      middle_name
      image
    }
  }
}
`

export const GET_STUDENT_CONTACTS = gql`
mutation($id:[ID]){
  getStudentContacts(id:$id){
    id 
    fname  
    lname  
    middle_name   
    avatar

  }
}
`
export const DELETE_FILE = gql`
mutation($id:ID){
  deleteFile(id:$id){
    status

  }
}
`
export const NEW_ALL_STUDENTS_BY_LOCATION = gql`
mutation($location:ID!){
  newStudentsByLocation(location:$location){
   id 
   fname 
   lname 
   middle_name  
   nick_name
   full_name
   dob
   image  
   status  
   type
   users{
    id 
    fname  
    lname  
    middle_name   
    email 
    avatar
    pivot{
    black_list
    }
   }
   program{
    id 
    name 
    color_code 
    }
   location{
    id 
    name 
    billing 
   }
  }
}
`
export const NEW_ALL_STUDENTS_BY_LOCATION2 = gql`
mutation($location:ID!,$status:[String],$filterBy:String,$searchBy:String){
  newStudentsByLocation2(location:$location,status:$status,filterBy:$filterBy,searchBy:$searchBy)
}
`
export const NEW_ALL_USER_LIST_BY_LOCATION = gql`
mutation($location:ID!){
  newUsersListByLocation (location:$location){
    id
    fname
    lname
    middle_name
    full_name
    username
    email
    phone
    phone_type
    phone2_type
    phone2
    email_confirmed
    status
    pending
    invited
    invite_expire
    emergency_contact
    avatar
    check_in_pin
    last_login_time
    isset_password
    locations{
        id
        name
        billing
      }
    students{
    id
    fname
    lname
    image
    program_id
    }
    cameras{
    id
    name
    color_code
    }
  }
}
`
export const GET_USER_CAMERAS_STUDENT = gql`
mutation($users:[ID],$location:ID!){
  getUsersCamerasStudents (users:$users,location:$location)
}
`
export const SHARE_FILE_WITH_STUDENT = gql`
mutation($id:ID,$ids:[ID]){
  shareFileWithParents (id:$id,ids:$ids){
    status
    message
  }
}
`
export const SHARE_FILE_WITH_TEAM = gql`
mutation($id:ID,$ids:[ID]){
  shareFileWithTeam (id:$id,ids:$ids){
    status
    message
  }
}
`

export const NEW_ALL_USER_LIST_BY_LOCATION2 = gql`
mutation($location:ID!,$statusBy:String,$filterBy:String,$searchBy:String,$userIds:[ID]){
  newUsersListByLocation2 (location:$location,statusBy:$statusBy,filterBy:$filterBy,searchBy:$searchBy,userIds:$userIds)
  # {
    # id
    # avatar
    # full_name
    # status
    # pending
    # invited
    # invite_expire
    # isset_password

    # id
    # fname
    # lname
    # middle_name
    # avatar
    # full_name
    # username
    # email
    # phone
    # phone_type
    # phone2_type
    # phone2
    # status
    # pending
    # invited
    # invite_expire
    # check_in_pin
    # last_login_time
    # isset_password
  # }
}
`
export const SINGLE_LOCATION_CAMERAS = gql`
query ($id:ID!){
  location(id:$id) {
    id
    name
    color_code
    cameras{
    id
    name
    code
    color_code
    camera_id
    groups{
      id
      name
    }
    location_setting{
      id
      name
      location_camera_setting{
        id
        key
        value
      }
    }
    location_id
    status
    order
    location{
      name
      id
      schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }
    }
    schedule{
        id
        name
        scheduledates{
            id
            day
            start_time
            end_time
            created_at
            updated_at
        }
    }
    camera_setting{
        id
        key
        value
    }
    billing
    timezone{
      id
      value
    }
    groups{
      id
      name
    }
  }
}
`
export const GET_STUDENT_ACCOUNT_DETAILS = gql`
  mutation ($id:ID!){
    getStudentAccountDetails(id:$id) 
  }
`
export const GET_STUDENT_PAYERS = gql`
mutation($id:ID) {
  getStudentPayers(
    id:  $id
  )
}
`
export const SAVE_STUDENT_PAYMENT_LOG = gql`
  mutation
  saveStudentPaymentLog(
    $payer:PayerInput
    $date:String
    $amount:String
    $method:String
    $student:ID
    $invoices:String
    $credits:String
   ){
    saveStudentPaymentLog (
      payer: $payer
      date: $date
      amount: $amount
      method: $method
      student:$student
      invoices: $invoices
      credits:$credits

    )
    {
      status
    }
  }
`
export const SAVE_STUDENT_CREDIT_LOG = gql`
  mutation
  saveStudentCreditLog(
    $date:String
    $amount:String
    $reason:String
    $student:ID
    $invoices:String
    $credits:String
   ){
    saveStudentCreditLog (
      date: $date
      amount: $amount
      reason: $reason
      student:$student
      invoices: $invoices
      credits:$credits
    )
    {
      status
    }
  }
`
export const GET_USER_ALL_BILLING_DETAILS = gql`
mutation {getUserAllBillingDetails}
`

export const SAVE_BILLING_PLAN = gql`
  mutation
  saveBillingPlan(
    $date:String
    $amount:String
    $invoice_without_payer:[InvoiceInput]
    $invoice_with_payer:[InvoiceWithPayerInput]
    $students:[ID]
    $days:String
    $name:String
    $period:String
   ){
    saveBillingPlan (
      date: $date
      amount: $amount
      invoice_without_payer: $invoice_without_payer
      invoice_with_payer:$invoice_with_payer
      students:$students
      days: $days
      name: $name
      period:$period
    )
    {
      status
    }
  }
`
export const GET_STUDENT_NEXT_INVOICES = gql`
  mutation ($id:ID!){
    getStudentNextInvoices(id:$id) 
  }
`
export const GET_SINGLE_INVOICE = gql`
mutation ($id:ID!){
  getSingleInvoice(id:$id) 
}
`
export const SAVE_ADJUSTMENT_CHARGE = gql`
  mutation
  saveAdjustmentCharge(
    $id:ID!,
    $amount:String,
    $reason:String,
    $note:String,
    $payments:String
   ){
    saveAdjustmentCharge (
      id: $id
      amount:$amount
      reason:$reason
      note:$note
      payments:$payments
    )
     
  }
`
export const UNAPPLY_TRANSECTION = gql`
  mutation
  saveUnapplyTransection(
    $id:ID!,
 
   ){
    saveUnapplyTransection (
      id: $id
   
    )
     
  }
`
export const SAVE_VOID_INVOICE = gql`
  mutation
  saveVoidInvoice(
    $id:ID!,
    $reason:String
    $note:String
 
   ){
    saveVoidInvoice (
      id: $id
      reason:$reason
      note:$note
   
    )
     
  }
`
export const SAVE_VOID_PAYMENT = gql`
  mutation
  saveVoidPayment(
    $id:ID!,
    $reason:String
    $note:String
 
   ){
    saveVoidPayment (
      id: $id
      reason:$reason
      note:$note
   
    )
     
  }
`
export const SAVE_REFUND_PAYMENT = gql`
  mutation
  saveRefundPayment(
    $id:ID!,
    $reason:String
    $note:String
    $refund:String
    $method:String
 
   ){
    saveRefundPayment (
      id: $id
      reason:$reason
      note:$note
      refund:$refund
      method:$method   
    )
     
  }
`
export const GET_SINGLE_PAYMENT_DETAILS = gql`
mutation ($id:ID!){
  getSinglePaymentDetails(id:$id) 
}
`
export const EDIT_STUDENT_PAYMENT_LOG = gql`
  mutation
  editStudentPaymentLog(
    $id:ID
    $payer:PayerInput
    $date:String
    $amount:String
    $method:String
    $student:ID
    $invoices:String
    $credits:String
   ){
    editStudentPaymentLog (
      id:$id
      payer: $payer
      date: $date
      amount: $amount
      method: $method
      student:$student
      invoices: $invoices
      credits:$credits

    )
    {
      status
    }
  }
`
export const EDIT_STUDENT_CREDIT_LOG = gql`
  mutation
  editStudentCreditLog(
    $id:ID
   
    $date:String
    $amount:String
    $reason:String
    $student:ID
    $invoices:String
    $credits:String
   ){
    editStudentCreditLog (
      id:$id
      date: $date
      amount: $amount
      reason: $reason
      student:$student
      invoices: $invoices
      credits:$credits

    )
    {
      status
    }
  }
`
export const GET_STUDENT_BILL_PLANS = gql`
  mutation ($id:ID!){
    getStudentBillPlans(id:$id){
       student
       plans
    } 
  }
`
export const GET_CUSTOM_EMAIL_SETTING = gql`
  mutation
  getCustomEmailSetting(
    $id:ID
  ){
    getCustomEmailSetting (
      id:$id
    ) {
        id
        key
        value
        object_id
    }
  }
`

export const SAVE_CUSTOM_EMAIL_SETTING = gql`
  mutation
  saveCustomEmailSetting(
    $subject:String,
    $message:String,
    $id:ID
  ){
    saveCustomEmailSetting (
      subject: $subject
      message: $message
      id:$id
    ) {
      status
      message
      color
    }
  }
`
export const SEND_CUSTOM_EMAIL_FROM_SETTING = gql`
  mutation
  sendCustomEmailFromSetting(
    $subject:String,
    $message:String,
    $id:ID
  ){
    sendCustomEmailFromSetting (
      subject: $subject
      message: $message
      id:$id
    ) {
      status
      message
      color
    }
  }
`
export const SEND_CUSTOM_EMAIL_TO_USERS = gql`
  mutation
  sendCustomEmailToUsers(
    $subject:String,
    $message:String,
    $delete_tags:Boolean,
    $users:[ID]
  ){
    sendCustomEmailToUsers (
      subject: $subject
      message: $message
      delete_tags:$delete_tags
      users:$users
    ) {
      status
      message
      color
    }
  }
`


export const REMOVE_INVOICE_ITEM = gql`
  mutation
  removeInvoiceItem(
    $id:ID!
  ){
    removeInvoiceItem (
      id:$id
    ) {
      status
      message
      color
    }
  }
`
export const GET_PRESET_ITEMS = gql`
  mutation{
    getInvoicePresetItems 
  }
`
export const CREATE_PRESET_ITEM = gql`
  mutation
  createPresetItem(
    $name:String,
    $amount:String
  ){
    createPresetItem (
      name: $name
      amount: $amount
    ) {
      status
       
    }
  }
`
export const UPDATE_PRESET_ITEM = gql`
  mutation
  updatePresetItem(
    $id: ID,
    $name:String,
    $amount:String
  ){
    updatePresetItem (
      id:$id
      name: $name
      amount: $amount
    ) {
      status
       
    }
  }
`
export const DELETE_PRESET_ITEM = gql`
  mutation
  deletePresetItem(
    $id: ID,
  
  ){
    deletePresetItem (
      id:$id
     
    ) {
      status
       
    }
  }
`
export const PREVIEW_LOCATION_INVITE = gql`
  mutation($location:ID!){
    previewLocationInvite(location:$location)
  }
`
export const CREATE_BILLING_PROGRAM = gql`
mutation
createBillingProgram($name: String!, $location_id:String!, $color_code:String ,$start_date:String ,$end_date:String,$rooms:[ID]){
  createBillingProgram ( 
    name: $name,
    color_code:$color_code
    location_id: $location_id
    start_date: $start_date
    end_date: $end_date
    rooms:$rooms
   ) {
    status
    message
    color
  }
}
`
export const UPDATE_BILLING_PROGRAM = gql`
mutation
updateBillingProgram($id: ID!,$name: String!, $location_id:String!, $color_code:String ,$start_date:String ,$end_date:String,$rooms:[ID]){
  updateBillingProgram (
    id:$id  
    name: $name,
    color_code:$color_code
    location_id: $location_id
    start_date: $start_date
    end_date: $end_date
    rooms:$rooms
    ) {
    status
    message
    color
  }
}
`
export const REMOVE_BILLING_PROGRAM = gql`
mutation($id:ID!) {
  deleteBillingProgram(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const GET_BILLING_PROGRAM_BY_LOCATION = gql`
  mutation ($location_id:ID!){
    getLocationBillingPrograms(location_id:$location_id){
       id
       name
       color_code
       start_date
       end_date
       rooms{
        id
        name
        color_code
       }
    }
  }
`

export const EDIT_STUDENT_ROOMS = gql`
mutation
editStudentRooms($id:ID,$homeRoom:ID,$otherRooms:[ID]){
  editStudentRooms ( 
    id: $id,
    homeRoom:$homeRoom
    otherRooms: $otherRooms
    
   ) {
    status
    
  }
}
`
export const GENERATE_STUDENT_BALANCE_REPORT = gql`
mutation
generateStudentBalanceReport($start_date:String, $end_date:String,$location:ID!){
  generateStudentBalanceReport ( 
    start_date:$start_date
    end_date: $end_date
    location:$location
    
   ) 
}
`
export const GET_BILLING_PROGRAM_BY_LOCATION_DROPDOWN = gql`
  mutation ($location_id:ID!){
    getLocationBillingPrograms(location_id:$location_id){
       id
       name
    }
  }
`
export const GENERATE_STUDENT_TRANSECTION_REPORT = gql`
mutation
generateStudentTransectionReport($start_date:String, $end_date:String,$location:ID!,$students:[ID]){
  generateStudentTransectionReport ( 
    start_date:$start_date
    end_date: $end_date
    location:$location
    students:$students
    
   ) 
}
`
export const GENERATE_STUDENT_INVOICE_REPORT = gql`
mutation
generateStudentInvoiceReport($start_date:String, $end_date:String,$location:ID!,$students:[ID],$invoice_status:String){
  generateStudentInvoiceReport ( 
    start_date:$start_date
    end_date: $end_date
    location:$location
    students:$students
    invoice_status:$invoice_status
    
   ) 
}
`

export const GET_ALL_STUDENT_FOR_ATTENDANCE = gql`
  mutation ($date: String,$location:ID!,$program:ID){
    getAllStudentForAttendance(date:$date,location:$location,program:$program)  
  }
`
export const GENERATE_STUDENT_PAYMENT_REPORT = gql`
mutation 
generateStudentPaymentReport($start_date:String, $end_date:String,$location:ID!,$students:[ID],$invoice_status:String){
  generateStudentPaymentReport ( 
    start_date:$start_date
    end_date: $end_date
    location:$location
    students:$students
    invoice_status:$invoice_status
    
   ) 
}
`
export const GET_TIMECLOCK_HISTORY = gql`
  mutation ($location:ID!){
    getTimeClockHistory(location:$location)  
  }
`
export const GET_ALL_STAFF_FOR_ATTENDANCE = gql`
  mutation ($date: String,$location:ID!,$role:ID){
    getAllStaffForAttendance(date:$date,location:$location,role:$role)  {
          id
          fname
          lname
          checkedin_program{
            id
            name
            color_code
          }
          avatar
          roles{
            id 
            name
          }
          programs{
            id
            name

          }
    }
  }
`

export const GENERATE_STUDENT_SUMMARY_REPORT = gql`
mutation
generateStudentBillingReport($start_date:String, $end_date:String,$location:ID!,$students:[ID]){
  generateStudentBillingReport ( 
    start_date:$start_date
    end_date: $end_date
    location:$location
    students:$students
 
    
   ) 
}
`
export const SAVE_PAUSE_PLAN = gql`
mutation
savePausePlan($id:ID, $date:String){
  savePausePlan ( 
    id:$id
    date: $date
 
   ){
    status
   } 
}
`
export const SAVE_UNPAUSE_PLAN = gql`
mutation
saveUnPausePlan($id:ID ){
  saveUnPausePlan ( 
    id:$id
   ){
    status
   } 
}
`
export const SAVE_DEACTIVATE_PLAN = gql`
mutation
saveDeactivatePlan($id:ID, $date:String){
  saveDeactivatePlan ( 
    id:$id
    date: $date
 
   ){
    status
   } 
}
`
export const GET_BILLING_PLAN_STUDENTS = gql`
  mutation ($location:ID!,$program:ID){
    getBillingPlanStudent(location:$location,program:$program)  
  }
`
export const GET_BILLING_STUDENTS_OVERVIEW = gql`
  mutation ($location:ID!,$program:ID){
    getBillingStudentOverview(location:$location,program:$program)  
  }
`
export const SEND_BILLING_INVITE = gql`
mutation
sendBillingInvite($id:ID){
  sendBillingInvite ( 
    id:$id
   ){
    status
   } 
}
`
export const VIEW_BILLING_INVITE = gql`
mutation
viewBillingInvite($id:ID){
  viewBillingInvite ( 
    id:$id
   ) 
}
`
export const GET_ROOM_ACTIVITIES = gql`
mutation
getRoomActivities(
    $date: String,
    $id:ID,
    $staffOnly:Boolean
    $to:String
    $from:String
    $type:String
  )
  {
    getRoomActivities (
    date: $date
    id:$id
    staffOnly:$staffOnly
    to:$to
    from:$from
    type:$type
    ){
    data
    date
    end
    }
}
`
export const APPROVE_ROOM_ACTIVITIES = gql`
mutation
approveRoomActivities(
    $id:[ID]
  )
  {
    approveRoomActivities (
 
    id:$id
 
    ){
     status
    }
}
`
export const UPDATE_BILLING_PLAN = gql`
  mutation
  updateBillingPlan(
    $id:ID
    $amount:String
    $invoice:[InvoiceInput]
   
   ){
    updateBillingPlan (
      id: $id
      amount: $amount
      invoice: $invoice
     
    )
    {
      status
    }
  }
`

export const DOWNLOAD_STUDENT_ROSTER = gql`
  mutation
  downloadStudentRoster(
    $location_id:ID!
    
  ){
    downloadStudentRoster(
      location_id:$location_id
       
    ) 
  }
`
export const UPDATE_STUDENTS_STATUS = gql`
  mutation
  updateStudentsStatus(
    $status:String
    $students:[ID]
  ){
    updateStudentsStatus(
      status:$status
      students:$students
    ){
       status
    }
  }
`
export const GET_ALL_ALLERGY = gql` 
query allergies ($location_id:ID!) {
  allergies(location_id:$location_id) {
    id
    name
    student_count
 
  }
}
`
export const DELETE_ALLERGY = gql`
mutation($id:ID!) {
  deleteAllergy(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const CREATE_ALLERGY = gql`
mutation($name:String,$type:String,$location:ID!) {
  addNewAllergy(
    name: $name
    type: $type
    location:$location

   )
  {
     status
     color
     message
  }
}
`
export const UPDATE_ALLERGY = gql`
mutation($id:ID,$name:String) {
  updateAllergy(
    id:$id
    name: $name
   )
  {
     status
     color
     message
  }
}
`
export const GET_ALL_MEDICATION = gql` 
query medications ($location_id:ID!) {
  medications(location_id:$location_id) {
    id
    name
    student_count
 
  }
}
`
export const DELETE_MEDICATION = gql`
mutation($id:ID!) {
  deleteMedication(
    id: $id
  )
  {
    message
    status
    color
  }
}
`
export const CREATE_MEDICATION = gql`
mutation($name:String,$type:String,$location:ID!) {
  addNewMedication(
    name: $name
    type: $type
    location:$location

   )
  {
     status
     color
     message
  }
}
`
export const UPDATE_MEDICATION = gql`
mutation($id:ID,$name:String) {
  updateMedication(
    id:$id
    name: $name
   )
  {
     status
     color
     message
  }
}
`
export const AUTO_CREATE_ALLERGY = gql`
mutation($location:ID!) {
  autoCreateAllergies(
 
    location:$location

   )
  {
     status
     color
     message
  }
}
`
export const AUTO_CREATE_MEDICATIONS = gql`
mutation($location:ID!) {
  autoCreateMedications(
 
    location:$location

   )
  {
     status
     color
     message
  }
}
`
export const MAKE_STUDENT_PRIMARY_PAYER = gql`
mutation($student_id:ID,$user_id:ID) {
  makeStudentPrimaryPayer(
 
    student_id:$student_id
    user_id:$user_id

   )
  {
     status
     color
     message
  }
}
`
export const REMOVE_STUDENT_PAYER = gql`
mutation($student_id:ID,$user_id:ID) {
  removeStudentPayer(
 
    student_id:$student_id
    user_id:$user_id

   )
  {
     status
     color
     message
  }
}
`
export const REMOVE_STUDENT_PAYER_AND_MAKE_PRIMARY = gql`
mutation($student_id:ID,$user_id:ID,$primary_id:ID) {
  removePayerAndMakePrimary(
 
    student_id:$student_id
    user_id:$user_id
    primary_id:$primary_id

   )
  {
     status
     color
     message
  }
}
`
export const GET_ALL_STUDENT_PAYER_LIST = gql`
mutation($id:ID) {
  getAllStudentPayers(
    id:  $id
  )
}
`
export const ADD_STUDENT_NEW_PAYERS = gql`
mutation($student_id:ID,$user_ids:[ID]) {
  addStudentNewPayers(
 
    student_id:$student_id
    user_ids:$user_ids

   )
  {
     status
     color
     message
  }
}
`
export const CREATE_BILLING_AGENCY = gql`
mutation($data:BillingAgency) {
  createBillingAgency(
 
    data:$data
 

   )
  {
     status
      
  }
}
`
export const UPDATE_BILLING_AGENCY = gql`
mutation($data:BillingAgency) {
  updateBillingAgency(
 
    data:$data
 

   )
  {
     status
      
  }
}
`
export const GET_BILLING_AGENCY_LIST = gql`
mutation($id:ID) {
  getBillingAgencyList(id:$id)
}
`
export const GET_AGENCY_ACCOUNT_DETAILS = gql`
  mutation ($id:ID!){
    getAgencyAccountDetails(id:$id) 
  }
`
export const GET_BILLING_AGENCY = gql`
  mutation ($id:ID!){
    getBillingAgency(id:$id) 
  }
`
export const GET_AGENCY_STUDENTS = gql`
  mutation ($id:ID!){
    getAgencyStudents(id:$id) 
  }
`
export const UPDATE_AGENCY_STUDENTS = gql`
mutation($id:ID,$students:[ID]) {
  updateAgencyStudents(
 
    id:$id
    students:$students
 

   )
  {
     status
      
  }
}
`
export const GET_AGENCY_STUDENT_LIST = gql`
  mutation ($id:ID!){
    getAgencyStudentList(id:$id) 
  }
`
export const REMOVE_AGENCY_STUDENT = gql`
mutation($student_id:ID,$agencyId:ID) {
  removeAgencyStudent(
 
    student_id:$studentId
    agencyId:$agencyId
 

   )
  {
     status
      
  }
}
`
export const SAVE_BILL_TRANSFER_INVOICE = gql`
  mutation
  saveBillTransferInvoice(
    $id:ID!,
    $reason:String
    $note:String
    $date:String
   ){
    saveBillTransferInvoice (
      id: $id
      reason:$reason
      note:$note
      date:$date
    ){
      status
    }
     
  }
`
export const SAVE_WAIVE_INVOICE = gql`
  mutation
  saveWaiveInvoice(
    $id:ID!,
    $reason:String
    $note:String
  
   ){
    saveWaiveInvoice (
      id: $id
      reason:$reason
      note:$note
      
    ){
      status
    }
     
  }
`
export const GET_AGENCY_NEXT_INVOICES = gql`
  mutation ($id:ID!){
    getAgencyNextInvoices(id:$id) 
  }
`
export const ADD_NEW_ITEM_TO_INVOICE = gql`
  mutation
  addNewItemToInvoice(
    $id:ID,
    $name:String,
    $detail:String,
    $original_amount: String,
    $amount: String,
    $discount:String,
    $discount_type: String
   ){
    addNewItemToInvoice (
      id:$id,
      name:$name,
      detail:$detail,
      original_amount: $original_amount,
      amount: $amount,
      discount:$discount,
      discount_type: $discount_type
      
    ){
      status
    }
     
  }
`
export const GET_INCIDENT_SHARED_FILE_HISTORY = gql`
mutation ($file_name: String) {
  getIncidentFileHistory(file_name: $file_name) 
}
`
export const GET_SCHOOL_LOGO = gql`
query getSchoolProfile($location:ID!){
  getSchoolProfile(location:$location){
    school_name
    school_logo
  }
}
`
export const CREATE_VARIABLE_CHARGES = gql`
  mutation
  createVariableCharges(
    $category:String,
    $details:String,
    $start_time:String,
    $end_time: String,
    $amount: String,
    $max_amount:String,
    $interval: String
    $days: String
    $programs: [ID]
    $location:ID!
   ){
    createVariableCharges (
      category:$category,
      details:$details,
      start_time:$start_time,
      end_time: $end_time,
      amount: $amount,
      max_amount:$max_amount,
      interval: $interval
      days:$days
      programs:$programs
      location:$location
      
    ){
      status
    }
     
  }
`
export const UPDATE_VARIABLE_CHARGES = gql`
  mutation
  updateVariableCharges(
    $id:ID,
    $category:String,
    $details:String,
    $start_time:String,
    $end_time: String,
    $amount: String,
    $max_amount:String,
    $interval: String
    $days: String
    $programs: [ID]
    $location:ID!
   ){
    updateVariableCharges (
      id:$id
      category:$category,
      details:$details,
      start_time:$start_time,
      end_time: $end_time,
      amount: $amount,
      max_amount:$max_amount,
      interval: $interval
      days:$days
      programs:$programs
      location:$location
      
    ){
      status
    }
     
  }
`
export const DELETE_VARIABLE_CHARGES = gql`
  mutation
  deleteVariableCharges(
    $id:ID 
   ){
    deleteVariableCharges (
      id:$id
    ){
      status
    }
     
  }
`
export const GET_VARIABLE_CHARGES = gql`
  mutation ($location:ID!){
    getVariableCharges(location:$location) 
  }
`
export const APPLY_VARIABLE_CHARGES_TO_STUDENTS = gql`
  mutation ($charges:[ID],$start_date:String,$end_date:String){
    applyVariableChargesToStudents(charges:$charges,start_date:$start_date,end_date:$end_date) 
  }
`
export const SAVE_STUDENT_ATTENDANCE_INVOICE = gql`
  mutation
  saveStudentAttendanceInvoice(
    $date:String
    $from_date:String
    $to_date:String
    $charges:String
   
   ){
    saveStudentAttendanceInvoice (
      date: $date
      from_date: $from_date
      to_date: $to_date
      charges: $charges
    )
    {
      status
    }
  }
`
export const GET_STUDENT_PAYERS_AND_NON_PAYERS = gql`
mutation($id:ID) {
  getStudentPayersAndNonPayers(
    id:  $id
  )
}
`
export const GET_PAYMENT_LIST = gql`
mutation($location_id:ID!,$start:String,$end:String) {
  getPaymentsList(
    location_id:  $location_id
    start: $start
    end:$end
  )
}
`
export const GET_BILLING_OVERVIEW = gql`
mutation($location_id:ID!,$filter:String) {
  getBillingOverviewDetails(
    location_id:  $location_id
    filter: $filter
  )
}
`
export const CHECK_SETUP_FORM = gql`
mutation {checkSetupForm}
`
export const GET_LEAD_STUDENTS = gql`
mutation($location:ID!) {
  getLeadStudents(
    location:  $location
  ){
    id
    fname
    lname
    middle_name
    image
  }
}
`
export const GET_SCHOOL_FOOD_MENU = gql`
query($location:ID!) {
  getSchoolFoodMenu(
    location:  $location
  ){
    status data error
  }
}
`
export const GET_WIDGET_FOOD_MENU = gql`
query($location:ID!,$week:String,$week_index:String) {
  getWidgetFoodMenu(
    location:  $location,
    week: $week
    week_index:$week_index
  ){
    status data error rotate weeks week
  }
}
`
export const GET_CURRENT_USER_LOCATION = gql` query CurrentUsersQuery {
  me {
    id
    locations{
       id
    }
  }
}
`
export const UPDATE_SIDEBAR_PERMISSIONS = gql`
mutation($name:String,$roles:[String]) {
  updateSidebarPermission(
    name: $name
    roles:$roles
  ){
     status
  }
}
`
export const GET_STUDENT_BY_PROGRAMS_AND_TAGS = gql`
  mutation ($program_id:[ID],$tags:[ID]){
    programsAndTagStudent(program_id:$program_id,tags:$tags) {
      id
      fname
      lname
      middle_name
      image
      users{
        id
        fname
        lname
        phone
        avatar
        phone
        phone_verified
        pivot{
         alert
         black_list
        }
      }
    }
  }
`
export const GET_STUDENT_BY_IDS_FOR_MESSAGE = gql`
  mutation ($student_id:[ID]){
    getStudentByIdsForMessage(student_id:$student_id) {
      id
      fname
      lname
      middle_name
      image
      users{
        id
        fname
        lname
        phone
        avatar
        phone
        phone_verified
        pivot{
         alert
         black_list
        }
      }
    }
  }
`
export const STUDENT_PROFILE_FOR_CHAT = gql`
query ($id:ID!){
  student(id:$id) {
    id
    fname
    middle_name
    nick_name
    image
    dob
    lname
    status
    type
    gender 
    race 
    allergies {
      id 
      name
    }
    medications {
      id 
      name
    }
    ethnicity 
    enrollment_date
    graduation_date
    external_id
    tags{
     id
     name
    }
    billing_program{
        id
        name
        color_code
    }
    program{
        id
        name
        color_code
    }
    users{
        id
        fname
        lname
        middle_name
        email
        avatar
    }
    cameras{
        id
        name
        code
        color_code
        camera_id
    }
  }

}
`
export const MAKE_BLOG_ACTION = gql`
mutation($id:[ID],$type:String) {
  makeBlogAction(
    id: $id
    type:$type
  ){
     status
  }
}
`
export const MAKE_NEWSLETTER_ACTION = gql`
mutation($id:[ID],$type:String) {
  makeNewsletterAction(
    id: $id
    type:$type
  ){
     status
  }
}
`
export const GET_USER_FOR_CUSTOM_EMAIL = gql`
mutation($location:ID!,$day:String,$inactive:Boolean) {
  getUserForCustomEmail(
    location: $location
    day:$day
    inactive:$inactive
  ){
     id
     fname
     lname
     avatar
     email
     last_login_time
     tags{
      id
      name
     }
  }
}
`
export const SEND_CUSTOM_EMAIL_UTILITY = gql`
  mutation
  sendCustomEmailUtility(
    $subject:String,
    $message:String,
    $location:ID!,
    $users:[ID],
    $delete_tag:Boolean
  ){
    sendCustomEmailUtility (
      subject: $subject
      message: $message
      location:$location
      users:$users
      delete_tag:$delete_tag
    ) {
      status
      message
      color
    }
  }
`
export const SUBMIT_FORM = gql`
  mutation
  submitForm(
    $id:ID,
    $student:ID,
    $date:String,
    $data:[FormFieldsInput]
  ){
    submitForm (
      id:$id
      student:$student
      date:$date
      data:$data
    ) {
      status
      message
      color
    }
  }
`

export const GET_SINGLE_STUDENT_SUBMISSIONS = gql`
  mutation
  getSingleSubmissionDetail(
    $id:ID,
    $student:ID,
  ){
    getSingleSubmissionDetail(
      id:$id
      student:$student
    ) 
  }
`
export const GET_STUDENT_SUBMISSIONS = gql`
  mutation
  getStudentSubmissions(
    $form_id:ID,
    $student:ID,
  ){
    getStudentSubmissions (
      form_id:$form_id
      student:$student
    ) {
     id
     type
     value
     name
     required
     
    }
  }
`
export const CHECK_REQUEST_CHANGE_FORM = gql`
  mutation
  checkRequestChange(
    $id:ID,
    $student:ID,
  ){
    checkRequestChange (
      id:$id
      student:$student
    ) {
     change
     change_date
     notes
     
    }
  }
`

export const GET_USER_SHARED_FORMS = gql`
  mutation
  getUserSharedForm(
    $id:ID
  ){
    getUserSharedForm (
      id:$id
    ) 
  }
`
export const GET_USER_SHARED_FORMS_STUDENTS = gql`
  mutation
  getUserSharedFormStudent(
    $id:ID
  ){
    getUserSharedFormStudent (
      id:$id
    ) 
  }
`


export const GET_STAFF_RECIPIENT_FOR_MSG = gql`
mutation($programs:[ID]) {
  getStaffRecipientForMsg(
    programs: $programs
  ){
     id
     fname
     lname
     avatar
  }
}
`

export const UPDATE_BLOG_STATUS = gql`
  mutation
  updateBlogStatus(
    $id:ID
    $status:Boolean
  ){
    updateBlogStatus(
      id:$id
      status:$status
    ){
       status
    }
  }
`
export const MAKE_TAGS_ACTION = gql`
mutation($id:[ID],$type:String) {
  makeTagsAction(
    id: $id
    type:$type
  ){
     status
  }
}
`
export const UPLOAD_CAMERAS_LIST = gql`
  mutation
  uploadCamerasList(
    $file:Upload
    $location:ID!
  ){
    uploadCamerasList (file:$file,location:$location) {
       status
       cameras
       errors
    }
  }
`
export const SAVE_UPLOAD_CAMERAS_LIST = gql`
  mutation
  saveUploadCameraList(
     $cameras:String
  ){
    saveUploadCameraList (cameras:$cameras) {
       status
      
    }
  }
`
export const ADD_NEW_DEPLOYMENT_SERVER = gql`
  mutation{
    addNewDeploymentServer
  }
`
export const GET_DEPLOYMENT_SERVER_CONFIG = gql`
  mutation{
    getDeploymentServerConfig
  }
`
export const ADD_NEW_DEPLOYMENT_SERVER_CONFIG = gql`
  mutation($centers:AwsConfigCenter,$db:String){
    addNewDeploymentServerConfig(centers:$centers,db:$db)
  }
`
export const ADD_NEW_SERVER_DOMAIN = gql`
  mutation($domain:String,$status:Boolean,$confirm:Boolean){
    addNewServerDomain(domain:$domain,status:$status,confirm:$confirm)
  }
`
export const GET_SERVER_DOMAINS = gql`
  mutation{ 
  getServerDomains{
       id
       domain
       status
       cloud_front
  }
  }
`
export const GET_AWS_CENTER_USERS = gql`
  mutation($id:String!){
    getAwsCenterUsers(id:$id)
  }
`
export const DELETE_SERVER_DOMAINS = gql`
  mutation
  deleteServerDomain($id:ID)
  { 
    deleteServerDomain (id:$id) 
  }
`
export const MAKE_TINY_URL = gql`
mutation($url:String!) {
  makeTinyUrl(
    url: $url
  )
}
`
export const GET_ACTIVE_STUDENT = gql`
  mutation($location:ID!){ 
  getActiveStudents(location:$location){
      id
      fname
      lname
      image
  }
  }
`
export const GET_ACTIVE_STUDENTS_USERS = gql`
  mutation($students:[ID]){ 
  getActiveStudentsUsers(students:$students){
      id
      fname
      lname
      avatar
      phone_verified
  }
  }
`
export const SEND_NEWSLETTER_ACTION = gql`
  mutation($users:[ID],$type:String,$subject:String,$msg:String,$attachment:Boolean,$file:String,$id:ID,$location:ID!,$msg_users:String){ 
    sendNewsletterAction(users:$users,type:$type,subject:$subject,msg:$msg,attachment:$attachment,file:$file,id:$id,location:$location,msg_users:$msg_users) 
  }
`

export const GET_ACTIVE_STUDENTS_USERS_FOR_MESSAGE = gql`
  mutation($students:[ID]){ 
  getActiveStudentsUsersForMessage(students:$students) 
  }
`
export const CREATE_NEW_FILE = gql`
  mutation($location:ID!,$name:String,$date:String,$type:String,$sub_type:String,$visible:String,$description:String,$instructions:String,$key:String,$original:String,$students:[ID],$read:Boolean,$thumbnail:String,$required:Boolean){ 
  createNewFile(location:$location,name:$name,date:$date,type:$type,sub_type:$sub_type,visible:$visible,description:$description,instructions:$instructions,key:$key,original:$original,students:$students,read:$read,thumbnail:$thumbnail,required:$required) {

     status


  }
  }
`
export const GET_USERS_FILES_LIST = gql`
  mutation($id:ID,){ 
    getUserFilesList(id:$id)
  }
`
export const GET_TEAM_FORMS_LIST= gql`
mutation($id:ID,){ 
  getTeamSharedForms(id:$id)
}
`

export const SEND_FILE_ACTION = gql`
  mutation($users:[ID],$type:String,$subject:String,$msg:String,$attachment:Boolean,$file:String,$id:ID,$location:ID!){ 
    sharedFilesAction(users:$users,type:$type,subject:$subject,msg:$msg,attachment:$attachment,file:$file,id:$id,location:$location) 
  }
`
export const UPDATE_FILE = gql`
  mutation($location:ID!,$id:ID,$name:String,$date:String,$type:String,$sub_type:String,$visible:String,$description:String,$instructions:String,$students:[ID],$read:Boolean,$required:Boolean){ 
  updateFile(location:$location,id:$id,name:$name,date:$date,type:$type,sub_type:$sub_type,visible:$visible,description:$description,instructions:$instructions,students:$students,read:$read,required:$required) {

     status


  }
  }
`
export const CHECK_USER_READ_DOCUMENT = gql`
  mutation($id:ID,$file_id:ID){ 
    checkUserReadDocument(id:$id,file_id:$file_id) 
  }
`
export const SAVE_READ_DOCUMENT = gql`
  mutation($id:ID,$file_id:ID){ 
    saveReadDocument(id:$id,file_id:$file_id) {
      status
    }
  }
`


export const ADDED_FILE_ARCHIVE = gql`
  mutation($id:ID){ 
  fileAddedInArchive(id:$id) {
     status
  }
  }
`
export const SORT_FILES = gql`
  mutation($id:ID,$sort:String){ 
    sortFiles(id:$id,sort:$sort) {
      id
      name
      description
      instructions
      type
      visible
      expiry_date
      file_name
      file_path
      file_original
      archive
      created_at
  }
  }
`

export const GET_ALL_FILES = gql`
  mutation($location:ID!){ 
  getAllFiles(location:$location) 
  }
`
export const GET_SINGLE_FILE = gql`
  mutation($id:ID!){ 
    getSingleDocument(id:$id) 
  }
`

export const FILTER_ALL_FILES = gql`
  mutation($location:ID!,$type:String){ 
    filterFiles(location:$location,type:$type) 
  }
`

export const REQUEST_CHANGE_FORM = gql`
mutation
requestChangeForm(
   $id:ID,
   $student:ID
   $notes:String
   $date:String
){
  requestChangeForm(id:$id,student:$student,notes:$notes,date:$date) {
     status
    
  }
}
`
export const PUBLISHED_FILES = gql`
mutation
publishedFiles(
   $id:ID,
   $value:Boolean
){
  publishedFiles(id:$id,value:$value) {
     status
    
  }
}
`
export const SAVE_TEMP_PROCARE_STAFF = gql`
  mutation
  saveTempProcareStaff(
     $staff:String
  ){
    saveTempProcareStaff (staff:$staff) {
       status
      
    }
  }
`
export const SAVE_PROCARE_STAFF = gql`
  mutation
  saveProcareStaff(
     $staff:String
  ){
    saveProcareStaff (staff:$staff) {
       status
      
    }
  }
`
export const GET_SIGNLE_USER_DATA = gql`
  mutation singleUserDataById($id:ID){
    singleUserDataById (id:$id) 
  }
`
export const GET_USERS_LIST_ALERT_COUNT = gql`
  mutation getUserListAlertCount($location:ID!){
    getUserListAlertCount (location:$location) 
  }
`
export const PLAY_CAMERA_GRID_VIEW = gql`
  mutation playCameraGridView($id:[ID],$location:ID){
    playCameraGridView (id:$id,location:$location) 
  }
`
export const CREATE_THUMBNAIL = gql`
  mutation createThumbnail($link:String,$name:String,$key:String,$original_file:String){
    createThumbnail (link:$link,name:$name,key:$key,original_file:$original_file) 
  }
`
export const GET_USER_SIGNED_DOCUMENT = gql`
  mutation getUserSignedDocument($id:ID){
    getUserSignedDocument (id:$id) 
  }
`
export const GET_PDF_FORM_SUBMISSIONS = gql`
  mutation getPDFFormSubmissions($id:ID){
    getPDFFormSubmissions (id:$id) 
  }
`
export const SUBMIT_PDF_FORM = gql`
  mutation submitPDFForm($file:ID,$user:ID,$student:ID,$date:String,$filename:String,$filepath:String,$original:String){
  submitPDFForm (file:$file,user:$user,student:$student,date:$date,filename:$filename,filepath:$filepath,original:$original) {
      status
    }
  }
`
export const SUBMIT_PDF_FORM_STAFF = gql`
  mutation submitPDFFormStaff($file:ID,$user:ID,$date:String,$filename:String,$filepath:String,$original:String){
  submitPDFFormStaff (file:$file,user:$user,date:$date,filename:$filename,filepath:$filepath,original:$original) {
      status
    }
  }
`
export const APPROVED_PDF_FORM = gql`
  mutation approveSubmittedForm($id:ID,$value:Boolean){
    approveSubmittedForm (id:$id,value:$value) {
      status
    }
  }
`
export const REJECT_PDF_FORM = gql`
  mutation rejectSubmittedForm($id:ID){
    rejectSubmittedForm (id:$id) {
      status
    }
  }
`

export const ADD_PDF_FORM_IN_ARCHIVE = gql`
  mutation addPDFFormInArchive($id:ID){
    addPDFFormInArchive (id:$id) {
      status
    }
  }
`
export const CREATE_NEW_BUILDER_FORM = gql`
mutation ($url: String,$location:ID!,$name:String) {
  createNewBuilderForm(url: $url,location:$location,name:$name) {
      status
  }
}
`

export const GET_FORM_BUILDER_ENTRIES = gql`
mutation ($id:ID,$url:String) {
  getFormEntries(id:$id,url: $url) 
}
`
export const GET_FORM_BUILDER_FIELDS = gql`
mutation ($id:ID,$url:String) {
  getFormBuilderFields(id:$id,url: $url) 
}
`
export const SAVE_DASHBOARD_LAYOUT = gql`
mutation ($layout:String,$layouts:String) {
  saveDashboardLayout(layout:$layout,layouts: $layouts) 
}
`
export const GET_DASHBOARD_LAYOUT = gql`
mutation ($user_id:ID ) {
  getDashboardLayout(user_id:$user_id) 
}
`
export const CHECK_LEFT_ENTRIES = gql`
mutation ($id:ID,$url:String) {
  checkEntries(id:$id,url: $url) 
}
`
export const GET_FORM_BUILDER_FIELDS_DATABASE = gql`
mutation ($id:ID) {
  getFormBuilderFieldsFromDatabase(id:$id) 
}
`
export const GET_FORM_BUILDER_ENTRIES_DATABASE = gql`
mutation ($id:ID) {
  getFormBuilderEntriesFromDatabase(id:$id) 
}
`
export const GET_SINGLE_ENTRY_FORM_DATABASE = gql`
mutation ($id:ID,$entry_id:ID) {
  getSingleEntry(id:$id,entry_id:$entry_id) 
}
`
export const GET_FILE_CONTENT = gql`
mutation ($url:String) {
  getFileContent(url:$url) 
}
`
export const REFRESH_FORM_DATA = gql`
mutation ($location:ID!,$url:String) {
  refreshFormData(location:$location,url:$url) {
      status
  }
}
`
export const SAVE_CUSTOM_ACTIVITY = gql`
mutation
    saveCustomActivity(
        $date: String,
        $time: String,
        $note: String,
        $students:[ID]
        $staffOnly:Boolean
        $amount:String
      )
      {
        saveCustomActivity (
        date: $date
        time: $time
        note: $note
        students:$students
        staffOnly:$staffOnly
        amount:$amount
        ) 
      {
        status
      }
    } 
`
export const UPDATE_CUSTOM_ACTIVITY = gql`
mutation
    updateCustomActivity(
        $id:ID,
        $date: String,
        $time: String,
        $note: String,
        $students:[ID]
        $amount:String
      )
      {
        updateCustomActivity (
        id:$id  
        date: $date
        time: $time
        note: $note
        students:$students
        amount:$amount
        ) 
      {
        status
      }
    }
`
export const SIGN_UP_CUSTOMER = gql` 
mutation saveCustomer($data: String!){
  saveCustomer(
    data:$data
  )
}`
export const GET_DEMO_REQUESTS = gql`
mutation{
  getDemoRequests
}
`
export const DELETE_DEMO_REQUEST = gql`
mutation
deleteDemoRequest($id:ID){
    deleteDemoRequest (id:$id) 
}
`
export const SETUP_NEW_CENTER = gql` 
mutation setupNewCenter($data: String!,$request:ID!,$email:String){
  setupNewCenter(
    data:$data
    request:$request
    email:$email
  )
}`

export const CREATE_CUSTOMER_PAYMENT_SESSION = gql` 
mutation createCustomerPaymentSession($price_id: String!,$customer_id: String!){
  createCustomerPaymentSession(
    price_id:$price_id,
    customer_id:$customer_id
  )
}`
export const CHECK_VALID_CENTER_SETUP = gql` 
mutation checkValidCenterSetup($token: String!){
  checkValidCenterSetup(
    token:$token,
  ){
    status
  }
}`
export const ALL_TEAM_FILES_DROPDOWN = gql`query AllUsersQuery {
  getAllTeamList{
    id
    fname
    lname
    full_name
    status
    avatar
    invited
}
}
`
export const CREATE_UPDATE_CENTER_PLAN = gql` 
mutation createOrUpdateCenterPlan($id:ID,$data: String!){
  createOrUpdateCenterPlan(
    id:$id
    data:$data,
  ) 
}`
export const GET_CENTER_BILLING_PLANS = gql`
mutation{
  getCenterPlans
}
`
export const ATTACH_CENTER_PLAN = gql` 
mutation attachCenterPlan($id:String!,$locations: String!){
  attachCenterPlan(
    id:$id
    locations:$locations,
  ) 
}`
export const GET_AWS_CENTER_PLAN = gql`
mutation getAwsCenterPlan($id:String!){
  getAwsCenterPlan(id:$id)
}
`
export const GET_CENTER_BILLING_INVOICES = gql`
mutation{
  getCenterInvoices
}
`
export const GET_CENTER_BILLING_PAYMENTS = gql`
mutation{
  getCenterPayments
}
`

export const ADD_CENTER_CARD = gql`
mutation addCenterCard($token:String!,$center:String!){
  addCenterCard(token:$token,center:$center)
}
`
export const GET_AWS_CENTER_BILLING = gql`
mutation getAwsCenterBilling($center:String!){
  getAwsCenterBilling(center:$center)
}
`
export const SET_DEFAULT_AWS_CENTER_PAYMENT_METHOD = gql`
mutation setDefaultAwsCenterPaymentMethod($center:String!,$id:String!){
  setDefaultAwsCenterPaymentMethod(center:$center,id:$id)
}
`
export const CHARGE_CENTER_INVOICE = gql`
mutation chargeCenterInvoice($center:String!,$id:String!,$token:String){
  chargeCenterInvoice(center:$center,id:$id,token:$token)
}
`
export const SUBMIT_CENTER_INVOICE = gql`
mutation submitCenterInvoice($center:String!,$id:String!,$file:String,$details:String){
  submitCenterInvoice(center:$center,id:$id,file:$file,details:$details)
}
`
export const ADD_PAYMENT_TO_CENTER_INVOICE = gql`
mutation addPaymentToCenterInvoice($data:String!){
  addPaymentToCenterInvoice(data:$data)
}
`
export const APPROVE_CENTER_PAYMENT = gql`
mutation approveCenterPayment($id:ID!){
  approveCenterPayment(id:$id)
}
`
export const EXTEND_AWS_CENTER_TRAIL = gql`
mutation extendAwsCenterTrail($id:ID!,$days:String!){
  extendAwsCenterTrail(id:$id,days:$days)
}
`
export const GET_AWS_CENTER_LOCATIONS = gql`
mutation getAwsChildCenterLocations($id:String!){
  getAwsChildCenterLocations(id:$id)
}
`
export const CHECK_CENTER_BILLING = gql`
mutation checkCenterBilling($center:String!){
  checkCenterBilling(center:$center)
}
`
export const ROLES_KEY = 'userRoles'
export const APP_TOKEN = 'app-token'

